module.exports=[
  {
    "parcel_id": 9286800032,
    "latitude": 47.504073,
    "longitude": -122.36908,
    "building_number": 2615,
    "street": "S.W. 110th St.",
    "city": "Seattle",
    "zip": 98146,
    "address": "2615 S.W. 110th St., Seattle",
    "purchase_date": "3/29/05",
    "purchase_year": 2005,
    "purchase_amount": 30000,
    "assessed_value": 0,
    "purchase_amount_vs_assessment": "#DIV/0!",
    "sale_date": "5/2/05",
    "sale_amount": 125000
  },
  {
    "parcel_id": 7504000930,
    "latitude": 47.631142,
    "longitude": -122.06226,
    "building_number": 2421,
    "street": "Sahalee Drive W.",
    "city": "Sammamish",
    "zip": 98074,
    "address": "2421 Sahalee Drive W., Sammamish, WA 98074",
    "purchase_date": "3/20/06",
    "purchase_year": 2006,
    "purchase_amount": 314700,
    "assessed_value": 337000,
    "purchase_amount_vs_assessment": -6.617210682,
    "sale_date": "9/8/06",
    "sale_amount": 532250
  },
  {
    "parcel_id": 8563020140,
    "latitude": 47.630534,
    "longitude": -122.09714,
    "building_number": 2216,
    "street": "182nd Ave. N.E.",
    "city": "Redmond",
    "zip": 98052,
    "address": "2216 182nd Ave. N.E., Redmond, WA 98052",
    "purchase_date": "6/19/06",
    "purchase_year": 2006,
    "purchase_amount": 405000,
    "assessed_value": 355000,
    "purchase_amount_vs_assessment": 14.08450704,
    "sale_date": "9/25/06",
    "sale_amount": 545000
  },
  {
    "parcel_id": 7804200400,
    "latitude": 47.663701,
    "longitude": -122.15728,
    "building_number": 6404,
    "street": "137th Ave. N.E.",
    "city": "Redmond",
    "zip": 98052,
    "address": "6404 137th Ave. N.E., Redmond, WA 98052",
    "purchase_date": "11/2/07",
    "purchase_year": 2007,
    "purchase_amount": 159659,
    "assessed_value": 111000,
    "purchase_amount_vs_assessment": 43.83693694,
    "sale_date": "12/7/07",
    "sale_amount": 205000
  },
  {
    "parcel_id": 1310941640,
    "latitude": 47.746385,
    "longitude": -122.18244,
    "building_number": 16310,
    "street": "118th Court N.E.",
    "city": "Bothell",
    "zip": 98011,
    "address": "16310 118th Court N.E., Bothell, WA 98011",
    "purchase_date": "1/18/08",
    "purchase_year": 2008,
    "purchase_amount": 216500,
    "assessed_value": 224000,
    "purchase_amount_vs_assessment": -3.348214286,
    "sale_date": "2/29/08",
    "sale_amount": 0
  },
  {
    "parcel_id": 923049347,
    "latitude": 47.497267,
    "longitude": -122.3,
    "building_number": 2515,
    "street": "S. 118th St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "2515 S. 118th St., Seattle, WA 98168",
    "purchase_date": "2/6/08",
    "purchase_year": 2008,
    "purchase_amount": 210000,
    "assessed_value": 264000,
    "purchase_amount_vs_assessment": -20.45454545,
    "sale_date": "5/8/08",
    "sale_amount": 0
  },
  {
    "parcel_id": 3426049160,
    "latitude": 47.699435,
    "longitude": -122.28567,
    "building_number": 9703,
    "street": "40th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9703 40th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "9/26/08",
    "purchase_year": 2008,
    "purchase_amount": 215000,
    "assessed_value": 463000,
    "purchase_amount_vs_assessment": -53.5637149,
    "sale_date": "10/3/08",
    "sale_amount": 340000
  },
  {
    "parcel_id": 3345100046,
    "latitude": 47.523102,
    "longitude": -122.1915787,
    "building_number": 11308,
    "street": "S.E. May Creek Park Drive",
    "city": "Newcastle",
    "zip": 98056,
    "address": "11308 S.E. May Creek Park Drive, Newcastle, WA 98056",
    "purchase_date": "10/17/08",
    "purchase_year": 2008,
    "purchase_amount": 420000,
    "assessed_value": 509000,
    "purchase_amount_vs_assessment": -17.48526523
  },
  {
    "parcel_id": 7518505360,
    "latitude": 47.676748,
    "longitude": -122.38354,
    "building_number": 6529,
    "street": "21st Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "6529 21st Ave. N.W., Seattle, WA 98117",
    "purchase_date": "11/18/08",
    "purchase_year": 2008,
    "purchase_amount": 260756,
    "assessed_value": 324000,
    "purchase_amount_vs_assessment": -19.51975309,
    "sale_date": "4/6/09",
    "sale_amount": 385000
  },
  {
    "parcel_id": 3343901643,
    "latitude": 47.507194,
    "longitude": -122.19066,
    "building_number": 1632,
    "street": "Aberdeen Ave. N.E.",
    "city": "Renton",
    "zip": 98056,
    "address": "1632 Aberdeen Ave. N.E., Renton, WA 98056",
    "purchase_date": "11/26/08",
    "purchase_year": 2008,
    "purchase_amount": 225000,
    "assessed_value": 407000,
    "purchase_amount_vs_assessment": -44.71744472,
    "sale_date": "4/27/09",
    "sale_amount": 0
  },
  {
    "parcel_id": 2110900005,
    "latitude": 47.773096,
    "longitude": -122.37165,
    "building_number": 19828,
    "street": "12th Ave. N.W.",
    "city": "Seattle",
    "zip": 98177,
    "address": "19828 12th Ave. N.W., Seattle, WA 98177",
    "purchase_date": "12/15/08",
    "purchase_year": 2008,
    "purchase_amount": 183799,
    "assessed_value": 321000,
    "purchase_amount_vs_assessment": -42.74174455,
    "sale_date": "12/17/08",
    "sale_amount": 0
  },
  {
    "parcel_id": 3969300195,
    "latitude": 47.489339,
    "longitude": -122.23988,
    "building_number": 12655,
    "street": "74th Place S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "12655 74th Place S., Seattle, WA 98178",
    "purchase_date": "8/14/09",
    "purchase_year": 2009,
    "purchase_amount": 100631,
    "assessed_value": 221000,
    "purchase_amount_vs_assessment": -54.46561086,
    "sale_date": "1/13/10",
    "sale_amount": 120000
  },
  {
    "parcel_id": 4443801080,
    "latitude": 47.687144,
    "longitude": -122.3901,
    "building_number": 8009,
    "street": "26th Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "8009 26th Ave. N.W., Seattle, WA 98117",
    "purchase_date": "10/22/09",
    "purchase_year": 2009,
    "purchase_amount": 165000,
    "assessed_value": 365000,
    "purchase_amount_vs_assessment": -54.79452055,
    "sale_date": "2/28/10",
    "sale_amount": 367500
  },
  {
    "parcel_id": 8805900305,
    "latitude": 47.642613,
    "longitude": -122.303,
    "building_number": 2216,
    "street": "E. Louisa St.",
    "city": "Seattle",
    "zip": 98112,
    "address": "2216 E. Louisa St., Seattle, WA 98112",
    "purchase_date": "3/4/10",
    "purchase_year": 2010,
    "purchase_amount": 360000,
    "assessed_value": 434000,
    "purchase_amount_vs_assessment": -17.05069124,
    "sale_date": "7/19/10",
    "sale_amount": 642500
  },
  {
    "parcel_id": 1026069114,
    "latitude": 47.753452,
    "longitude": -122.01661,
    "building_number": 24136,
    "street": "N.E. 172nd St.",
    "city": "Woodinville",
    "zip": 98077,
    "address": "24136 N.E. 172nd St., Woodinville, WA 98077",
    "purchase_date": "8/31/10",
    "purchase_year": 2010,
    "purchase_amount": 250000,
    "assessed_value": 474000,
    "purchase_amount_vs_assessment": -47.25738397,
    "sale_date": "4/20/11",
    "sale_amount": 445000
  },
  {
    "parcel_id": 798000065,
    "latitude": 47.499277,
    "longitude": -122.32587,
    "building_number": 11604,
    "street": "5th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "11604 5th Ave. S., Seattle, WA 98168",
    "purchase_date": "11/2/10",
    "purchase_year": 2010,
    "purchase_amount": 160000,
    "assessed_value": 217000,
    "purchase_amount_vs_assessment": -26.26728111,
    "sale_date": "11/3/10",
    "sale_amount": 178000
  },
  {
    "parcel_id": 6713100027,
    "latitude": 47.76085,
    "longitude": -122.35515,
    "building_number": 422,
    "street": "N. 182nd Court",
    "city": "Seattle",
    "zip": 98133,
    "address": "422 N. 182nd Court, Seattle, WA 98133",
    "purchase_date": "11/5/10",
    "purchase_year": 2010,
    "purchase_amount": 145966,
    "assessed_value": 300000,
    "purchase_amount_vs_assessment": -51.34466667,
    "sale_date": "3/28/11",
    "sale_amount": 345000
  },
  {
    "parcel_id": 1939800010,
    "latitude": 47.764888,
    "longitude": -122.20835,
    "building_number": 18824,
    "street": "Bothell Way N.E.",
    "city": "Bothell",
    "zip": 98011,
    "address": "18824 Bothell Way N.E., Bothell, WA 98011",
    "purchase_date": "11/17/10",
    "purchase_year": 2010,
    "purchase_amount": 160000,
    "assessed_value": 294000,
    "purchase_amount_vs_assessment": -45.57823129,
    "sale_date": "6/30/13",
    "sale_amount": 315000
  },
  {
    "parcel_id": 6840700485,
    "latitude": 47.606615,
    "longitude": -122.29608,
    "building_number": 511,
    "street": "28th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "511 28th Ave., Seattle, WA 98122",
    "purchase_date": "12/13/10",
    "purchase_year": 2010,
    "purchase_amount": 200000,
    "assessed_value": 344000,
    "purchase_amount_vs_assessment": -41.86046512,
    "sale_date": "7/7/11",
    "sale_amount": 439000
  },
  {
    "parcel_id": 2877102741,
    "latitude": 47.679168,
    "longitude": -122.3608,
    "building_number": 6751,
    "street": "3rd Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "6751 3rd Ave. N.W., Seattle, WA 98117",
    "purchase_date": "1/11/11",
    "purchase_year": 2011,
    "purchase_amount": 250000,
    "assessed_value": 425000,
    "purchase_amount_vs_assessment": -41.17647059,
    "sale_date": "8/15/11",
    "sale_amount": 560000
  },
  {
    "parcel_id": 3362400559,
    "latitude": 47.682028,
    "longitude": -122.34945,
    "building_number": 710,
    "street": "N. 73rd St.",
    "city": "Seattle",
    "zip": 98103,
    "address": "710 N. 73rd St., Seattle, WA 98103",
    "purchase_date": "3/15/11",
    "purchase_year": 2011,
    "purchase_amount": 175000,
    "assessed_value": 261000,
    "purchase_amount_vs_assessment": -32.95019157,
    "sale_date": "3/21/11",
    "sale_amount": 0
  },
  {
    "parcel_id": 5364200519,
    "latitude": 47.663311,
    "longitude": -122.27611,
    "building_number": 4707,
    "street": "48th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "4707 48th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "5/16/11",
    "purchase_year": 2011,
    "purchase_amount": 530000,
    "assessed_value": 664000,
    "purchase_amount_vs_assessment": -20.18072289,
    "sale_date": "12/19/11",
    "sale_amount": 1023000
  },
  {
    "parcel_id": 9828202080,
    "latitude": 47.616633,
    "longitude": -122.29304,
    "building_number": 3008,
    "street": "E. Olive St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "3008 E. Olive St., Seattle, WA 98122",
    "purchase_date": "5/18/11",
    "purchase_year": 2011,
    "purchase_amount": 200000,
    "assessed_value": 372000,
    "purchase_amount_vs_assessment": -46.23655914,
    "sale_date": "5/31/11",
    "sale_amount": 241000
  },
  {
    "parcel_id": 7893200595,
    "latitude": 47.417162,
    "longitude": -122.33045,
    "building_number": 20704,
    "street": "4th Ave. S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "20704 4th Ave. S., Seattle, WA 98198",
    "purchase_date": "7/22/11",
    "purchase_year": 2011,
    "purchase_amount": 110000,
    "assessed_value": 221000,
    "purchase_amount_vs_assessment": -50.22624434,
    "sale_date": "10/5/11",
    "sale_amount": 215000
  },
  {
    "parcel_id": 3330501105,
    "latitude": 47.551733,
    "longitude": -122.27889,
    "building_number": 4243,
    "street": "S. Findlay St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4243 S. Findlay St., Seattle, WA 98118",
    "purchase_date": "8/2/11",
    "purchase_year": 2011,
    "purchase_amount": 55000,
    "assessed_value": 194000,
    "purchase_amount_vs_assessment": -71.64948454,
    "sale_date": "8/31/11",
    "sale_amount": 95000
  },
  {
    "parcel_id": 2600140260,
    "latitude": 47.545584,
    "longitude": -122.15648,
    "building_number": 13895,
    "street": "S.E. 64th St.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "13895 S.E. 64th St., Bellevue, WA 98006",
    "purchase_date": "9/7/11",
    "purchase_year": 2011,
    "purchase_amount": 310000,
    "assessed_value": 591000,
    "purchase_amount_vs_assessment": -47.5465313,
    "sale_date": "12/20/11",
    "sale_amount": 678000
  },
  {
    "parcel_id": 6058600290,
    "latitude": 47.595059,
    "longitude": -122.30189,
    "building_number": 814,
    "street": "23rd Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "814 23rd Ave. S., Seattle, WA 98144",
    "purchase_date": "10/19/11",
    "purchase_year": 2011,
    "purchase_amount": 98500,
    "assessed_value": 305000,
    "purchase_amount_vs_assessment": -67.70491803,
    "sale_date": "3/23/12",
    "sale_amount": 260000
  },
  {
    "parcel_id": 7645900230,
    "latitude": 47.57718,
    "longitude": -122.37951,
    "building_number": 3005,
    "street": "Belvidere Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "3005 Belvidere Ave. S.W., Seattle, WA 98126",
    "purchase_date": "10/25/11",
    "purchase_year": 2011,
    "purchase_amount": 300000,
    "assessed_value": 356000,
    "purchase_amount_vs_assessment": -15.73033708,
    "sale_date": "6/26/12",
    "sale_amount": 599000
  },
  {
    "parcel_id": 1845500090,
    "latitude": 47.540529,
    "longitude": -122.21442,
    "building_number": 9337,
    "street": "S.E. 70th Place",
    "city": "Mercer Island",
    "zip": 98040,
    "address": "9337 S.E. 70th Place, Mercer Island, WA 98040",
    "purchase_date": "1/24/12",
    "purchase_year": 2012,
    "purchase_amount": 400000,
    "assessed_value": 547000,
    "purchase_amount_vs_assessment": -26.8738574,
    "sale_date": "6/26/12",
    "sale_amount": 825000
  },
  {
    "parcel_id": 6738700225,
    "latitude": 47.584469,
    "longitude": -122.29118,
    "building_number": 2021,
    "street": "33rd Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2021 33rd Ave. S., Seattle, WA 98144",
    "purchase_date": "2/7/12",
    "purchase_year": 2012,
    "purchase_amount": 435000,
    "assessed_value": 428000,
    "purchase_amount_vs_assessment": 1.635514019,
    "sale_date": "10/9/12",
    "sale_amount": 949000
  },
  {
    "parcel_id": 1723049462,
    "latitude": 47.479934,
    "longitude": -122.32048,
    "building_number": 13718,
    "street": "10th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "13718 10th Ave. S., Seattle, WA 98168",
    "purchase_date": "2/15/12",
    "purchase_year": 2012,
    "purchase_amount": 109500,
    "assessed_value": 169000,
    "purchase_amount_vs_assessment": -35.20710059,
    "sale_date": "6/1/12",
    "sale_amount": 209000
  },
  {
    "parcel_id": 6170900115,
    "latitude": 47.702026,
    "longitude": -122.35831,
    "building_number": 101,
    "street": "N.W. 101st St.",
    "city": "Seattle",
    "zip": 98177,
    "address": "101 N.W. 101st St., Seattle, WA 98177",
    "purchase_date": "2/23/12",
    "purchase_year": 2012,
    "purchase_amount": 183000,
    "assessed_value": 288000,
    "purchase_amount_vs_assessment": -36.45833333,
    "sale_date": "6/28/12",
    "sale_amount": 435000
  },
  {
    "parcel_id": 1189001325,
    "latitude": 47.611363,
    "longitude": -122.29678,
    "building_number": 2717,
    "street": "E. Spring St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "2717 E. Spring St., Seattle, WA 98122",
    "purchase_date": "3/6/12",
    "purchase_year": 2012,
    "purchase_amount": 191000,
    "assessed_value": 268000,
    "purchase_amount_vs_assessment": -28.73134328,
    "sale_date": "10/10/12",
    "sale_amount": 454000
  },
  {
    "parcel_id": 1568100720,
    "latitude": 47.736135,
    "longitude": -122.2903,
    "building_number": 3521,
    "street": "N.E. 148th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "3521 N.E. 148th St., Seattle, WA 98155",
    "purchase_date": "3/16/12",
    "purchase_year": 2012,
    "purchase_amount": 240000,
    "assessed_value": 334000,
    "purchase_amount_vs_assessment": -28.14371257,
    "sale_date": "8/6/12",
    "sale_amount": 398950
  },
  {
    "parcel_id": 923049273,
    "latitude": 47.500637,
    "longitude": -122.30718,
    "building_number": 11422,
    "street": "20th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "11422 20th Ave. S., Seattle, WA 98168",
    "purchase_date": "5/25/12",
    "purchase_year": 2012,
    "purchase_amount": 120000,
    "assessed_value": 194000,
    "purchase_amount_vs_assessment": -38.1443299,
    "sale_date": "8/9/12",
    "sale_amount": 0
  },
  {
    "parcel_id": 6738700235,
    "latitude": 47.58469,
    "longitude": -122.29116,
    "building_number": 2015,
    "street": "33rd Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2015 33rd Ave. S., Seattle, WA 98144",
    "purchase_date": "6/7/12",
    "purchase_year": 2012,
    "purchase_amount": 425000,
    "assessed_value": 439000,
    "purchase_amount_vs_assessment": -3.189066059,
    "sale_date": "12/13/12",
    "sale_amount": 999950
  },
  {
    "parcel_id": 7849200885,
    "latitude": 47.523473,
    "longitude": -121.81832,
    "building_number": 39172,
    "street": "S.E. Gamma St.",
    "city": "Snoqualmie",
    "zip": 98065,
    "address": "39172 S.E. Gamma St., Snoqualmie, WA 98065",
    "purchase_date": "6/12/12",
    "purchase_year": 2012,
    "purchase_amount": 115000,
    "assessed_value": 199000,
    "purchase_amount_vs_assessment": -42.21105528,
    "sale_date": "10/23/12",
    "sale_amount": 220000
  },
  {
    "parcel_id": 7831800445,
    "latitude": 47.534522,
    "longitude": -122.35993,
    "building_number": 7532,
    "street": "21st Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "7532 21st Ave. S.W., Seattle, WA 98106",
    "purchase_date": "6/20/12",
    "purchase_year": 2012,
    "purchase_amount": 90000,
    "assessed_value": 480000,
    "purchase_amount_vs_assessment": -81.25,
    "sale_date": "12/21/12",
    "sale_amount": 300000
  },
  {
    "parcel_id": 3320000970,
    "latitude": 47.596464,
    "longitude": -122.30718,
    "building_number": 1841,
    "street": "S. Lane St.",
    "city": "Seattle",
    "zip": 98144,
    "address": "1841 S. Lane St., Seattle, WA 98144",
    "purchase_date": "6/21/12",
    "purchase_year": 2012,
    "purchase_amount": 160000,
    "assessed_value": 249000,
    "purchase_amount_vs_assessment": -35.74297189,
    "sale_date": "2/11/13",
    "sale_amount": 399900
  },
  {
    "parcel_id": 2789400035,
    "latitude": 47.504817,
    "longitude": -122.31498,
    "building_number": 10880,
    "street": "14th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "10880 14th Ave. S., Seattle, WA 98168",
    "purchase_date": "6/22/12",
    "purchase_year": 2012,
    "purchase_amount": 125000,
    "assessed_value": 204000,
    "purchase_amount_vs_assessment": -38.7254902,
    "sale_date": "12/6/12",
    "sale_amount": 229000
  },
  {
    "parcel_id": 3331500455,
    "latitude": 47.552463,
    "longitude": -122.2733,
    "building_number": 4719,
    "street": "S. Lucile St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4719 S. Lucile St., Seattle, WA 98118",
    "purchase_date": "6/28/12",
    "purchase_year": 2012,
    "purchase_amount": 200000,
    "assessed_value": 210000,
    "purchase_amount_vs_assessment": -4.761904762,
    "sale_date": "9/11/12",
    "sale_amount": 0
  },
  {
    "parcel_id": 3331500460,
    "latitude": 47.552427,
    "longitude": -122.2756094,
    "building_number": 4714,
    "street": "S. Lucile St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4714 S. Lucile St., Seattle, WA 98118",
    "purchase_date": "6/28/12",
    "purchase_year": 2012,
    "purchase_amount": 200000,
    "assessed_value": 90000,
    "purchase_amount_vs_assessment": 122.2222222,
    "sale_date": "9/11/12",
    "sale_amount": 0
  },
  {
    "parcel_id": 4022901450,
    "latitude": 47.774676,
    "longitude": -122.2918,
    "building_number": 3341,
    "street": "N.E. 202nd St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "3341 N.E. 202nd St., Seattle, WA 98155",
    "purchase_date": "7/13/12",
    "purchase_year": 2012,
    "purchase_amount": 120000,
    "assessed_value": 268000,
    "purchase_amount_vs_assessment": -55.2238806,
    "sale_date": "2/18/13",
    "sale_amount": 418750
  },
  {
    "parcel_id": 7523700020,
    "latitude": 47.37876,
    "longitude": -122.30699,
    "building_number": 24823,
    "street": "21st Ave. S.",
    "city": "Kent",
    "zip": 98032,
    "address": "24823 21st Ave. S., Kent, WA 98032",
    "purchase_date": "7/19/12",
    "purchase_year": 2012,
    "purchase_amount": 135199,
    "assessed_value": 212000,
    "purchase_amount_vs_assessment": -36.22688679,
    "sale_date": "3/8/13",
    "sale_amount": 239950
  },
  {
    "parcel_id": 1788800410,
    "latitude": 47.326261,
    "longitude": -122.34484,
    "building_number": 646,
    "street": "S.W. 308th St.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "646 S.W. 308th St., Federal Way, WA 98023",
    "purchase_date": "7/24/12",
    "purchase_year": 2012,
    "purchase_amount": 90000,
    "assessed_value": 167000,
    "purchase_amount_vs_assessment": -46.10778443,
    "sale_date": "2/27/13",
    "sale_amount": 200000
  },
  {
    "parcel_id": 1523059059,
    "latitude": 47.479187,
    "longitude": -122.14974,
    "building_number": 14231,
    "street": "S.E. 138th St.",
    "city": "Renton",
    "zip": 98059,
    "address": "14231 S.E. 138th St., Renton, WA 98059",
    "purchase_date": "7/25/12",
    "purchase_year": 2012,
    "purchase_amount": 165000,
    "assessed_value": 238000,
    "purchase_amount_vs_assessment": -30.67226891,
    "sale_date": "12/18/12",
    "sale_amount": 295000
  },
  {
    "parcel_id": 7971300035,
    "latitude": 47.616187,
    "longitude": -122.17262,
    "building_number": 12454,
    "street": "N.E. 6th Place",
    "city": "Bellevue",
    "zip": 98005,
    "address": "12454 N.E. 6th Place, Bellevue, WA 98005",
    "purchase_date": "7/25/12",
    "purchase_year": 2012,
    "purchase_amount": 382000,
    "assessed_value": 416000,
    "purchase_amount_vs_assessment": -8.173076923,
    "sale_date": "3/27/13",
    "sale_amount": 749950
  },
  {
    "parcel_id": 5540800060,
    "latitude": 47.694363,
    "longitude": -122.34582,
    "building_number": 930,
    "street": "N. 90th St.",
    "city": "Seattle",
    "zip": 98103,
    "address": "930 N. 90th St., Seattle, WA 98103",
    "purchase_date": "8/6/12",
    "purchase_year": 2012,
    "purchase_amount": 239000,
    "assessed_value": 312000,
    "purchase_amount_vs_assessment": -23.3974359,
    "sale_date": "4/23/13",
    "sale_amount": 447500
  },
  {
    "parcel_id": 9266700140,
    "latitude": 47.693971,
    "longitude": -122.34621,
    "building_number": 923,
    "street": "N. 90th St.",
    "city": "Seattle",
    "zip": 98103,
    "address": "923 N. 90th St., Seattle, WA 98103",
    "purchase_date": "8/22/12",
    "purchase_year": 2012,
    "purchase_amount": 246000,
    "assessed_value": 289000,
    "purchase_amount_vs_assessment": -14.87889273,
    "sale_date": "2/20/13",
    "sale_amount": 425000
  },
  {
    "parcel_id": 8125200460,
    "latitude": 47.451421,
    "longitude": -122.26848,
    "building_number": 5156,
    "street": "S. 170th St.",
    "city": "Seattle",
    "zip": 98188,
    "address": "5156 S. 170th St., Seattle, WA 98188",
    "purchase_date": "8/22/12",
    "purchase_year": 2012,
    "purchase_amount": 105000,
    "assessed_value": 231000,
    "purchase_amount_vs_assessment": -54.54545455,
    "sale_date": "5/17/13",
    "sale_amount": 261000
  },
  {
    "parcel_id": 4406000320,
    "latitude": 47.427919,
    "longitude": -122.15084,
    "building_number": 19340,
    "street": "142nd Place S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "19340 142nd Place S.E., Renton, WA 98058",
    "purchase_date": "8/24/12",
    "purchase_year": 2012,
    "purchase_amount": 143000,
    "assessed_value": 170000,
    "purchase_amount_vs_assessment": -15.88235294,
    "sale_date": "4/22/13",
    "sale_amount": 255000
  },
  {
    "parcel_id": 7522700180,
    "latitude": 47.366867,
    "longitude": -122.31461,
    "building_number": 1417,
    "street": "S. 262nd St.",
    "city": "Seattle",
    "zip": 98198,
    "address": "1417 S. 262nd St., Seattle, WA 98198",
    "purchase_date": "8/29/12",
    "purchase_year": 2012,
    "purchase_amount": 151000,
    "assessed_value": 215000,
    "purchase_amount_vs_assessment": -29.76744186,
    "sale_date": "11/28/12",
    "sale_amount": 249950
  },
  {
    "parcel_id": 7175300175,
    "latitude": 47.681122,
    "longitude": -122.30634,
    "building_number": 7062,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "7062 20th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "9/7/12",
    "purchase_year": 2012,
    "purchase_amount": 271000,
    "assessed_value": 321000,
    "purchase_amount_vs_assessment": -15.57632399,
    "sale_date": "3/11/13",
    "sale_amount": 550000
  },
  {
    "parcel_id": 1761600180,
    "latitude": 47.730346,
    "longitude": -122.23148,
    "building_number": 14230,
    "street": "82nd Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "14230 82nd Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "9/7/12",
    "purchase_year": 2012,
    "purchase_amount": 205199,
    "assessed_value": 237000,
    "purchase_amount_vs_assessment": -13.41814346,
    "sale_date": "1/3/13",
    "sale_amount": 340000
  },
  {
    "parcel_id": 1681400215,
    "latitude": 47.673181,
    "longitude": -122.30496,
    "building_number": 2111,
    "street": "N.E. 62nd St.",
    "city": "Seattle",
    "zip": 98115,
    "address": "2111 N.E. 62nd St., Seattle, WA 98115",
    "purchase_date": "9/13/12",
    "purchase_year": 2012,
    "purchase_amount": 320000,
    "assessed_value": 428000,
    "purchase_amount_vs_assessment": -25.23364486,
    "sale_date": "4/10/13",
    "sale_amount": 826000
  },
  {
    "parcel_id": 8121101451,
    "latitude": 47.570129,
    "longitude": -122.28581,
    "building_number": 3718,
    "street": "37th Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "3718 37th Ave. S., Seattle, WA 98144",
    "purchase_date": "9/19/12",
    "purchase_year": 2012,
    "purchase_amount": 110000,
    "assessed_value": 110000,
    "purchase_amount_vs_assessment": 0,
    "sale_date": "1/10/14",
    "sale_amount": 800000
  },
  {
    "parcel_id": 3995700060,
    "latitude": 47.742712,
    "longitude": -122.30178,
    "building_number": 15558,
    "street": "25th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "15558 25th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "9/21/12",
    "purchase_year": 2012,
    "purchase_amount": 120000,
    "assessed_value": 213000,
    "purchase_amount_vs_assessment": -43.66197183,
    "sale_date": "12/21/12",
    "sale_amount": 217000
  },
  {
    "parcel_id": 2011000070,
    "latitude": 47.381538,
    "longitude": -122.31142,
    "building_number": 1643,
    "street": "S. 245th Place",
    "city": "Seattle",
    "zip": 98198,
    "address": "1643 S. 245th Place, Seattle, WA 98198",
    "purchase_date": "9/28/12",
    "purchase_year": 2012,
    "purchase_amount": 131000,
    "assessed_value": 185000,
    "purchase_amount_vs_assessment": -29.18918919,
    "sale_date": "12/28/12",
    "sale_amount": 215000
  },
  {
    "parcel_id": 8722100340,
    "latitude": 47.63929,
    "longitude": -122.30503,
    "building_number": 2011,
    "street": "E. Lynn St.",
    "city": "Seattle",
    "zip": 98112,
    "address": "2011 E. Lynn St., Seattle, WA 98112",
    "purchase_date": "10/4/12",
    "purchase_year": 2012,
    "purchase_amount": 370000,
    "assessed_value": 309000,
    "purchase_amount_vs_assessment": 19.74110032,
    "sale_date": "8/27/13",
    "sale_amount": 1455000
  },
  {
    "parcel_id": 1827200185,
    "latitude": 47.447356,
    "longitude": -122.35617,
    "building_number": 17318,
    "street": "Sylvester Road S.W.",
    "city": "Seattle",
    "zip": 98166,
    "address": "17318 Sylvester Road S.W., Seattle, WA 98166",
    "purchase_date": "10/10/12",
    "purchase_year": 2012,
    "purchase_amount": 240000,
    "assessed_value": 285000,
    "purchase_amount_vs_assessment": -15.78947368,
    "sale_date": "4/12/13",
    "sale_amount": 549950
  },
  {
    "parcel_id": 537000370,
    "latitude": 47.325767,
    "longitude": -122.307,
    "building_number": 2025,
    "street": "S. 308th St.",
    "city": "Federal Way",
    "zip": 98003,
    "address": "2025 S. 308th St., Federal Way, WA 98003",
    "purchase_date": "10/12/12",
    "purchase_year": 2012,
    "purchase_amount": 120500,
    "assessed_value": 165000,
    "purchase_amount_vs_assessment": -26.96969697,
    "sale_date": "1/28/13",
    "sale_amount": 222000
  },
  {
    "parcel_id": 1453600202,
    "latitude": 47.725979,
    "longitude": -122.29608,
    "building_number": 13342,
    "street": "30th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "13342 30th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "10/19/12",
    "purchase_year": 2012,
    "purchase_amount": 197000,
    "assessed_value": 313000,
    "purchase_amount_vs_assessment": -37.06070288,
    "sale_date": "5/20/14",
    "sale_amount": 520000
  },
  {
    "parcel_id": 1705400255,
    "latitude": 47.556851,
    "longitude": -122.2789,
    "building_number": 4315,
    "street": "S. Hudson St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4315 S. Hudson St., Seattle, WA 98118",
    "purchase_date": "11/2/12",
    "purchase_year": 2012,
    "purchase_amount": 150000,
    "assessed_value": 306000,
    "purchase_amount_vs_assessment": -50.98039216,
    "sale_date": "6/26/13",
    "sale_amount": 516000
  },
  {
    "parcel_id": 5393600810,
    "latitude": 47.582818,
    "longitude": -122.30845,
    "building_number": 2301,
    "street": "19th Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2301 19th Ave. S., Seattle, WA 98144",
    "purchase_date": "11/5/12",
    "purchase_year": 2012,
    "purchase_amount": 155000,
    "assessed_value": 255000,
    "purchase_amount_vs_assessment": -39.21568627,
    "sale_date": "4/19/13",
    "sale_amount": 420000
  },
  {
    "parcel_id": 7686205350,
    "latitude": 47.415851,
    "longitude": -122.31524,
    "building_number": 20738,
    "street": "14th Ave. S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "20738 14th Ave. S., Seattle, WA 98198",
    "purchase_date": "11/8/12",
    "purchase_year": 2012,
    "purchase_amount": 114799,
    "assessed_value": 186000,
    "purchase_amount_vs_assessment": -38.28010753,
    "sale_date": "2/25/13",
    "sale_amount": 209000
  },
  {
    "parcel_id": 6649400180,
    "latitude": 47.522097,
    "longitude": -122.26406,
    "building_number": 9030,
    "street": "Seward Park Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "9030 Seward Park Ave. S., Seattle, WA 98118",
    "purchase_date": "11/16/12",
    "purchase_year": 2012,
    "purchase_amount": 85000,
    "assessed_value": 95000,
    "purchase_amount_vs_assessment": -10.52631579
  },
  {
    "parcel_id": 1709900020,
    "latitude": 47.562708,
    "longitude": -122.28805,
    "building_number": 4501,
    "street": "Rainier Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4501 Rainier Ave. S., Seattle, WA 98118",
    "purchase_date": "11/28/12",
    "purchase_year": 2012,
    "purchase_amount": 160000,
    "assessed_value": 238700,
    "purchase_amount_vs_assessment": -32.97025555,
    "sale_date": "1/28/13",
    "sale_amount": 225000
  },
  {
    "parcel_id": 3881900315,
    "latitude": 47.586837,
    "longitude": -122.31104,
    "building_number": 1805,
    "street": "17th Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "1805 17th Ave. S., Seattle, WA 98144",
    "purchase_date": "11/28/12",
    "purchase_year": 2012,
    "purchase_amount": 75000,
    "assessed_value": 340000,
    "purchase_amount_vs_assessment": -77.94117647,
    "sale_date": "1/6/15",
    "sale_amount": 790000
  },
  {
    "parcel_id": 8018600980,
    "latitude": 47.493859,
    "longitude": -122.31764,
    "building_number": 12214,
    "street": "12th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "12214 12th Ave. S., Seattle, WA 98168",
    "purchase_date": "11/28/12",
    "purchase_year": 2012,
    "purchase_amount": 165000,
    "assessed_value": 119000,
    "purchase_amount_vs_assessment": 38.65546218,
    "sale_date": "12/3/14",
    "sale_amount": 187250
  },
  {
    "parcel_id": 6414100291,
    "latitude": 47.719606,
    "longitude": -122.31438,
    "building_number": 12503,
    "street": "14th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "12503 14th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "12/4/12",
    "purchase_year": 2012,
    "purchase_amount": 70000,
    "assessed_value": 251000,
    "purchase_amount_vs_assessment": -72.11155378,
    "sale_date": "11/20/13",
    "sale_amount": 424000
  },
  {
    "parcel_id": 3348401086,
    "latitude": 47.496355,
    "longitude": -122.26587,
    "building_number": 11836,
    "street": "54th Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11836 54th Ave. S., Seattle, WA 98178",
    "purchase_date": "12/11/12",
    "purchase_year": 2012,
    "purchase_amount": 170000,
    "assessed_value": 264000,
    "purchase_amount_vs_assessment": -35.60606061,
    "sale_date": "8/21/13",
    "sale_amount": 335000
  },
  {
    "parcel_id": 4060000420,
    "latitude": 47.500796,
    "longitude": -122.24602,
    "building_number": 11439,
    "street": "71st Place S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11439 71st Place S., Seattle, WA 98178",
    "purchase_date": "12/12/12",
    "purchase_year": 2012,
    "purchase_amount": 92000,
    "assessed_value": 179000,
    "purchase_amount_vs_assessment": -48.60335196,
    "sale_date": "1/28/13",
    "sale_amount": 169950
  },
  {
    "parcel_id": 1788500065,
    "latitude": 47.32832,
    "longitude": -122.34801,
    "building_number": 1019,
    "street": "S.W. 305th St.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "1019 S.W. 305th St., Federal Way, WA 98023",
    "purchase_date": "12/12/12",
    "purchase_year": 2012,
    "purchase_amount": 30000,
    "assessed_value": 126000,
    "purchase_amount_vs_assessment": -76.19047619,
    "sale_date": "4/12/13",
    "sale_amount": 175000
  },
  {
    "parcel_id": 4083303690,
    "latitude": 47.653936,
    "longitude": -122.33592,
    "building_number": 3824,
    "street": "Wallingford Ave. N.",
    "city": "Seattle",
    "zip": 98103,
    "address": "3824 Wallingford Ave. N., Seattle, WA 98103",
    "purchase_date": "12/26/12",
    "purchase_year": 2012,
    "purchase_amount": 372000,
    "assessed_value": 412000,
    "purchase_amount_vs_assessment": -9.708737864,
    "sale_date": "7/8/13",
    "sale_amount": 755000
  },
  {
    "parcel_id": 927100433,
    "latitude": 47.756753,
    "longitude": -122.31901,
    "building_number": 17531,
    "street": "10th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "17531 10th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "1/15/13",
    "purchase_year": 2013,
    "purchase_amount": 178299,
    "assessed_value": 191000,
    "purchase_amount_vs_assessment": -6.64973822,
    "sale_date": "5/3/13",
    "sale_amount": 316250
  },
  {
    "parcel_id": 9547201745,
    "latitude": 47.678771,
    "longitude": -122.30855,
    "building_number": 6838,
    "street": "18th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "6838 18th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "1/18/13",
    "purchase_year": 2013,
    "purchase_amount": 455000,
    "assessed_value": 539000,
    "purchase_amount_vs_assessment": -15.58441558,
    "sale_date": "8/21/13",
    "sale_amount": 800000
  },
  {
    "parcel_id": 2220400195,
    "latitude": 47.506905,
    "longitude": -122.23152,
    "building_number": 10806,
    "street": "Rainier Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "10806 Rainier Ave. S., Seattle, WA 98178",
    "purchase_date": "1/23/13",
    "purchase_year": 2013,
    "purchase_amount": 451250,
    "assessed_value": 624000,
    "purchase_amount_vs_assessment": -27.68429487,
    "sale_date": "3/20/14",
    "sale_amount": 1150000
  },
  {
    "parcel_id": 2220400195,
    "latitude": 47.506905,
    "longitude": -122.23152,
    "building_number": 10806,
    "street": "Rainier Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "10806 Rainier Ave. S., Seattle, WA 98178",
    "purchase_date": "1/23/13",
    "purchase_year": 2013,
    "purchase_amount": 451250,
    "assessed_value": 624000,
    "purchase_amount_vs_assessment": -27.68429487,
    "sale_date": "3/20/14",
    "sale_amount": 1150000
  },
  {
    "parcel_id": 8651430190,
    "latitude": 47.370423,
    "longitude": -122.07792,
    "building_number": 19630,
    "street": "S.E. 259th St.",
    "city": "Kent",
    "zip": 98042,
    "address": "19630 S.E. 259th St., Kent, WA 98042",
    "purchase_date": "1/24/13",
    "purchase_year": 2013,
    "purchase_amount": 108000,
    "assessed_value": 123000,
    "purchase_amount_vs_assessment": -12.19512195,
    "sale_date": "7/12/13",
    "sale_amount": 210000
  },
  {
    "parcel_id": 5021900025,
    "latitude": 47.5779651,
    "longitude": -122.2274928,
    "building_number": 8435,
    "street": "S.E. 36th St.",
    "city": "Mercer Island",
    "zip": 25181,
    "address": "8435 S.E. 36th St., Mercer Island, WA 25181",
    "purchase_date": "1/25/13",
    "purchase_year": 2013,
    "purchase_amount": 665000,
    "assessed_value": 612000,
    "purchase_amount_vs_assessment": 8.660130719,
    "sale_date": "5/29/15",
    "sale_amount": 1300000
  },
  {
    "parcel_id": 2570300280,
    "latitude": 47.717411,
    "longitude": -122.20154,
    "building_number": 13016,
    "street": "104th Place N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13016 104th Place N.E., Kirkland, WA 98034",
    "purchase_date": "1/29/13",
    "purchase_year": 2013,
    "purchase_amount": 290000,
    "assessed_value": 268000,
    "purchase_amount_vs_assessment": 8.208955224,
    "sale_date": "8/9/13",
    "sale_amount": 415000
  },
  {
    "parcel_id": 1962200010,
    "latitude": 47.650177,
    "longitude": -122.32063,
    "building_number": 3214,
    "street": "Franklin Ave. E.",
    "city": "Seattle",
    "zip": 98102,
    "address": "3214 Franklin Ave. E., Seattle, WA 98102",
    "purchase_date": "2/5/13",
    "purchase_year": 2013,
    "purchase_amount": 456000,
    "assessed_value": 446000,
    "purchase_amount_vs_assessment": 2.242152466,
    "sale_date": "1/28/14",
    "sale_amount": 614400
  },
  {
    "parcel_id": 952003105,
    "latitude": 47.5658011,
    "longitude": -122.3840158,
    "building_number": 4121,
    "street": "39th Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "4121 39th Ave. S.W., Seattle, WA 98116",
    "purchase_date": "2/6/13",
    "purchase_year": 2013,
    "purchase_amount": 150000,
    "assessed_value": 203000,
    "purchase_amount_vs_assessment": -26.10837438,
    "sale_date": "1/27/14",
    "sale_amount": 1100000
  },
  {
    "parcel_id": 3448001280,
    "latitude": 47.71467,
    "longitude": -122.30066,
    "building_number": 11719,
    "street": "26th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "11719 26th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "2/6/13",
    "purchase_year": 2013,
    "purchase_amount": 230000,
    "assessed_value": 266000,
    "purchase_amount_vs_assessment": -13.53383459,
    "sale_date": "6/6/13",
    "sale_amount": 425000
  },
  {
    "parcel_id": 6600410220,
    "latitude": 47.323402,
    "longitude": -122.14268,
    "building_number": 31024,
    "street": "149th Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "31024 149th Ave. S.E., Kent, WA 98042",
    "purchase_date": "2/25/13",
    "purchase_year": 2013,
    "purchase_amount": 90000,
    "assessed_value": 128000,
    "purchase_amount_vs_assessment": -29.6875,
    "sale_date": "6/5/13",
    "sale_amount": 215373
  },
  {
    "parcel_id": 2423069108,
    "latitude": 47.4634045,
    "longitude": -121.9852909,
    "building_number": 15329,
    "street": "Tiger Mountain Road S.E.",
    "city": "Issaquah",
    "zip": 98027,
    "address": "15329 Tiger Mountain Road S.E., Issaquah, WA 98027",
    "purchase_date": "3/1/13",
    "purchase_year": 2013,
    "purchase_amount": 410799,
    "assessed_value": 467000,
    "purchase_amount_vs_assessment": -12.03447537,
    "sale_date": "6/12/13",
    "sale_amount": 599000
  },
  {
    "parcel_id": 1788800780,
    "latitude": 47.328337,
    "longitude": -122.34442,
    "building_number": 30514,
    "street": "7th Ave. S.W.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "30514 7th Ave. S.W., Federal Way, WA 98023",
    "purchase_date": "3/5/13",
    "purchase_year": 2013,
    "purchase_amount": 95000,
    "assessed_value": 130000,
    "purchase_amount_vs_assessment": -26.92307692,
    "sale_date": "6/12/13",
    "sale_amount": 200000
  },
  {
    "parcel_id": 9320700670,
    "latitude": 47.409201,
    "longitude": -122.21175,
    "building_number": 9608,
    "street": "S. 216th St.",
    "city": "Kent",
    "zip": 98031,
    "address": "9608 S. 216th St., Kent, WA 98031",
    "purchase_date": "3/25/13",
    "purchase_year": 2013,
    "purchase_amount": 155000,
    "assessed_value": 178000,
    "purchase_amount_vs_assessment": -12.92134831,
    "sale_date": "10/14/13",
    "sale_amount": 275000
  },
  {
    "parcel_id": 3426059060,
    "latitude": 47.697628,
    "longitude": -122.16404,
    "building_number": 10824,
    "street": "132nd Ave. N.E.",
    "city": "Redmond",
    "zip": 98052,
    "address": "10824 132nd Ave. N.E., Redmond, WA 98052",
    "purchase_date": "3/25/13",
    "purchase_year": 2013,
    "purchase_amount": 125000,
    "assessed_value": 185000,
    "purchase_amount_vs_assessment": -32.43243243,
    "sale_date": "9/23/13",
    "sale_amount": 325000
  },
  {
    "parcel_id": 3392500015,
    "latitude": 47.444168,
    "longitude": -122.27953,
    "building_number": 17631,
    "street": "43rd Ave. S.",
    "city": "Seattle",
    "zip": 98188,
    "address": "17631 43rd Ave. S., Seattle, WA 98188",
    "purchase_date": "4/3/13",
    "purchase_year": 2013,
    "purchase_amount": 130000,
    "assessed_value": 176000,
    "purchase_amount_vs_assessment": -26.13636364,
    "sale_date": "6/20/13",
    "sale_amount": 260000
  },
  {
    "parcel_id": 3876310040,
    "latitude": 47.727771,
    "longitude": -122.17429,
    "building_number": 12421,
    "street": "N.E. 141st Way",
    "city": "Kirkland",
    "zip": 98034,
    "address": "12421 N.E. 141st Way, Kirkland, WA 98034",
    "purchase_date": "4/8/13",
    "purchase_year": 2013,
    "purchase_amount": 288750,
    "assessed_value": 277000,
    "purchase_amount_vs_assessment": 4.241877256,
    "sale_date": "9/5/13",
    "sale_amount": 467500
  },
  {
    "parcel_id": 1285300130,
    "latitude": 47.591411,
    "longitude": -122.29948,
    "building_number": 2442,
    "street": "S. Irving St.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2442 S. Irving St., Seattle, WA 98144",
    "purchase_date": "4/10/13",
    "purchase_year": 2013,
    "purchase_amount": 225000,
    "assessed_value": 293000,
    "purchase_amount_vs_assessment": -23.20819113,
    "sale_date": "12/11/13",
    "sale_amount": 555000
  },
  {
    "parcel_id": 1775801290,
    "latitude": 47.740558,
    "longitude": -122.09885,
    "building_number": 18021,
    "street": "N.E. 156th St.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "18021 N.E. 156th St., Woodinville, WA 98072",
    "purchase_date": "4/10/13",
    "purchase_year": 2013,
    "purchase_amount": 260000,
    "assessed_value": 272000,
    "purchase_amount_vs_assessment": -4.411764706,
    "sale_date": "7/17/13",
    "sale_amount": 0
  },
  {
    "parcel_id": 3876800100,
    "latitude": 47.740521,
    "longitude": -122.17331,
    "building_number": 15601,
    "street": "125th Place N.E.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "15601 125th Place N.E., Woodinville, WA 98072",
    "purchase_date": "4/21/13",
    "purchase_year": 2013,
    "purchase_amount": 190000,
    "assessed_value": 209000,
    "purchase_amount_vs_assessment": -9.090909091,
    "sale_date": "8/8/13",
    "sale_amount": 387000
  },
  {
    "parcel_id": 9482700301,
    "latitude": 47.682139,
    "longitude": -122.34392,
    "building_number": 7308,
    "street": "Keen Way N.",
    "city": "Seattle",
    "zip": 98103,
    "address": "7308 Keen Way N., Seattle, WA 98103",
    "purchase_date": "4/25/13",
    "purchase_year": 2013,
    "purchase_amount": 385000,
    "assessed_value": 469000,
    "purchase_amount_vs_assessment": -17.91044776,
    "sale_date": "2/21/14",
    "sale_amount": 600000
  },
  {
    "parcel_id": 9455200715,
    "latitude": 47.702154,
    "longitude": -122.29036,
    "building_number": 10032,
    "street": "35th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "10032 35th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "4/25/13",
    "purchase_year": 2013,
    "purchase_amount": 190000,
    "assessed_value": 281000,
    "purchase_amount_vs_assessment": -32.38434164,
    "sale_date": "3/24/14",
    "sale_amount": 530000
  },
  {
    "parcel_id": 5437810350,
    "latitude": 47.198272,
    "longitude": -121.99922,
    "building_number": 2311,
    "street": "Paramount Drive",
    "city": "Enumclaw",
    "zip": 98022,
    "address": "2311 Paramount Drive, Enumclaw, WA 98022",
    "purchase_date": "4/29/13",
    "purchase_year": 2013,
    "purchase_amount": 5000,
    "assessed_value": 163000,
    "purchase_amount_vs_assessment": -96.93251534,
    "sale_date": "12/11/13",
    "sale_amount": 215500
  },
  {
    "parcel_id": 5634500141,
    "latitude": 47.749825,
    "longitude": -122.23983,
    "building_number": 16701,
    "street": "76th Ave. N.E.",
    "city": "Kenmore",
    "zip": 98028,
    "address": "16701 76th Ave. N.E., Kenmore, WA 98028",
    "purchase_date": "5/2/13",
    "purchase_year": 2013,
    "purchase_amount": 160000,
    "assessed_value": 348000,
    "purchase_amount_vs_assessment": -54.02298851,
    "sale_date": "1/30/14",
    "sale_amount": 412500
  },
  {
    "parcel_id": 8019200500,
    "latitude": 47.489788,
    "longitude": -122.32029,
    "building_number": 12618,
    "street": "10th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "12618 10th Ave. S., Seattle, WA 98168",
    "purchase_date": "5/9/13",
    "purchase_year": 2013,
    "purchase_amount": 135299,
    "assessed_value": 180000,
    "purchase_amount_vs_assessment": -24.83388889,
    "sale_date": "12/9/13",
    "sale_amount": 280000
  },
  {
    "parcel_id": 8019200500,
    "latitude": 47.489788,
    "longitude": -122.32029,
    "building_number": 12618,
    "street": "10th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "12618 10th Ave. S., Seattle, WA 98168",
    "purchase_date": "5/9/13",
    "purchase_year": 2013,
    "purchase_amount": 135299,
    "assessed_value": 180000,
    "purchase_amount_vs_assessment": -24.83388889,
    "sale_date": "12/9/13",
    "sale_amount": 280000
  },
  {
    "parcel_id": 1947300130,
    "latitude": 47.604701,
    "longitude": -122.28794,
    "building_number": 308,
    "street": "35th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "308 35th Ave., Seattle, WA 98122",
    "purchase_date": "5/14/13",
    "purchase_year": 2013,
    "purchase_amount": 460000,
    "assessed_value": 481000,
    "purchase_amount_vs_assessment": -4.365904366,
    "sale_date": "10/9/13",
    "sale_amount": 700000
  },
  {
    "parcel_id": 2770604355,
    "latitude": 47.645367,
    "longitude": -122.37459,
    "building_number": 2816,
    "street": "14th Ave. W.",
    "city": "Seattle",
    "zip": 98119,
    "address": "2816 14th Ave. W., Seattle, WA 98119",
    "purchase_date": "5/16/13",
    "purchase_year": 2013,
    "purchase_amount": 465000,
    "assessed_value": 423000,
    "purchase_amount_vs_assessment": 9.929078014,
    "sale_date": "1/24/14",
    "sale_amount": 599000
  },
  {
    "parcel_id": 1023059107,
    "latitude": 47.501765,
    "longitude": -122.15828,
    "building_number": 1123,
    "street": "Chelan Ave. N.E.",
    "city": "Renton",
    "zip": 98059,
    "address": "1123 Chelan Ave. N.E., Renton, WA 98059",
    "purchase_date": "5/17/13",
    "purchase_year": 2013,
    "purchase_amount": 200000,
    "assessed_value": 252000,
    "purchase_amount_vs_assessment": -20.63492063,
    "sale_date": "10/22/13",
    "sale_amount": 425000
  },
  {
    "parcel_id": 1423049012,
    "latitude": 47.486296,
    "longitude": -122.24921,
    "building_number": 6730,
    "street": "S. Langston Road",
    "city": "Seattle",
    "zip": 98178,
    "address": "6730 S. Langston Road, Seattle, WA 98178",
    "purchase_date": "5/21/13",
    "purchase_year": 2013,
    "purchase_amount": 165000,
    "assessed_value": 172000,
    "purchase_amount_vs_assessment": -4.069767442,
    "sale_date": "3/5/14",
    "sale_amount": 279000
  },
  {
    "parcel_id": 461000360,
    "latitude": 47.682643,
    "longitude": -122.3676,
    "building_number": 7341,
    "street": "Dibble Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "7341 Dibble Ave. N.W., Seattle, WA 98117",
    "purchase_date": "5/22/13",
    "purchase_year": 2013,
    "purchase_amount": 315000,
    "assessed_value": 361000,
    "purchase_amount_vs_assessment": -12.74238227,
    "sale_date": "3/13/14",
    "sale_amount": 705000
  },
  {
    "parcel_id": 9477201330,
    "latitude": 47.729293,
    "longitude": -122.1911,
    "building_number": 11232,
    "street": "N.E. 141st Place",
    "city": "Kirkland",
    "zip": 98034,
    "address": "11232 N.E. 141st Place, Kirkland, WA 98034",
    "purchase_date": "5/22/13",
    "purchase_year": 2013,
    "purchase_amount": 286000,
    "assessed_value": 286000,
    "purchase_amount_vs_assessment": 0,
    "sale_date": "9/26/13",
    "sale_amount": 435000
  },
  {
    "parcel_id": 6713700220,
    "latitude": 47.761161,
    "longitude": -122.35442,
    "building_number": 505,
    "street": "N. 183rd St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "505 N. 183rd St., Seattle, WA 98133",
    "purchase_date": "5/23/13",
    "purchase_year": 2013,
    "purchase_amount": 200000,
    "assessed_value": 261000,
    "purchase_amount_vs_assessment": -23.37164751,
    "sale_date": "1/9/14",
    "sale_amount": 375000
  },
  {
    "parcel_id": 9284801220,
    "latitude": 47.553055,
    "longitude": -122.37266,
    "building_number": 5423,
    "street": "31st Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "5423 31st Ave. S.W., Seattle, WA 98126",
    "purchase_date": "5/29/13",
    "purchase_year": 2013,
    "purchase_amount": 160000,
    "assessed_value": 235000,
    "purchase_amount_vs_assessment": -31.91489362,
    "sale_date": "4/7/14",
    "sale_amount": 325000
  },
  {
    "parcel_id": 4059400385,
    "latitude": 47.500714,
    "longitude": -122.2434,
    "building_number": 11410,
    "street": "Crestwood Drive S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11410 Crestwood Drive S., Seattle, WA 98178",
    "purchase_date": "6/3/13",
    "purchase_year": 2013,
    "purchase_amount": 90000,
    "assessed_value": 153000,
    "purchase_amount_vs_assessment": -41.17647059,
    "sale_date": "11/18/13",
    "sale_amount": 206000
  },
  {
    "parcel_id": 8824900190,
    "latitude": 47.675286,
    "longitude": -122.30576,
    "building_number": 6315,
    "street": "21st Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "6315 21st Ave. N.E., Seattle, WA 98115",
    "purchase_date": "6/4/13",
    "purchase_year": 2013,
    "purchase_amount": 472000,
    "assessed_value": 437000,
    "purchase_amount_vs_assessment": 8.009153318,
    "sale_date": "2/5/14",
    "sale_amount": 960000
  },
  {
    "parcel_id": 9826701015,
    "latitude": 47.6022293,
    "longitude": -122.3088022,
    "building_number": 119,
    "street": "20th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "119 20th Ave., Seattle, WA 98122",
    "purchase_date": "6/4/13",
    "purchase_year": 2013,
    "purchase_amount": 490000,
    "assessed_value": 440000,
    "purchase_amount_vs_assessment": 11.36363636,
    "sale_date": "7/17/15",
    "sale_amount": 630000
  },
  {
    "parcel_id": 3083000215,
    "latitude": 47.578201,
    "longitude": -122.30462,
    "building_number": 2803,
    "street": "22nd Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2803 22nd Ave. S., Seattle, WA 98144",
    "purchase_date": "6/5/13",
    "purchase_year": 2013,
    "purchase_amount": 205000,
    "assessed_value": 219000,
    "purchase_amount_vs_assessment": -6.392694064,
    "sale_date": "10/30/13",
    "sale_amount": 449750
  },
  {
    "parcel_id": 9542800560,
    "latitude": 47.300044,
    "longitude": -122.37542,
    "building_number": 33700,
    "street": "33rd Place S.W.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "33700 33rd Place S.W., Federal Way, WA 98023",
    "purchase_date": "6/12/13",
    "purchase_year": 2013,
    "purchase_amount": 181300,
    "assessed_value": 167000,
    "purchase_amount_vs_assessment": 8.562874251,
    "sale_date": "2/26/14",
    "sale_amount": 280000
  },
  {
    "parcel_id": 1844500050,
    "latitude": 47.759999,
    "longitude": -122.33076,
    "building_number": 18012,
    "street": "Sunnyside Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "18012 Sunnyside Ave. N., Seattle, WA 98133",
    "purchase_date": "6/25/13",
    "purchase_year": 2013,
    "purchase_amount": 173000,
    "assessed_value": 234000,
    "purchase_amount_vs_assessment": -26.06837607,
    "sale_date": "11/3/13",
    "sale_amount": 330000
  },
  {
    "parcel_id": 3083000435,
    "latitude": 47.58064,
    "longitude": -122.30461,
    "building_number": 2511,
    "street": "22nd Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2511 22nd Ave. S., Seattle, WA 98144",
    "purchase_date": "7/3/13",
    "purchase_year": 2013,
    "purchase_amount": 190000,
    "assessed_value": 276000,
    "purchase_amount_vs_assessment": -31.15942029,
    "sale_date": "10/9/13",
    "sale_amount": 499000
  },
  {
    "parcel_id": 1338800850,
    "latitude": 47.626358,
    "longitude": -122.30698,
    "building_number": 738,
    "street": "19th Ave. E.",
    "city": "Seattle",
    "zip": 98112,
    "address": "738 19th Ave. E., Seattle, WA 98112",
    "purchase_date": "7/10/13",
    "purchase_year": 2013,
    "purchase_amount": 530000,
    "assessed_value": 519000,
    "purchase_amount_vs_assessment": 2.119460501,
    "sale_date": "5/5/14",
    "sale_amount": 950000
  },
  {
    "parcel_id": 5272200025,
    "latitude": 47.714237,
    "longitude": -122.31851,
    "building_number": 916,
    "street": "N.E. 117th St.",
    "city": "Seattle",
    "zip": 98125,
    "address": "916 N.E. 117th St., Seattle, WA 98125",
    "purchase_date": "7/11/13",
    "purchase_year": 2013,
    "purchase_amount": 227000,
    "assessed_value": 259000,
    "purchase_amount_vs_assessment": -12.35521236,
    "sale_date": "12/16/13",
    "sale_amount": 360000
  },
  {
    "parcel_id": 3977630240,
    "latitude": 47.31689,
    "longitude": -122.12758,
    "building_number": 31728,
    "street": "160th Place S.E.",
    "city": "Auburn",
    "zip": 98092,
    "address": "31728 160th Place S.E., Auburn, WA 98092",
    "purchase_date": "7/14/13",
    "purchase_year": 2013,
    "purchase_amount": 112000,
    "assessed_value": 130000,
    "purchase_amount_vs_assessment": -13.84615385,
    "sale_date": "2/24/14",
    "sale_amount": 198000
  },
  {
    "parcel_id": 1900600040,
    "latitude": 47.469246,
    "longitude": -122.35014,
    "building_number": 1203,
    "street": "S.W. 149th St.",
    "city": "Seattle",
    "zip": 98166,
    "address": "1203 S.W. 149th St., Seattle, WA 98166",
    "purchase_date": "7/21/13",
    "purchase_year": 2013,
    "purchase_amount": 125000,
    "assessed_value": 149000,
    "purchase_amount_vs_assessment": -16.10738255,
    "sale_date": "5/7/14",
    "sale_amount": 265000
  },
  {
    "parcel_id": 4363700236,
    "latitude": 47.529624,
    "longitude": -122.37154,
    "building_number": 8111,
    "street": "30th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "8111 30th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "8/7/13",
    "purchase_year": 2013,
    "purchase_amount": 240500,
    "assessed_value": 238000,
    "purchase_amount_vs_assessment": 1.050420168,
    "sale_date": "3/13/14",
    "sale_amount": 409000
  },
  {
    "parcel_id": 7812801365,
    "latitude": 47.495361,
    "longitude": -122.24665,
    "building_number": 6922,
    "street": "S. 120th Place",
    "city": "Seattle",
    "zip": 98178,
    "address": "6922 S. 120th Place, Seattle, WA 98178",
    "purchase_date": "8/7/13",
    "purchase_year": 2013,
    "purchase_amount": 130000,
    "assessed_value": 136000,
    "purchase_amount_vs_assessment": -4.411764706,
    "sale_date": "4/17/14",
    "sale_amount": 226040
  },
  {
    "parcel_id": 2658000305,
    "latitude": 47.530542,
    "longitude": -122.2711,
    "building_number": 7935,
    "street": "50th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "7935 50th Ave. S., Seattle, WA 98118",
    "purchase_date": "8/9/13",
    "purchase_year": 2013,
    "purchase_amount": 60000,
    "assessed_value": 241000,
    "purchase_amount_vs_assessment": -75.10373444,
    "sale_date": "4/7/14",
    "sale_amount": 250000
  },
  {
    "parcel_id": 6141100380,
    "latitude": 47.718343,
    "longitude": -122.3533,
    "building_number": 12215,
    "street": "Dayton Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "12215 Dayton Ave. N., Seattle, WA 98133",
    "purchase_date": "8/13/13",
    "purchase_year": 2013,
    "purchase_amount": 215000,
    "assessed_value": 248000,
    "purchase_amount_vs_assessment": -13.30645161,
    "sale_date": "5/15/14",
    "sale_amount": 465000
  },
  {
    "parcel_id": 926069103,
    "latitude": 47.751247,
    "longitude": -122.04378,
    "building_number": 22011,
    "street": "N.E. 170th Place",
    "city": "Woodinville",
    "zip": 98077,
    "address": "22011 N.E. 170th Place, Woodinville, WA 98077",
    "purchase_date": "8/19/13",
    "purchase_year": 2013,
    "purchase_amount": 160000,
    "assessed_value": 240000,
    "purchase_amount_vs_assessment": -33.33333333,
    "sale_date": "4/8/14",
    "sale_amount": 375000
  },
  {
    "parcel_id": 2891000010,
    "latitude": 47.326233,
    "longitude": -122.21052,
    "building_number": 2121,
    "street": "Pike St. N.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "2121 Pike St. N.E., Auburn, WA 98002",
    "purchase_date": "8/22/13",
    "purchase_year": 2013,
    "purchase_amount": 127000,
    "assessed_value": 147000,
    "purchase_amount_vs_assessment": -13.60544218,
    "sale_date": "8/6/14",
    "sale_amount": 269000
  },
  {
    "parcel_id": 4027700632,
    "latitude": 47.77072,
    "longitude": -122.27321,
    "building_number": 19547,
    "street": "53rd Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "19547 53rd Ave. N.E., Seattle, WA 98155",
    "purchase_date": "8/23/13",
    "purchase_year": 2013,
    "purchase_amount": 254500,
    "assessed_value": 302000,
    "purchase_amount_vs_assessment": -15.72847682,
    "sale_date": "6/9/14",
    "sale_amount": 475000
  },
  {
    "parcel_id": 8150100120,
    "latitude": 47.531114,
    "longitude": -122.37569,
    "building_number": 7925,
    "street": "34th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "7925 34th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "8/27/13",
    "purchase_year": 2013,
    "purchase_amount": 245000,
    "assessed_value": 233000,
    "purchase_amount_vs_assessment": 5.150214592,
    "sale_date": "4/9/14",
    "sale_amount": 427500
  },
  {
    "parcel_id": 910000068,
    "latitude": 47.765403,
    "longitude": -122.19767,
    "building_number": 18924,
    "street": "107th Ave. N.E.",
    "city": "Bothell",
    "zip": 98011,
    "address": "18924 107th Ave. N.E., Bothell, WA 98011",
    "purchase_date": "8/27/13",
    "purchase_year": 2013,
    "purchase_amount": 280000,
    "assessed_value": 290000,
    "purchase_amount_vs_assessment": -3.448275862,
    "sale_date": "1/21/14",
    "sale_amount": 460000
  },
  {
    "parcel_id": 9151600145,
    "latitude": 47.585984,
    "longitude": -122.38341,
    "building_number": 1926,
    "street": "41st Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "1926 41st Ave. S.W., Seattle, WA 98116",
    "purchase_date": "8/30/13",
    "purchase_year": 2013,
    "purchase_amount": 150000,
    "assessed_value": 324000,
    "purchase_amount_vs_assessment": -53.7037037,
    "sale_date": "12/3/14",
    "sale_amount": 1250000
  },
  {
    "parcel_id": 4174600115,
    "latitude": 47.558674,
    "longitude": -122.29879,
    "building_number": 2614,
    "street": "S. Ferdinand St.",
    "city": "Seattle",
    "zip": 98108,
    "address": "2614 S. Ferdinand St., Seattle, WA 98108",
    "purchase_date": "9/6/13",
    "purchase_year": 2013,
    "purchase_amount": 325000,
    "assessed_value": 194000,
    "purchase_amount_vs_assessment": 67.5257732,
    "sale_date": "9/23/15",
    "sale_amount": 819950
  },
  {
    "parcel_id": 1899400365,
    "latitude": 47.468294,
    "longitude": -122.34843,
    "building_number": 1029,
    "street": "S.W. 150th St.",
    "city": "Seattle",
    "zip": 98166,
    "address": "1029 S.W. 150th St., Seattle, WA 98166",
    "purchase_date": "9/18/13",
    "purchase_year": 2013,
    "purchase_amount": 160000,
    "assessed_value": 123500,
    "purchase_amount_vs_assessment": 29.55465587,
    "sale_date": "6/20/14",
    "sale_amount": 332000
  },
  {
    "parcel_id": 1795500090,
    "latitude": 47.36359,
    "longitude": -122.11601,
    "building_number": 26455,
    "street": "170th Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "26455 170th Ave. S.E., Kent, WA 98042",
    "purchase_date": "9/23/13",
    "purchase_year": 2013,
    "purchase_amount": 100000,
    "assessed_value": 141000,
    "purchase_amount_vs_assessment": -29.07801418,
    "sale_date": "10/8/13",
    "sale_amount": 0
  },
  {
    "parcel_id": 6671900130,
    "latitude": 47.739968,
    "longitude": -122.34289,
    "building_number": 15313,
    "street": "Stone Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "15313 Stone Ave. N., Seattle, WA 98133",
    "purchase_date": "9/27/13",
    "purchase_year": 2013,
    "purchase_amount": 275000,
    "assessed_value": 259000,
    "purchase_amount_vs_assessment": 6.177606178,
    "sale_date": "12/16/14",
    "sale_amount": 370000
  },
  {
    "parcel_id": 1189000290,
    "latitude": 47.6139917,
    "longitude": -122.2981215,
    "building_number": 2803,
    "street": "E. Pike St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "2803 E. Pike St., Seattle, WA 98122",
    "purchase_date": "10/1/13",
    "purchase_year": 2013,
    "purchase_amount": 145000,
    "assessed_value": 194000,
    "purchase_amount_vs_assessment": -25.25773196,
    "sale_date": "10/1/14",
    "sale_amount": 799000
  },
  {
    "parcel_id": 3793700210,
    "latitude": 47.48178,
    "longitude": -122.09429,
    "building_number": 18430,
    "street": "S.E. 135th St.",
    "city": "Renton",
    "zip": 98059,
    "address": "18430 S.E. 135th St., Renton, WA 98059",
    "purchase_date": "10/1/13",
    "purchase_year": 2013,
    "purchase_amount": 185000,
    "assessed_value": 206000,
    "purchase_amount_vs_assessment": -10.19417476,
    "sale_date": "6/13/14",
    "sale_amount": 299000
  },
  {
    "parcel_id": 1951600170,
    "latitude": 47.37132,
    "longitude": -122.29699,
    "building_number": 25631,
    "street": "29th Ave. S.",
    "city": "Kent",
    "zip": 98032,
    "address": "25631 29th Ave. S., Kent, WA 98032",
    "purchase_date": "10/3/13",
    "purchase_year": 2013,
    "purchase_amount": 137000,
    "assessed_value": 176000,
    "purchase_amount_vs_assessment": -22.15909091,
    "sale_date": "4/10/14",
    "sale_amount": 214000
  },
  {
    "parcel_id": 2946002140,
    "latitude": 47.41904,
    "longitude": -122.3222,
    "building_number": 922,
    "street": "S. 206th St.",
    "city": "Seattle",
    "zip": 98198,
    "address": "922 S. 206th St., Seattle, WA 98198",
    "purchase_date": "10/9/13",
    "purchase_year": 2013,
    "purchase_amount": 91250,
    "assessed_value": 196000,
    "purchase_amount_vs_assessment": -53.44387755,
    "sale_date": "8/12/14",
    "sale_amount": 279000
  },
  {
    "parcel_id": 6381502065,
    "latitude": 47.72694,
    "longitude": -122.30668,
    "building_number": 2011,
    "street": "N.E. 135th Place",
    "city": "Seattle",
    "zip": 98125,
    "address": "2011 N.E. 135th Place, Seattle, WA 98125",
    "purchase_date": "10/9/13",
    "purchase_year": 2013,
    "purchase_amount": 176000,
    "assessed_value": 242000,
    "purchase_amount_vs_assessment": -27.27272727,
    "sale_date": "2/5/14",
    "sale_amount": 353000
  },
  {
    "parcel_id": 3222069147,
    "latitude": 47.344751,
    "longitude": -122.07296,
    "building_number": 28628,
    "street": "202nd Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "28628 202nd Ave. S.E., Kent, WA 98042",
    "purchase_date": "10/10/13",
    "purchase_year": 2013,
    "purchase_amount": 105000,
    "assessed_value": 216000,
    "purchase_amount_vs_assessment": -51.38888889,
    "sale_date": "2/25/14",
    "sale_amount": 339000
  },
  {
    "parcel_id": 8685300060,
    "latitude": 47.559995,
    "longitude": -122.30073,
    "building_number": 2436,
    "street": "S. Angeline St.",
    "city": "Seattle",
    "zip": 98108,
    "address": "2436 S. Angeline St., Seattle, WA 98108",
    "purchase_date": "10/20/13",
    "purchase_year": 2013,
    "purchase_amount": 275000,
    "assessed_value": 301000,
    "purchase_amount_vs_assessment": -8.637873754,
    "sale_date": "3/24/14",
    "sale_amount": 450000
  },
  {
    "parcel_id": 7972602100,
    "latitude": 47.527446,
    "longitude": -122.34774,
    "building_number": 8426,
    "street": "10th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "8426 10th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "10/30/13",
    "purchase_year": 2013,
    "purchase_amount": 115000,
    "assessed_value": 180000,
    "purchase_amount_vs_assessment": -36.11111111,
    "sale_date": "3/5/14",
    "sale_amount": 249950
  },
  {
    "parcel_id": 1450000240,
    "latitude": 47.286608,
    "longitude": -122.22025,
    "building_number": 607,
    "street": "25th St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "607 25th St. S.E., Auburn, WA 98002",
    "purchase_date": "10/30/13",
    "purchase_year": 2013,
    "purchase_amount": 130000,
    "assessed_value": 130000,
    "purchase_amount_vs_assessment": 0,
    "sale_date": "3/18/14",
    "sale_amount": 199950
  },
  {
    "parcel_id": 1450000240,
    "latitude": 47.286608,
    "longitude": -122.22025,
    "building_number": 607,
    "street": "25th St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "607 25th St. S.E., Auburn, WA 98002",
    "purchase_date": "10/30/13",
    "purchase_year": 2013,
    "purchase_amount": 130000,
    "assessed_value": 130000,
    "purchase_amount_vs_assessment": 0,
    "sale_date": "3/18/14",
    "sale_amount": 199950
  },
  {
    "parcel_id": 4112100150,
    "latitude": 47.552438,
    "longitude": -122.26909,
    "building_number": 5117,
    "street": "S. Lucile St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5117 S. Lucile St., Seattle, WA 98118",
    "purchase_date": "10/31/13",
    "purchase_year": 2013,
    "purchase_amount": 225000,
    "assessed_value": 259000,
    "purchase_amount_vs_assessment": -13.12741313,
    "sale_date": "5/13/14",
    "sale_amount": 465000
  },
  {
    "parcel_id": 3755100540,
    "latitude": 47.720295,
    "longitude": -122.2289,
    "building_number": 13248,
    "street": "85th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13248 85th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "11/5/13",
    "purchase_year": 2013,
    "purchase_amount": 299950,
    "assessed_value": 251000,
    "purchase_amount_vs_assessment": 19.50199203,
    "sale_date": "7/25/14",
    "sale_amount": 431200
  },
  {
    "parcel_id": 8642600170,
    "latitude": 47.397378,
    "longitude": -122.31159,
    "building_number": 22805,
    "street": "Thunderbird Drive S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "22805 Thunderbird Drive S., Seattle, WA 98198",
    "purchase_date": "11/22/13",
    "purchase_year": 2013,
    "purchase_amount": 200000,
    "assessed_value": 224000,
    "purchase_amount_vs_assessment": -10.71428571,
    "sale_date": "10/9/14",
    "sale_amount": 375000
  },
  {
    "parcel_id": 9259900025,
    "latitude": 47.717876,
    "longitude": -122.31635,
    "building_number": 1036,
    "street": "N.E. 123rd St.",
    "city": "Seattle",
    "zip": 98125,
    "address": "1036 N.E. 123rd St., Seattle, WA 98125",
    "purchase_date": "12/5/13",
    "purchase_year": 2013,
    "purchase_amount": 221000,
    "assessed_value": 290000,
    "purchase_amount_vs_assessment": -23.79310345,
    "sale_date": "7/14/14",
    "sale_amount": 430000
  },
  {
    "parcel_id": 5101400862,
    "latitude": 47.691964,
    "longitude": -122.30819,
    "building_number": 1731,
    "street": "N.E. 88th St.",
    "city": "Seattle",
    "zip": 98115,
    "address": "1731 N.E. 88th St., Seattle, WA 98115",
    "purchase_date": "12/17/13",
    "purchase_year": 2013,
    "purchase_amount": 284950,
    "assessed_value": 322000,
    "purchase_amount_vs_assessment": -11.50621118,
    "sale_date": "5/12/14",
    "sale_amount": 499950
  },
  {
    "parcel_id": 6381500065,
    "latitude": 47.732564,
    "longitude": -122.30705,
    "building_number": 14316,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "14316 20th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "1/10/14",
    "purchase_year": 2014,
    "purchase_amount": 242000,
    "assessed_value": 304000,
    "purchase_amount_vs_assessment": -20.39473684,
    "sale_date": "7/29/14",
    "sale_amount": 376500
  },
  {
    "parcel_id": 179001425,
    "latitude": 47.492779,
    "longitude": -122.27374,
    "building_number": 12250,
    "street": "48th Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "12250 48th Ave. S., Seattle, WA 98178",
    "purchase_date": "1/10/14",
    "purchase_year": 2014,
    "purchase_amount": 60000,
    "assessed_value": 92000,
    "purchase_amount_vs_assessment": -34.7826087,
    "sale_date": "10/24/14",
    "sale_amount": 230000
  },
  {
    "parcel_id": 7454000605,
    "latitude": 47.516128,
    "longitude": -122.37421,
    "building_number": 9716,
    "street": "33rd Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "9716 33rd Ave. S.W., Seattle, WA 98126",
    "purchase_date": "1/13/14",
    "purchase_year": 2014,
    "purchase_amount": 156000,
    "assessed_value": 167000,
    "purchase_amount_vs_assessment": -6.586826347,
    "sale_date": "7/10/14",
    "sale_amount": 279000
  },
  {
    "parcel_id": 8944300390,
    "latitude": 47.303672,
    "longitude": -122.36899,
    "building_number": 2659,
    "street": "S.W. 332nd Court",
    "city": "Federal Way",
    "zip": 98023,
    "address": "2659 S.W. 332nd Court, Federal Way, WA 98023",
    "purchase_date": "1/15/14",
    "purchase_year": 2014,
    "purchase_amount": 130000,
    "assessed_value": 138000,
    "purchase_amount_vs_assessment": -5.797101449,
    "sale_date": "4/24/14",
    "sale_amount": 200000
  },
  {
    "parcel_id": 6159400030,
    "latitude": 47.744747,
    "longitude": -122.32808,
    "building_number": 124,
    "street": "N.E. 159th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "124 N.E. 159th St., Seattle, WA 98155",
    "purchase_date": "1/17/14",
    "purchase_year": 2014,
    "purchase_amount": 295000,
    "assessed_value": 242000,
    "purchase_amount_vs_assessment": 21.90082645,
    "sale_date": "10/8/14",
    "sale_amount": 399950
  },
  {
    "parcel_id": 5560000640,
    "latitude": 47.327782,
    "longitude": -122.33742,
    "building_number": 30603,
    "street": "2nd Ave. S.W.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "30603 2nd Ave. S.W., Federal Way, WA 98023",
    "purchase_date": "1/27/14",
    "purchase_year": 2014,
    "purchase_amount": 127500,
    "assessed_value": 140000,
    "purchase_amount_vs_assessment": -8.928571429,
    "sale_date": "6/19/14",
    "sale_amount": 232500
  },
  {
    "parcel_id": 4141800030,
    "latitude": 47.615008,
    "longitude": -122.2884,
    "building_number": 1531,
    "street": "35th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "1531 35th Ave., Seattle, WA 98122",
    "purchase_date": "1/27/14",
    "purchase_year": 2014,
    "purchase_amount": 375000,
    "assessed_value": 471000,
    "purchase_amount_vs_assessment": -20.38216561,
    "sale_date": "10/14/14",
    "sale_amount": 920000
  },
  {
    "parcel_id": 7864500140,
    "latitude": 47.374677,
    "longitude": -122.30561,
    "building_number": 2125,
    "street": "S. 253rd St.",
    "city": "Seattle",
    "zip": 98198,
    "address": "2125 S. 253rd St., Seattle, WA 98198",
    "purchase_date": "2/3/14",
    "purchase_year": 2014,
    "purchase_amount": 105000,
    "assessed_value": 132000,
    "purchase_amount_vs_assessment": -20.45454545,
    "sale_date": "11/7/14",
    "sale_amount": 275000
  },
  {
    "parcel_id": 5451210170,
    "latitude": 47.534087,
    "longitude": -122.22214,
    "building_number": 7560,
    "street": "86th Ave. S.E.",
    "city": "Mercer Island",
    "zip": 98040,
    "address": "7560 86th Ave. S.E., Mercer Island, WA 98040",
    "purchase_date": "2/6/14",
    "purchase_year": 2014,
    "purchase_amount": 335000,
    "assessed_value": 609000,
    "purchase_amount_vs_assessment": -44.99178982,
    "sale_date": "1/28/15",
    "sale_amount": 800000
  },
  {
    "parcel_id": 3392100050,
    "latitude": 47.326607,
    "longitude": -122.33417,
    "building_number": 30635,
    "street": "1st Place S.",
    "city": "Federal Way",
    "zip": 98003,
    "address": "30635 1st Place S., Federal Way, WA 98003",
    "purchase_date": "2/7/14",
    "purchase_year": 2014,
    "purchase_amount": 125000,
    "assessed_value": 134000,
    "purchase_amount_vs_assessment": -6.71641791,
    "sale_date": "6/25/14",
    "sale_amount": 205000
  },
  {
    "parcel_id": 7385310040,
    "latitude": 47.621753,
    "longitude": -122.15159,
    "building_number": 1302,
    "street": "141st Place N.E.",
    "city": "Bellevue",
    "zip": 98007,
    "address": "1302 141st Place N.E., Bellevue, WA 98007",
    "purchase_date": "2/13/14",
    "purchase_year": 2014,
    "purchase_amount": 410000,
    "assessed_value": 427000,
    "purchase_amount_vs_assessment": -3.981264637,
    "sale_date": "6/5/14",
    "sale_amount": 725000
  },
  {
    "parcel_id": 1431700210,
    "latitude": 47.460695,
    "longitude": -122.17143,
    "building_number": 12627,
    "street": "S.E. 158th St.",
    "city": "Renton",
    "zip": 98058,
    "address": "12627 S.E. 158th St., Renton, WA 98058",
    "purchase_date": "2/14/14",
    "purchase_year": 2014,
    "purchase_amount": 166000,
    "assessed_value": 183000,
    "purchase_amount_vs_assessment": -9.289617486,
    "sale_date": "7/2/14",
    "sale_amount": 305000
  },
  {
    "parcel_id": 3021059155,
    "latitude": 47.281147,
    "longitude": -122.21371,
    "building_number": 3015,
    "street": "M St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "3015 M St. S.E., Auburn, WA 98002",
    "purchase_date": "2/18/14",
    "purchase_year": 2014,
    "purchase_amount": 95000,
    "assessed_value": 134000,
    "purchase_amount_vs_assessment": -29.10447761,
    "sale_date": "11/5/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 1226059105,
    "latitude": 47.756629,
    "longitude": -122.11309,
    "building_number": 17017,
    "street": "N.E. 179th St.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "17017 N.E. 179th St., Woodinville, WA 98072",
    "purchase_date": "2/24/14",
    "purchase_year": 2014,
    "purchase_amount": 315000,
    "assessed_value": 345000,
    "purchase_amount_vs_assessment": -8.695652174,
    "sale_date": "8/27/14",
    "sale_amount": 545000
  },
  {
    "parcel_id": 1422059052,
    "latitude": 47.397891,
    "longitude": -122.13379,
    "building_number": 22655,
    "street": "156th Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "22655 156th Ave. S.E., Kent, WA 98042",
    "purchase_date": "3/27/14",
    "purchase_year": 2014,
    "purchase_amount": 240000,
    "assessed_value": 364000,
    "purchase_amount_vs_assessment": -34.06593407,
    "sale_date": "1/30/17",
    "sale_amount": 300000
  },
  {
    "parcel_id": 3491300082,
    "latitude": 47.685747,
    "longitude": -122.37574,
    "building_number": 7719,
    "street": "Mary Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "7719 Mary Ave. N.W., Seattle, WA 98117",
    "purchase_date": "3/28/14",
    "purchase_year": 2014,
    "purchase_amount": 390000,
    "assessed_value": 461000,
    "purchase_amount_vs_assessment": -15.40130152,
    "sale_date": "1/27/15",
    "sale_amount": 799990
  },
  {
    "parcel_id": 9214900135,
    "latitude": 47.680093,
    "longitude": -122.29611,
    "building_number": 7022,
    "street": "29th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "7022 29th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "3/28/14",
    "purchase_year": 2014,
    "purchase_amount": 325500,
    "assessed_value": 321000,
    "purchase_amount_vs_assessment": 1.401869159,
    "sale_date": "1/15/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 1432701510,
    "latitude": 47.449978,
    "longitude": -122.17499,
    "building_number": 16882,
    "street": "125th Ave. S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "16882 125th Ave. S.E., Renton, WA 98058",
    "purchase_date": "3/28/14",
    "purchase_year": 2014,
    "purchase_amount": 155000,
    "assessed_value": 150000,
    "purchase_amount_vs_assessment": 3.333333333,
    "sale_date": "10/21/14",
    "sale_amount": 249000
  },
  {
    "parcel_id": 1423900580,
    "latitude": 47.45261,
    "longitude": -122.1765,
    "building_number": 12324,
    "street": "S.E. 168th St.",
    "city": "Renton",
    "zip": 98058,
    "address": "12324 S.E. 168th St., Renton, WA 98058",
    "purchase_date": "4/4/14",
    "purchase_year": 2014,
    "purchase_amount": 115000,
    "assessed_value": 178000,
    "purchase_amount_vs_assessment": -35.39325843,
    "sale_date": "6/25/14",
    "sale_amount": 280000
  },
  {
    "parcel_id": 7544800075,
    "latitude": 47.604588,
    "longitude": -122.30297,
    "building_number": 2218,
    "street": "E. Alder St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "2218 E. Alder St., Seattle, WA 98122",
    "purchase_date": "4/7/14",
    "purchase_year": 2014,
    "purchase_amount": 72000,
    "assessed_value": 76000,
    "purchase_amount_vs_assessment": -5.263157895,
    "sale_date": "6/23/16",
    "sale_amount": 655000
  },
  {
    "parcel_id": 7544800065,
    "latitude": 47.604603,
    "longitude": -122.3032,
    "building_number": 2210,
    "street": "E. Alder St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "2210 E. Alder St., Seattle, WA 98122",
    "purchase_date": "4/7/14",
    "purchase_year": 2014,
    "purchase_amount": 72000,
    "assessed_value": 76000,
    "purchase_amount_vs_assessment": -5.263157895,
    "sale_date": "6/17/16",
    "sale_amount": 669950
  },
  {
    "parcel_id": 3423049307,
    "latitude": 47.43916,
    "longitude": -122.27641,
    "building_number": 18219,
    "street": "46th Place S.",
    "city": "Seattle",
    "zip": 98188,
    "address": "18219 46th Place S., Seattle, WA 98188",
    "purchase_date": "4/8/14",
    "purchase_year": 2014,
    "purchase_amount": 221000,
    "assessed_value": 200000,
    "purchase_amount_vs_assessment": 10.5,
    "sale_date": "7/25/14",
    "sale_amount": 325000
  },
  {
    "parcel_id": 3391900130,
    "latitude": 47.328197,
    "longitude": -122.3325,
    "building_number": 30432,
    "street": "2nd Ave. S.",
    "city": "Federal Way",
    "zip": 98003,
    "address": "30432 2nd Ave. S., Federal Way, WA 98003",
    "purchase_date": "4/10/14",
    "purchase_year": 2014,
    "purchase_amount": 140250,
    "assessed_value": 175000,
    "purchase_amount_vs_assessment": -19.85714286,
    "sale_date": "9/3/14",
    "sale_amount": 258750
  },
  {
    "parcel_id": 4174600121,
    "latitude": 47.559008,
    "longitude": -122.29911,
    "building_number": 2602,
    "street": "S. Ferdinand St.",
    "city": "Seattle",
    "zip": 98108,
    "address": "2602 S. Ferdinand St., Seattle, WA 98108",
    "purchase_date": "4/10/14",
    "purchase_year": 2014,
    "purchase_amount": 150000,
    "assessed_value": 64000,
    "purchase_amount_vs_assessment": 134.375,
    "sale_date": "6/16/15",
    "sale_amount": 789979
  },
  {
    "parcel_id": 3832200070,
    "latitude": 47.374487,
    "longitude": -122.27453,
    "building_number": 4656,
    "street": "S. 254th St.",
    "city": "Kent",
    "zip": 98032,
    "address": "4656 S. 254th St., Kent, WA 98032",
    "purchase_date": "4/14/14",
    "purchase_year": 2014,
    "purchase_amount": 182000,
    "assessed_value": 182000,
    "purchase_amount_vs_assessment": 0,
    "sale_date": "12/22/14",
    "sale_amount": 250000
  },
  {
    "parcel_id": 1421039067,
    "latitude": 47.302113,
    "longitude": -122.3878,
    "building_number": 33417,
    "street": "43rd Ave. S.W.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "33417 43rd Ave. S.W., Federal Way, WA 98023",
    "purchase_date": "4/14/14",
    "purchase_year": 2014,
    "purchase_amount": 111350,
    "assessed_value": 168000,
    "purchase_amount_vs_assessment": -33.7202381,
    "sale_date": "4/24/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 100600320,
    "latitude": 47.301776,
    "longitude": -122.36923,
    "building_number": 2686,
    "street": "S.W. 334th Place",
    "city": "Federal Way",
    "zip": 98023,
    "address": "2686 S.W. 334th Place, Federal Way, WA 98023",
    "purchase_date": "4/21/14",
    "purchase_year": 2014,
    "purchase_amount": 110000,
    "assessed_value": 146000,
    "purchase_amount_vs_assessment": -24.65753425,
    "sale_date": "6/10/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 1900000060,
    "latitude": 47.469255,
    "longitude": -122.34937,
    "building_number": 1051,
    "street": "S.W. 149th St.",
    "city": "Seattle",
    "zip": 98166,
    "address": "1051 S.W. 149th St., Seattle, WA 98166",
    "purchase_date": "4/22/14",
    "purchase_year": 2014,
    "purchase_amount": 180000,
    "assessed_value": 249000,
    "purchase_amount_vs_assessment": -27.71084337,
    "sale_date": "9/11/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 3331500650,
    "latitude": 47.552404,
    "longitude": -122.27036,
    "building_number": 4853,
    "street": "S. Lucile St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4853 S. Lucile St., Seattle, WA 98118",
    "purchase_date": "5/5/14",
    "purchase_year": 2014,
    "purchase_amount": 185000,
    "assessed_value": 192000,
    "purchase_amount_vs_assessment": -3.645833333,
    "sale_date": "9/19/14",
    "sale_amount": 356000
  },
  {
    "parcel_id": 9206200170,
    "latitude": 47.719331,
    "longitude": -122.19607,
    "building_number": 13229,
    "street": "109th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13229 109th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "5/5/14",
    "purchase_year": 2014,
    "purchase_amount": 280000,
    "assessed_value": 267000,
    "purchase_amount_vs_assessment": 4.868913858,
    "sale_date": "8/18/14",
    "sale_amount": 434000
  },
  {
    "parcel_id": 3500100200,
    "latitude": 47.735433,
    "longitude": -122.30168,
    "building_number": 2503,
    "street": "N.E. 147th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "2503 N.E. 147th St., Seattle, WA 98155",
    "purchase_date": "5/7/14",
    "purchase_year": 2014,
    "purchase_amount": 242000,
    "assessed_value": 271000,
    "purchase_amount_vs_assessment": -10.70110701,
    "sale_date": "10/7/14",
    "sale_amount": 425000
  },
  {
    "parcel_id": 8651443420,
    "latitude": 47.366019,
    "longitude": -122.0928,
    "building_number": 26309,
    "street": "187th Court S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "26309 187th Court S.E., Kent, WA 98042",
    "purchase_date": "5/15/14",
    "purchase_year": 2014,
    "purchase_amount": 131250,
    "assessed_value": 173000,
    "purchase_amount_vs_assessment": -24.13294798,
    "sale_date": "10/17/14",
    "sale_amount": 280000
  },
  {
    "parcel_id": 826069067,
    "latitude": 47.754478,
    "longitude": -122.06599,
    "building_number": 20415,
    "street": "N.E. Woodinville Duvall Road",
    "city": "Woodinville",
    "zip": 98077,
    "address": "20415 N.E. Woodinville Duvall Road, Woodinville, WA 98077",
    "purchase_date": "5/21/14",
    "purchase_year": 2014,
    "purchase_amount": 215000,
    "assessed_value": 276000,
    "purchase_amount_vs_assessment": -22.10144928,
    "sale_date": "11/5/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 2968800626,
    "latitude": 47.458869,
    "longitude": -122.35282,
    "building_number": 16023,
    "street": "14th Ave. S.W.",
    "city": "Seattle",
    "zip": 98166,
    "address": "16023 14th Ave. S.W., Seattle, WA 98166",
    "purchase_date": "5/21/14",
    "purchase_year": 2014,
    "purchase_amount": 235000,
    "assessed_value": 242000,
    "purchase_amount_vs_assessment": -2.892561983,
    "sale_date": "8/22/14",
    "sale_amount": 355000
  },
  {
    "parcel_id": 1202000200,
    "latitude": 47.304829,
    "longitude": -122.21775,
    "building_number": 311,
    "street": "J St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "311 J St. S.E., Auburn, WA 98002",
    "purchase_date": "5/23/14",
    "purchase_year": 2014,
    "purchase_amount": 100000,
    "assessed_value": 128000,
    "purchase_amount_vs_assessment": -21.875,
    "sale_date": "11/3/14",
    "sale_amount": 233000
  },
  {
    "parcel_id": 426049051,
    "latitude": 47.774271,
    "longitude": -122.30325,
    "building_number": 20007,
    "street": "25th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "20007 25th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "5/31/14",
    "purchase_year": 2014,
    "purchase_amount": 265000,
    "assessed_value": 314000,
    "purchase_amount_vs_assessment": -15.60509554,
    "sale_date": "12/11/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 726059047,
    "latitude": 47.760977,
    "longitude": -122.21423,
    "building_number": 18306,
    "street": "94th Ave. N.E.",
    "city": "Bothell",
    "zip": 98011,
    "address": "18306 94th Ave. N.E., Bothell, WA 98011",
    "purchase_date": "6/6/14",
    "purchase_year": 2014,
    "purchase_amount": 165000,
    "assessed_value": 226000,
    "purchase_amount_vs_assessment": -26.99115044,
    "sale_date": "12/16/14",
    "sale_amount": 310000
  },
  {
    "parcel_id": 2767700730,
    "latitude": 47.66923,
    "longitude": -122.38157,
    "building_number": 1765,
    "street": "N.W. 56th St.",
    "city": "Seattle",
    "zip": 98107,
    "address": "1765 N.W. 56th St., Seattle, WA 98107",
    "purchase_date": "6/13/14",
    "purchase_year": 2014,
    "purchase_amount": 1000000,
    "assessed_value": 953800,
    "purchase_amount_vs_assessment": 4.843782764
  },
  {
    "parcel_id": 7387500195,
    "latitude": 47.518453,
    "longitude": -122.36296,
    "building_number": 9422,
    "street": "24th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9422 24th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "6/19/14",
    "purchase_year": 2014,
    "purchase_amount": 200100,
    "assessed_value": 208000,
    "purchase_amount_vs_assessment": -3.798076923,
    "sale_date": "9/19/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 7972601445,
    "latitude": 47.529591,
    "longitude": -122.34205,
    "building_number": 8115,
    "street": "5th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "8115 5th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "6/24/14",
    "purchase_year": 2014,
    "purchase_amount": 329000,
    "assessed_value": 405000,
    "purchase_amount_vs_assessment": -18.7654321,
    "sale_date": "1/16/15",
    "sale_amount": 465000
  },
  {
    "parcel_id": 303000220,
    "latitude": 47.326352,
    "longitude": -122.26225,
    "building_number": 5703,
    "street": "S. 307th St.",
    "city": "Auburn",
    "zip": 98001,
    "address": "5703 S. 307th St., Auburn, WA 98001",
    "purchase_date": "6/24/14",
    "purchase_year": 2014,
    "purchase_amount": 164300,
    "assessed_value": 200000,
    "purchase_amount_vs_assessment": -17.85,
    "sale_date": "4/21/15",
    "sale_amount": 375000
  },
  {
    "parcel_id": 9238500040,
    "latitude": 47.773519,
    "longitude": -122.13299,
    "building_number": 15351,
    "street": "N.E. 202nd St.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "15351 N.E. 202nd St., Woodinville, WA 98072",
    "purchase_date": "6/24/14",
    "purchase_year": 2014,
    "purchase_amount": 400000,
    "assessed_value": 355000,
    "purchase_amount_vs_assessment": 12.67605634,
    "sale_date": "2/10/15",
    "sale_amount": 599000
  },
  {
    "parcel_id": 2568300045,
    "latitude": 47.703745,
    "longitude": -122.29634,
    "building_number": 2754,
    "street": "N.E. 103rd St.",
    "city": "Seattle",
    "zip": 98125,
    "address": "2754 N.E. 103rd St., Seattle, WA 98125",
    "purchase_date": "6/25/14",
    "purchase_year": 2014,
    "purchase_amount": 305000,
    "assessed_value": 404000,
    "purchase_amount_vs_assessment": -24.5049505,
    "sale_date": "12/17/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 117000310,
    "latitude": 47.583782,
    "longitude": -122.3852,
    "building_number": 2221,
    "street": "42nd Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "2221 42nd Ave. S.W., Seattle, WA 98116",
    "purchase_date": "6/26/14",
    "purchase_year": 2014,
    "purchase_amount": 550000,
    "assessed_value": 109300,
    "purchase_amount_vs_assessment": 403.2021958,
    "sale_date": "7/27/15",
    "sale_amount": 799950
  },
  {
    "parcel_id": 117000305,
    "latitude": 47.583401,
    "longitude": -122.3854,
    "building_number": 2217,
    "street": "42nd Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "2217 42nd Ave. S.W., Seattle, WA 98116",
    "purchase_date": "6/26/14",
    "purchase_year": 2014,
    "purchase_amount": 550000,
    "assessed_value": 589700,
    "purchase_amount_vs_assessment": -6.732236731
  },
  {
    "parcel_id": 5153200411,
    "latitude": 47.332034,
    "longitude": -122.34799,
    "building_number": 30041,
    "street": "10th Ave. S.W.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "30041 10th Ave. S.W., Federal Way, WA 98023",
    "purchase_date": "7/3/14",
    "purchase_year": 2014,
    "purchase_amount": 238000,
    "assessed_value": 272000,
    "purchase_amount_vs_assessment": -12.5,
    "sale_date": "12/3/15",
    "sale_amount": 437500
  },
  {
    "parcel_id": 1450100330,
    "latitude": 47.288781,
    "longitude": -122.22055,
    "building_number": 605,
    "street": "22nd St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "605 22nd St. S.E., Auburn, WA 98002",
    "purchase_date": "7/16/14",
    "purchase_year": 2014,
    "purchase_amount": 100000,
    "assessed_value": 131000,
    "purchase_amount_vs_assessment": -23.66412214,
    "sale_date": "3/12/15",
    "sale_amount": 237950
  },
  {
    "parcel_id": 7686202065,
    "latitude": 47.422224,
    "longitude": -122.31755,
    "building_number": 1232,
    "street": "S. 201st St.",
    "city": "Seattle",
    "zip": 98198,
    "address": "1232 S. 201st St., Seattle, WA 98198",
    "purchase_date": "7/23/14",
    "purchase_year": 2014,
    "purchase_amount": 170000,
    "assessed_value": 198000,
    "purchase_amount_vs_assessment": -14.14141414,
    "sale_date": "3/4/15",
    "sale_amount": 276000
  },
  {
    "parcel_id": 3526039116,
    "latitude": 47.692484,
    "longitude": -122.3879,
    "building_number": 8705,
    "street": "24th Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "8705 24th Ave. N.W., Seattle, WA 98117",
    "purchase_date": "7/24/14",
    "purchase_year": 2014,
    "purchase_amount": 305000,
    "assessed_value": 364000,
    "purchase_amount_vs_assessment": -16.20879121,
    "sale_date": "11/18/14",
    "sale_amount": 549000
  },
  {
    "parcel_id": 3303230320,
    "latitude": 47.727889,
    "longitude": -122.19545,
    "building_number": 10830,
    "street": "N.E. 141st Place",
    "city": "Kirkland",
    "zip": 98034,
    "address": "10830 N.E. 141st Place, Kirkland, WA 98034",
    "purchase_date": "7/28/14",
    "purchase_year": 2014,
    "purchase_amount": 290000,
    "assessed_value": 261000,
    "purchase_amount_vs_assessment": 11.11111111,
    "sale_date": "3/24/15",
    "sale_amount": 422000
  },
  {
    "parcel_id": 9103000355,
    "latitude": 47.618562,
    "longitude": -122.28739,
    "building_number": 3602,
    "street": "E. Denny Way",
    "city": "Seattle",
    "zip": 98122,
    "address": "3602 E. Denny Way, Seattle, WA 98122",
    "purchase_date": "7/29/14",
    "purchase_year": 2014,
    "purchase_amount": 462000,
    "assessed_value": 405000,
    "purchase_amount_vs_assessment": 14.07407407,
    "sale_date": "6/23/15",
    "sale_amount": 950000
  },
  {
    "parcel_id": 3438502066,
    "latitude": 47.545671,
    "longitude": -122.36286,
    "building_number": 6329,
    "street": "23rd Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "6329 23rd Ave. S.W., Seattle, WA 98106",
    "purchase_date": "7/31/14",
    "purchase_year": 2014,
    "purchase_amount": 170000,
    "assessed_value": 226000,
    "purchase_amount_vs_assessment": -24.77876106,
    "sale_date": "4/8/15",
    "sale_amount": 229000
  },
  {
    "parcel_id": 2561340020,
    "latitude": 47.617014,
    "longitude": -122.05146,
    "building_number": 811,
    "street": "216th Place N.E.",
    "city": "Sammamish",
    "zip": 98074,
    "address": "811 216th Place N.E., Sammamish, WA 98074",
    "purchase_date": "8/4/14",
    "purchase_year": 2014,
    "purchase_amount": 325000,
    "assessed_value": 305000,
    "purchase_amount_vs_assessment": 6.557377049,
    "sale_date": "2/16/15",
    "sale_amount": 500000
  },
  {
    "parcel_id": 5207200500,
    "latitude": 47.695059,
    "longitude": -122.27713,
    "building_number": 9122,
    "street": "Matthews Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9122 Matthews Ave. N.E., Seattle, WA 98115",
    "purchase_date": "8/13/14",
    "purchase_year": 2014,
    "purchase_amount": 285000,
    "assessed_value": 302000,
    "purchase_amount_vs_assessment": -5.629139073,
    "sale_date": "7/15/15",
    "sale_amount": 770000
  },
  {
    "parcel_id": 3025059136,
    "latitude": 47.629407,
    "longitude": -122.21481,
    "building_number": 2112,
    "street": "94th Ave. N.E.",
    "city": "Bellevue",
    "zip": 98004,
    "address": "2112 94th Ave. N.E., Bellevue, WA 98004",
    "purchase_date": "8/13/14",
    "purchase_year": 2014,
    "purchase_amount": 800000,
    "assessed_value": 664000,
    "purchase_amount_vs_assessment": 20.48192771,
    "sale_date": "9/30/15",
    "sale_amount": 1400000
  },
  {
    "parcel_id": 3293700496,
    "latitude": 47.748091,
    "longitude": -122.3554,
    "building_number": 16312,
    "street": "Greenwood Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "16312 Greenwood Ave. N., Seattle, WA 98133",
    "purchase_date": "8/14/14",
    "purchase_year": 2014,
    "purchase_amount": 270000,
    "assessed_value": 268000,
    "purchase_amount_vs_assessment": 0.7462686567,
    "sale_date": "8/18/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 123039313,
    "latitude": 47.515295,
    "longitude": -122.36967,
    "building_number": 9811,
    "street": "28th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "9811 28th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "8/18/14",
    "purchase_year": 2014,
    "purchase_amount": 245000,
    "assessed_value": 175000,
    "purchase_amount_vs_assessment": 40,
    "sale_date": "4/10/15",
    "sale_amount": 425000
  },
  {
    "parcel_id": 3832500790,
    "latitude": 47.366602,
    "longitude": -122.28781,
    "building_number": 3516,
    "street": "S. 262nd St.",
    "city": "Kent",
    "zip": 98032,
    "address": "3516 S. 262nd St., Kent, WA 98032",
    "purchase_date": "8/24/14",
    "purchase_year": 2014,
    "purchase_amount": 180000,
    "assessed_value": 184000,
    "purchase_amount_vs_assessment": -2.173913043,
    "sale_date": "4/20/15",
    "sale_amount": 309000
  },
  {
    "parcel_id": 6381500170,
    "latitude": 47.733197,
    "longitude": -122.305,
    "building_number": 14323,
    "street": "23rd Place N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "14323 23rd Place N.E., Seattle, WA 98125",
    "purchase_date": "8/26/14",
    "purchase_year": 2014,
    "purchase_amount": 235000,
    "assessed_value": 230000,
    "purchase_amount_vs_assessment": 2.173913043,
    "sale_date": "1/16/15",
    "sale_amount": 365000
  },
  {
    "parcel_id": 823000070,
    "latitude": 47.595567,
    "longitude": -122.29172,
    "building_number": 803,
    "street": "32nd Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "803 32nd Ave. S., Seattle, WA 98144",
    "purchase_date": "8/27/14",
    "purchase_year": 2014,
    "purchase_amount": 535000,
    "assessed_value": 535000,
    "purchase_amount_vs_assessment": 0,
    "sale_date": "10/15/15",
    "sale_amount": 1299999
  },
  {
    "parcel_id": 2594200375,
    "latitude": 47.514198,
    "longitude": -122.38899,
    "building_number": 9855,
    "street": "44th Ave. S.W.",
    "city": "Seattle",
    "zip": 98136,
    "address": "9855 44th Ave. S.W., Seattle, WA 98136",
    "purchase_date": "9/11/14",
    "purchase_year": 2014,
    "purchase_amount": 185000,
    "assessed_value": 251000,
    "purchase_amount_vs_assessment": -26.29482072,
    "sale_date": "3/30/15",
    "sale_amount": 427500
  },
  {
    "parcel_id": 2138800060,
    "latitude": 47.735433,
    "longitude": -122.34327,
    "building_number": 1140,
    "street": "N. 146th Place",
    "city": "Seattle",
    "zip": 98133,
    "address": "1140 N. 146th Place, Seattle, WA 98133",
    "purchase_date": "9/15/14",
    "purchase_year": 2014,
    "purchase_amount": 280000,
    "assessed_value": 272000,
    "purchase_amount_vs_assessment": 2.941176471,
    "sale_date": "12/17/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 421000055,
    "latitude": 47.494041,
    "longitude": -122.16894,
    "building_number": 675,
    "street": "Redmond Ave. N.E.",
    "city": "Renton",
    "zip": 98056,
    "address": "675 Redmond Ave. N.E., Renton, WA 98056",
    "purchase_date": "9/18/14",
    "purchase_year": 2014,
    "purchase_amount": 187500,
    "assessed_value": 145000,
    "purchase_amount_vs_assessment": 29.31034483
  },
  {
    "parcel_id": 6198400218,
    "latitude": 47.433801,
    "longitude": -122.18279,
    "building_number": 11823,
    "street": "S.E. 188th St.",
    "city": "Renton",
    "zip": 98058,
    "address": "11823 S.E. 188th St., Renton, WA 98058",
    "purchase_date": "9/19/14",
    "purchase_year": 2014,
    "purchase_amount": 95000,
    "assessed_value": 191000,
    "purchase_amount_vs_assessment": -50.2617801,
    "sale_date": "8/11/16",
    "sale_amount": 290000
  },
  {
    "parcel_id": 8568700015,
    "latitude": 47.743358,
    "longitude": -122.24181,
    "building_number": 15810,
    "street": "74th Ave. N.E.",
    "city": "Kenmore",
    "zip": 98028,
    "address": "15810 74th Ave. N.E., Kenmore, WA 98028",
    "purchase_date": "9/22/14",
    "purchase_year": 2014,
    "purchase_amount": 275000,
    "assessed_value": 231000,
    "purchase_amount_vs_assessment": 19.04761905,
    "sale_date": "4/23/15",
    "sale_amount": 446000
  },
  {
    "parcel_id": 7230400400,
    "latitude": 47.471204,
    "longitude": -122.09952,
    "building_number": 14607,
    "street": "182nd Ave. S.E.",
    "city": "Renton",
    "zip": 98059,
    "address": "14607 182nd Ave. S.E., Renton, WA 98059",
    "purchase_date": "9/26/14",
    "purchase_year": 2014,
    "purchase_amount": 240000,
    "assessed_value": 245000,
    "purchase_amount_vs_assessment": -2.040816327,
    "sale_date": "3/26/15",
    "sale_amount": 415500
  },
  {
    "parcel_id": 7340600620,
    "latitude": 47.48911,
    "longitude": -122.2898,
    "building_number": 12630,
    "street": "34th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "12630 34th Ave. S., Seattle, WA 98168",
    "purchase_date": "9/29/14",
    "purchase_year": 2014,
    "purchase_amount": 74850,
    "assessed_value": 103000,
    "purchase_amount_vs_assessment": -27.33009709,
    "sale_date": "10/23/15",
    "sale_amount": 322000
  },
  {
    "parcel_id": 2421039055,
    "latitude": 47.293041,
    "longitude": -122.37601,
    "building_number": 3401,
    "street": "S.W. 344th St.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "3401 S.W. 344th St., Federal Way, WA 98023",
    "purchase_date": "10/1/14",
    "purchase_year": 2014,
    "purchase_amount": 130000,
    "assessed_value": 124900,
    "purchase_amount_vs_assessment": 4.083266613
  },
  {
    "parcel_id": 2231500030,
    "latitude": 47.771129,
    "longitude": -122.34137,
    "building_number": 1309,
    "street": "N. 196th St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "1309 N. 196th St., Seattle, WA 98133",
    "purchase_date": "10/1/14",
    "purchase_year": 2014,
    "purchase_amount": 315000,
    "assessed_value": 244000,
    "purchase_amount_vs_assessment": 29.09836066,
    "sale_date": "3/24/15",
    "sale_amount": 530000
  },
  {
    "parcel_id": 8857600780,
    "latitude": 47.383865,
    "longitude": -122.28836,
    "building_number": 24314,
    "street": "35th Ave. S.",
    "city": "Kent",
    "zip": 98032,
    "address": "24314 35th Ave. S., Kent, WA 98032",
    "purchase_date": "10/3/14",
    "purchase_year": 2014,
    "purchase_amount": 158550,
    "assessed_value": 170000,
    "purchase_amount_vs_assessment": -6.735294118,
    "sale_date": "7/13/15",
    "sale_amount": 325000
  },
  {
    "parcel_id": 9407102490,
    "latitude": 47.441729,
    "longitude": -121.77112,
    "building_number": 42739,
    "street": "S.E. 175th Place",
    "city": "North Bend",
    "zip": 98045,
    "address": "42739 S.E. 175th Place, North Bend, WA 98045",
    "purchase_date": "10/13/14",
    "purchase_year": 2014,
    "purchase_amount": 178500,
    "assessed_value": 179000,
    "purchase_amount_vs_assessment": -0.2793296089,
    "sale_date": "6/12/15",
    "sale_amount": 305000
  },
  {
    "parcel_id": 6669020290,
    "latitude": 47.373123,
    "longitude": -122.28621,
    "building_number": 3617,
    "street": "S. 254th Place",
    "city": "Kent",
    "zip": 98032,
    "address": "3617 S. 254th Place, Kent, WA 98032",
    "purchase_date": "10/23/14",
    "purchase_year": 2014,
    "purchase_amount": 169000,
    "assessed_value": 184000,
    "purchase_amount_vs_assessment": -8.152173913,
    "sale_date": "3/4/15",
    "sale_amount": 279950
  },
  {
    "parcel_id": 4154300505,
    "latitude": 47.560886,
    "longitude": -122.27922,
    "building_number": 4626,
    "street": "43rd Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4626 43rd Ave. S., Seattle, WA 98118",
    "purchase_date": "10/24/14",
    "purchase_year": 2014,
    "purchase_amount": 315000,
    "assessed_value": 238000,
    "purchase_amount_vs_assessment": 32.35294118,
    "sale_date": "12/17/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 5306100255,
    "latitude": 47.775689,
    "longitude": -122.35022,
    "building_number": 729,
    "street": "N. 202nd St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "729 N. 202nd St., Seattle, WA 98133",
    "purchase_date": "11/5/14",
    "purchase_year": 2014,
    "purchase_amount": 290000,
    "assessed_value": 289000,
    "purchase_amount_vs_assessment": 0.3460207612,
    "sale_date": "12/4/15",
    "sale_amount": 525000
  },
  {
    "parcel_id": 4014400347,
    "latitude": 47.316669,
    "longitude": -122.27604,
    "building_number": 4613,
    "street": "S. 318th St.",
    "city": "Auburn",
    "zip": 98001,
    "address": "4613 S. 318th St., Auburn, WA 98001",
    "purchase_date": "11/5/14",
    "purchase_year": 2014,
    "purchase_amount": 165000,
    "assessed_value": 151000,
    "purchase_amount_vs_assessment": 9.271523179,
    "sale_date": "5/22/15",
    "sale_amount": 315000
  },
  {
    "parcel_id": 3336001316,
    "latitude": 47.524759,
    "longitude": -122.26538,
    "building_number": 8741,
    "street": "Hamlet Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "8741 Hamlet Ave. S., Seattle, WA 98118",
    "purchase_date": "11/6/14",
    "purchase_year": 2014,
    "purchase_amount": 160000,
    "assessed_value": 176000,
    "purchase_amount_vs_assessment": -9.090909091,
    "sale_date": "7/22/15",
    "sale_amount": 459950
  },
  {
    "parcel_id": 2917200475,
    "latitude": 47.700494,
    "longitude": -122.35155,
    "building_number": 9729,
    "street": "Evanston Ave. N.",
    "city": "Seattle",
    "zip": 98103,
    "address": "9729 Evanston Ave. N., Seattle, WA 98103",
    "purchase_date": "11/12/14",
    "purchase_year": 2014,
    "purchase_amount": 205000,
    "assessed_value": 274000,
    "purchase_amount_vs_assessment": -25.18248175,
    "sale_date": "3/23/15",
    "sale_amount": 430000
  },
  {
    "parcel_id": 1775800750,
    "latitude": 47.742153,
    "longitude": -122.09907,
    "building_number": 15717,
    "street": "180th Place N.E.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "15717 180th Place N.E., Woodinville, WA 98072",
    "purchase_date": "11/13/14",
    "purchase_year": 2014,
    "purchase_amount": 227000,
    "assessed_value": 199000,
    "purchase_amount_vs_assessment": 14.07035176,
    "sale_date": "2/24/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 1591600676,
    "latitude": 47.502214,
    "longitude": -122.3602,
    "building_number": 11220,
    "street": "21st Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "11220 21st Ave. S.W., Seattle, WA 98146",
    "purchase_date": "11/18/14",
    "purchase_year": 2014,
    "purchase_amount": 138000,
    "assessed_value": 204000,
    "purchase_amount_vs_assessment": -32.35294118,
    "sale_date": "12/12/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 2586800140,
    "latitude": 47.505719,
    "longitude": -122.34755,
    "building_number": 10827,
    "street": "10th Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "10827 10th Ave. S.W., Seattle, WA 98146",
    "purchase_date": "11/18/14",
    "purchase_year": 2014,
    "purchase_amount": 135000,
    "assessed_value": 145000,
    "purchase_amount_vs_assessment": -6.896551724,
    "sale_date": "5/28/15",
    "sale_amount": 314950
  },
  {
    "parcel_id": 4302200025,
    "latitude": 47.525883,
    "longitude": -122.35939,
    "building_number": 8619,
    "street": "20th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "8619 20th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "11/20/14",
    "purchase_year": 2014,
    "purchase_amount": 210000,
    "assessed_value": 199000,
    "purchase_amount_vs_assessment": 5.527638191,
    "sale_date": "5/26/15",
    "sale_amount": 415000
  },
  {
    "parcel_id": 2473410450,
    "latitude": 47.445337,
    "longitude": -122.12849,
    "building_number": 15810,
    "street": "S.E. 175th Place",
    "city": "Renton",
    "zip": 98058,
    "address": "15810 S.E. 175th Place, Renton, WA 98058",
    "purchase_date": "11/20/14",
    "purchase_year": 2014,
    "purchase_amount": 170000,
    "assessed_value": 234000,
    "purchase_amount_vs_assessment": -27.35042735,
    "sale_date": "12/17/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 2970800145,
    "latitude": 47.473778,
    "longitude": -122.34963,
    "building_number": 1123,
    "street": "S.W. 144th St.",
    "city": "Seattle",
    "zip": 98166,
    "address": "1123 S.W. 144th St., Seattle, WA 98166",
    "purchase_date": "11/21/14",
    "purchase_year": 2014,
    "purchase_amount": 195500,
    "assessed_value": 222000,
    "purchase_amount_vs_assessment": -11.93693694,
    "sale_date": "4/7/15",
    "sale_amount": 350500
  },
  {
    "parcel_id": 6668900020,
    "latitude": 47.749029,
    "longitude": -122.31152,
    "building_number": 1539,
    "street": "N.E. 166th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "1539 N.E. 166th St., Seattle, WA 98155",
    "purchase_date": "11/24/14",
    "purchase_year": 2014,
    "purchase_amount": 165000,
    "assessed_value": 217000,
    "purchase_amount_vs_assessment": -23.96313364,
    "sale_date": "3/18/15",
    "sale_amount": 420550
  },
  {
    "parcel_id": 1250200715,
    "latitude": 47.596882,
    "longitude": -122.29827,
    "building_number": 2608,
    "street": "S. Lane St.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2608 S. Lane St., Seattle, WA 98144",
    "purchase_date": "12/2/14",
    "purchase_year": 2014,
    "purchase_amount": 664000,
    "assessed_value": 781000,
    "purchase_amount_vs_assessment": -14.98079385,
    "sale_date": "3/29/18",
    "sale_amount": 2300000
  },
  {
    "parcel_id": 9187200095,
    "latitude": 47.603168,
    "longitude": -122.29626,
    "building_number": 151,
    "street": "28th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "151 28th Ave., Seattle, WA 98122",
    "purchase_date": "12/2/14",
    "purchase_year": 2014,
    "purchase_amount": 432500,
    "assessed_value": 515000,
    "purchase_amount_vs_assessment": -16.01941748,
    "sale_date": "4/28/16",
    "sale_amount": 765000
  },
  {
    "parcel_id": 3320000665,
    "latitude": 47.59682,
    "longitude": -122.30816,
    "building_number": 1816,
    "street": "S. Lane St.",
    "city": "Seattle",
    "zip": 98144,
    "address": "1816 S. Lane St., Seattle, WA 98144",
    "purchase_date": "12/4/14",
    "purchase_year": 2014,
    "purchase_amount": 181500,
    "assessed_value": 156000,
    "purchase_amount_vs_assessment": 16.34615385,
    "sale_date": "9/24/15",
    "sale_amount": 605000
  },
  {
    "parcel_id": 7308900095,
    "latitude": 47.71896,
    "longitude": -122.35792,
    "building_number": 12238,
    "street": "1st Ave. N.W.",
    "city": "Seattle",
    "zip": 98177,
    "address": "12238 1st Ave. N.W., Seattle, WA 98177",
    "purchase_date": "12/5/14",
    "purchase_year": 2014,
    "purchase_amount": 275000,
    "assessed_value": 358000,
    "purchase_amount_vs_assessment": -23.18435754,
    "sale_date": "12/17/14",
    "sale_amount": 0
  },
  {
    "parcel_id": 2144800876,
    "latitude": 47.484387,
    "longitude": -122.22096,
    "building_number": 8825,
    "street": "S. 132nd St.",
    "city": "Renton",
    "zip": 98057,
    "address": "8825 S. 132nd St., Renton, WA 98057",
    "purchase_date": "12/8/14",
    "purchase_year": 2014,
    "purchase_amount": 30000,
    "assessed_value": 142000,
    "purchase_amount_vs_assessment": -78.87323944,
    "sale_date": "12/30/14",
    "sale_amount": 100550
  },
  {
    "parcel_id": 7228500094,
    "latitude": 47.614651,
    "longitude": -122.30234,
    "building_number": 1514,
    "street": "23rd Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "1514 23rd Ave., Seattle, WA 98122",
    "purchase_date": "12/12/14",
    "purchase_year": 2014,
    "purchase_amount": 278000,
    "assessed_value": 280000,
    "purchase_amount_vs_assessment": -0.7142857143
  },
  {
    "parcel_id": 9407000380,
    "latitude": 47.444359,
    "longitude": -121.76626,
    "building_number": 17301,
    "street": "431st Ave. S.E.",
    "city": "North Bend",
    "zip": 98045,
    "address": "17301 431st Ave. S.E., North Bend, WA 98045",
    "purchase_date": "12/24/14",
    "purchase_year": 2014,
    "purchase_amount": 220500,
    "assessed_value": 216000,
    "purchase_amount_vs_assessment": 2.083333333,
    "sale_date": "6/3/15",
    "sale_amount": 352000
  },
  {
    "parcel_id": 2205500030,
    "latitude": 47.576183,
    "longitude": -122.14263,
    "building_number": 3766,
    "street": "148th Ave. S.E.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "3766 148th Ave. S.E., Bellevue, WA 98006",
    "purchase_date": "1/8/15",
    "purchase_year": 2015,
    "purchase_amount": 331500,
    "assessed_value": 381000,
    "purchase_amount_vs_assessment": -12.99212598,
    "sale_date": "5/20/15",
    "sale_amount": 575000
  },
  {
    "parcel_id": 3298700327,
    "latitude": 47.521688,
    "longitude": -122.35088,
    "building_number": 9039,
    "street": "12th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9039 12th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "1/12/15",
    "purchase_year": 2015,
    "purchase_amount": 110000,
    "assessed_value": 97000,
    "purchase_amount_vs_assessment": 13.40206186,
    "sale_date": "5/11/15",
    "sale_amount": 340000
  },
  {
    "parcel_id": 9407110700,
    "latitude": 47.447362,
    "longitude": -121.77088,
    "building_number": 16865,
    "street": "427th Place S.E.",
    "city": "North Bend",
    "zip": 98045,
    "address": "16865 427th Place S.E., North Bend, WA 98045",
    "purchase_date": "1/13/15",
    "purchase_year": 2015,
    "purchase_amount": 175000,
    "assessed_value": 215000,
    "purchase_amount_vs_assessment": -18.60465116,
    "sale_date": "5/28/15",
    "sale_amount": 299950
  },
  {
    "parcel_id": 1922059170,
    "latitude": 47.373833,
    "longitude": -122.21765,
    "building_number": 812,
    "street": "Reiten Road",
    "city": "Kent",
    "zip": 98030,
    "address": "812 Reiten Road, Kent, WA 98030",
    "purchase_date": "1/16/15",
    "purchase_year": 2015,
    "purchase_amount": 140000,
    "assessed_value": 192000,
    "purchase_amount_vs_assessment": -27.08333333,
    "sale_date": "5/1/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 3361401773,
    "latitude": 47.495973,
    "longitude": -122.31393,
    "building_number": 1430,
    "street": "S. 120th St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "1430 S. 120th St., Seattle, WA 98168",
    "purchase_date": "1/22/15",
    "purchase_year": 2015,
    "purchase_amount": 150000,
    "assessed_value": 191000,
    "purchase_amount_vs_assessment": -21.46596859,
    "sale_date": "11/25/15",
    "sale_amount": 330000
  },
  {
    "parcel_id": 1446403145,
    "latitude": 47.4862,
    "longitude": -122.32555,
    "building_number": 13020,
    "street": "6th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "13020 6th Ave. S., Seattle, WA 98168",
    "purchase_date": "1/22/15",
    "purchase_year": 2015,
    "purchase_amount": 170000,
    "assessed_value": 182000,
    "purchase_amount_vs_assessment": -6.593406593,
    "sale_date": "6/29/15",
    "sale_amount": 330000
  },
  {
    "parcel_id": 1446403145,
    "latitude": 47.4862,
    "longitude": -122.32555,
    "building_number": 13020,
    "street": "6th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "13020 6th Ave. S., Seattle, WA 98168",
    "purchase_date": "1/22/15",
    "purchase_year": 2015,
    "purchase_amount": 170000,
    "assessed_value": 182000,
    "purchase_amount_vs_assessment": -6.593406593,
    "sale_date": "6/29/15",
    "sale_amount": 330000
  },
  {
    "parcel_id": 3739500096,
    "latitude": 47.737197,
    "longitude": -122.30714,
    "building_number": 14750,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "14750 20th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "1/26/15",
    "purchase_year": 2015,
    "purchase_amount": 229000,
    "assessed_value": 264000,
    "purchase_amount_vs_assessment": -13.25757576,
    "sale_date": "5/5/15",
    "sale_amount": 430000
  },
  {
    "parcel_id": 3739500096,
    "latitude": 47.737197,
    "longitude": -122.30714,
    "building_number": 14750,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "14750 20th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "1/26/15",
    "purchase_year": 2015,
    "purchase_amount": 229000,
    "assessed_value": 264000,
    "purchase_amount_vs_assessment": -13.25757576,
    "sale_date": "5/5/15",
    "sale_amount": 430000
  },
  {
    "parcel_id": 2570600140,
    "latitude": 47.775797,
    "longitude": -122.23766,
    "building_number": 7619,
    "street": "N.E. 204th Place",
    "city": "Kenmore",
    "zip": 98028,
    "address": "7619 N.E. 204th Place, Kenmore, WA 98028",
    "purchase_date": "1/28/15",
    "purchase_year": 2015,
    "purchase_amount": 196000,
    "assessed_value": 171000,
    "purchase_amount_vs_assessment": 14.61988304,
    "sale_date": "8/13/15",
    "sale_amount": 447000
  },
  {
    "parcel_id": 8058500005,
    "latitude": 47.70685,
    "longitude": -122.29877,
    "building_number": 2718,
    "street": "N.E. 107th St.",
    "city": "Seattle",
    "zip": 98125,
    "address": "2718 N.E. 107th St., Seattle, WA 98125",
    "purchase_date": "2/3/15",
    "purchase_year": 2015,
    "purchase_amount": 290000,
    "assessed_value": 296000,
    "purchase_amount_vs_assessment": -2.027027027,
    "sale_date": "5/26/16",
    "sale_amount": 550000
  },
  {
    "parcel_id": 3034200247,
    "latitude": 47.718652,
    "longitude": -122.33019,
    "building_number": 12257,
    "street": "Corliss Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "12257 Corliss Ave. N., Seattle, WA 98133",
    "purchase_date": "2/6/15",
    "purchase_year": 2015,
    "purchase_amount": 360000,
    "assessed_value": 399000,
    "purchase_amount_vs_assessment": -9.77443609,
    "sale_date": "7/13/15",
    "sale_amount": 605000
  },
  {
    "parcel_id": 88000051,
    "latitude": 47.459546,
    "longitude": -122.18988,
    "building_number": 16010,
    "street": "113th Ave. S.E.",
    "city": "Renton",
    "zip": 98055,
    "address": "16010 113th Ave. S.E., Renton, WA 98055",
    "purchase_date": "2/15/15",
    "purchase_year": 2015,
    "purchase_amount": 140000,
    "assessed_value": 267000,
    "purchase_amount_vs_assessment": -47.56554307,
    "sale_date": "6/29/15",
    "sale_amount": 246000
  },
  {
    "parcel_id": 4402700520,
    "latitude": 47.74258,
    "longitude": -122.33693,
    "building_number": 15540,
    "street": "Wallingford Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "15540 Wallingford Ave. N., Seattle, WA 98133",
    "purchase_date": "2/18/15",
    "purchase_year": 2015,
    "purchase_amount": 241500,
    "assessed_value": 332000,
    "purchase_amount_vs_assessment": -27.25903614,
    "sale_date": "11/18/15",
    "sale_amount": 499950
  },
  {
    "parcel_id": 7016310030,
    "latitude": 47.741919,
    "longitude": -122.18095,
    "building_number": 15714,
    "street": "119th Ave. N.E.",
    "city": "Bothell",
    "zip": 98011,
    "address": "15714 119th Ave. N.E., Bothell, WA 98011",
    "purchase_date": "2/19/15",
    "purchase_year": 2015,
    "purchase_amount": 330000,
    "assessed_value": 350000,
    "purchase_amount_vs_assessment": -5.714285714,
    "sale_date": "11/12/15",
    "sale_amount": 545000
  },
  {
    "parcel_id": 3145600045,
    "latitude": 47.554325,
    "longitude": -122.27509,
    "building_number": 5300,
    "street": "46th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5300 46th Ave. S., Seattle, WA 98118",
    "purchase_date": "2/25/15",
    "purchase_year": 2015,
    "purchase_amount": 302000,
    "assessed_value": 443000,
    "purchase_amount_vs_assessment": -31.82844244,
    "sale_date": "11/17/15",
    "sale_amount": 621000
  },
  {
    "parcel_id": 3343300020,
    "latitude": 47.54263,
    "longitude": -122.18597,
    "building_number": 6651,
    "street": "116th Ave. S.E.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "6651 116th Ave. S.E., Bellevue, WA 98006",
    "purchase_date": "3/4/15",
    "purchase_year": 2015,
    "purchase_amount": 457500,
    "assessed_value": 325000,
    "purchase_amount_vs_assessment": 40.76923077,
    "sale_date": "4/14/15",
    "sale_amount": 485000
  },
  {
    "parcel_id": 4222310120,
    "latitude": 47.347805,
    "longitude": -122.30624,
    "building_number": 2023,
    "street": "S. 282nd Place",
    "city": "Federal Way",
    "zip": 98003,
    "address": "2023 S. 282nd Place, Federal Way, WA 98003",
    "purchase_date": "3/6/15",
    "purchase_year": 2015,
    "purchase_amount": 155000,
    "assessed_value": 198000,
    "purchase_amount_vs_assessment": -21.71717172,
    "sale_date": "9/23/15",
    "sale_amount": 265000
  },
  {
    "parcel_id": 1423200110,
    "latitude": 47.456343,
    "longitude": -122.1843,
    "building_number": 11638,
    "street": "S.E. 164th St.",
    "city": "Renton",
    "zip": 98058,
    "address": "11638 S.E. 164th St., Renton, WA 98058",
    "purchase_date": "3/10/15",
    "purchase_year": 2015,
    "purchase_amount": 112000,
    "assessed_value": 161000,
    "purchase_amount_vs_assessment": -30.43478261,
    "sale_date": "5/13/15",
    "sale_amount": 180000
  },
  {
    "parcel_id": 2061100265,
    "latitude": 47.689255,
    "longitude": -122.32463,
    "building_number": 8231,
    "street": "4th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "8231 4th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "3/17/15",
    "purchase_year": 2015,
    "purchase_amount": 370000,
    "assessed_value": 401000,
    "purchase_amount_vs_assessment": -7.730673317,
    "sale_date": "8/6/15",
    "sale_amount": 672500
  },
  {
    "parcel_id": 1424059130,
    "latitude": 47.567044,
    "longitude": -122.12403,
    "building_number": 16200,
    "street": "S.E. 44th Way",
    "city": "Bellevue",
    "zip": 98006,
    "address": "16200 S.E. 44th Way, Bellevue, WA 98006",
    "purchase_date": "3/18/15",
    "purchase_year": 2015,
    "purchase_amount": 247500,
    "assessed_value": 312000,
    "purchase_amount_vs_assessment": -20.67307692,
    "sale_date": "4/15/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 2201500130,
    "latitude": 47.573338,
    "longitude": -122.14043,
    "building_number": 4025,
    "street": "151st Ave. S.E.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "4025 151st Ave. S.E., Bellevue, WA 98006",
    "purchase_date": "3/27/15",
    "purchase_year": 2015,
    "purchase_amount": 297000,
    "assessed_value": 346000,
    "purchase_amount_vs_assessment": -14.16184971,
    "sale_date": "12/16/15",
    "sale_amount": 555000
  },
  {
    "parcel_id": 3298700686,
    "latitude": 47.519668,
    "longitude": -122.35375,
    "building_number": 9246,
    "street": "15th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9246 15th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "3/30/15",
    "purchase_year": 2015,
    "purchase_amount": 166000,
    "assessed_value": 178000,
    "purchase_amount_vs_assessment": -6.741573034,
    "sale_date": "4/29/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 9113500040,
    "latitude": 47.315769,
    "longitude": -122.083,
    "building_number": 31850,
    "street": "195th Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "31850 195th Ave. S.E., Kent, WA 98042",
    "purchase_date": "4/7/15",
    "purchase_year": 2015,
    "purchase_amount": 222065,
    "assessed_value": 295000,
    "purchase_amount_vs_assessment": -24.72372881,
    "sale_date": "4/27/16",
    "sale_amount": 475000
  },
  {
    "parcel_id": 421049146,
    "latitude": 47.329867,
    "longitude": -122.30765,
    "building_number": 2004,
    "street": "S. 304th St.",
    "city": "Federal Way",
    "zip": 98003,
    "address": "2004 S. 304th St., Federal Way, WA 98003",
    "purchase_date": "4/15/15",
    "purchase_year": 2015,
    "purchase_amount": 173500,
    "assessed_value": 209000,
    "purchase_amount_vs_assessment": -16.98564593,
    "sale_date": "9/24/15",
    "sale_amount": 320000
  },
  {
    "parcel_id": 7211402305,
    "latitude": 47.510467,
    "longitude": -122.35981,
    "building_number": 10247,
    "street": "20th Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "10247 20th Ave. S.W., Seattle, WA 98146",
    "purchase_date": "4/15/15",
    "purchase_year": 2015,
    "purchase_amount": 240000,
    "assessed_value": 199000,
    "purchase_amount_vs_assessment": 20.60301508,
    "sale_date": "10/23/15",
    "sale_amount": 366800
  },
  {
    "parcel_id": 1099600330,
    "latitude": 47.302178,
    "longitude": -122.37679,
    "building_number": 33415,
    "street": "35th Ave. S.W.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "33415 35th Ave. S.W., Federal Way, WA 98023",
    "purchase_date": "4/24/15",
    "purchase_year": 2015,
    "purchase_amount": 180000,
    "assessed_value": 172000,
    "purchase_amount_vs_assessment": 4.651162791,
    "sale_date": "12/31/15",
    "sale_amount": 311950
  },
  {
    "parcel_id": 2610100090,
    "latitude": 47.74154,
    "longitude": -122.32566,
    "building_number": 314,
    "street": "N.E. 155th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "314 N.E. 155th St., Seattle, WA 98155",
    "purchase_date": "4/24/15",
    "purchase_year": 2015,
    "purchase_amount": 238000,
    "assessed_value": 207000,
    "purchase_amount_vs_assessment": 14.97584541,
    "sale_date": "8/25/15",
    "sale_amount": 382000
  },
  {
    "parcel_id": 1865800040,
    "latitude": 47.373284,
    "longitude": -122.1175,
    "building_number": 25417,
    "street": "168th Place S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "25417 168th Place S.E., Kent, WA 98042",
    "purchase_date": "5/11/15",
    "purchase_year": 2015,
    "purchase_amount": 178000,
    "assessed_value": 211000,
    "purchase_amount_vs_assessment": -15.63981043,
    "sale_date": "7/20/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 7893201655,
    "latitude": 47.417782,
    "longitude": -122.32721,
    "building_number": 20622,
    "street": "6th Ave. S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "20622 6th Ave. S., Seattle, WA 98198",
    "purchase_date": "5/11/15",
    "purchase_year": 2015,
    "purchase_amount": 180000,
    "assessed_value": 207000,
    "purchase_amount_vs_assessment": -13.04347826,
    "sale_date": "12/29/15",
    "sale_amount": 345000
  },
  {
    "parcel_id": 1568100715,
    "latitude": 47.736084,
    "longitude": -122.29049,
    "building_number": 3517,
    "street": "N.E. 148th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "3517 N.E. 148th St., Seattle, WA 98155",
    "purchase_date": "5/18/15",
    "purchase_year": 2015,
    "purchase_amount": 470000,
    "assessed_value": 466000,
    "purchase_amount_vs_assessment": 0.8583690987,
    "sale_date": "3/1/17",
    "sale_amount": 702000
  },
  {
    "parcel_id": 3438502380,
    "latitude": 47.540375,
    "longitude": -122.36221,
    "building_number": 6945,
    "street": "23rd Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "6945 23rd Ave. S.W., Seattle, WA 98106",
    "purchase_date": "5/19/15",
    "purchase_year": 2015,
    "purchase_amount": 213000,
    "assessed_value": 257000,
    "purchase_amount_vs_assessment": -17.12062257,
    "sale_date": "6/9/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 255000300,
    "latitude": 47.747439,
    "longitude": -122.17008,
    "building_number": 16500,
    "street": "126th Ave. N.E.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "16500 126th Ave. N.E., Woodinville, WA 98072",
    "purchase_date": "5/19/15",
    "purchase_year": 2015,
    "purchase_amount": 375000,
    "assessed_value": 383000,
    "purchase_amount_vs_assessment": -2.088772846,
    "sale_date": "6/2/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 2660500445,
    "latitude": 47.5557,
    "longitude": -122.28642,
    "building_number": 5045,
    "street": "37th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5045 37th Ave. S., Seattle, WA 98118",
    "purchase_date": "5/21/15",
    "purchase_year": 2015,
    "purchase_amount": 320000,
    "assessed_value": 271000,
    "purchase_amount_vs_assessment": 18.08118081,
    "sale_date": "7/9/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 5418500250,
    "latitude": 47.698809,
    "longitude": -122.28173,
    "building_number": 9547,
    "street": "44th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9547 44th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "5/28/15",
    "purchase_year": 2015,
    "purchase_amount": 507500,
    "assessed_value": 486000,
    "purchase_amount_vs_assessment": 4.423868313,
    "sale_date": "7/28/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 6632300075,
    "latitude": 47.729237,
    "longitude": -122.30762,
    "building_number": 13727,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "13727 20th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "6/4/15",
    "purchase_year": 2015,
    "purchase_amount": 223000,
    "assessed_value": 324000,
    "purchase_amount_vs_assessment": -31.17283951,
    "sale_date": "11/10/15",
    "sale_amount": 510000
  },
  {
    "parcel_id": 6385400025,
    "latitude": 47.525103,
    "longitude": -122.18337,
    "building_number": 8625,
    "street": "118th Ave. S.E.",
    "city": "Renton",
    "zip": 98056,
    "address": "8625 118th Ave. S.E., Renton, WA 98056",
    "purchase_date": "6/8/15",
    "purchase_year": 2015,
    "purchase_amount": 380000,
    "assessed_value": 343000,
    "purchase_amount_vs_assessment": 10.78717201,
    "sale_date": "3/12/16",
    "sale_amount": 615000
  },
  {
    "parcel_id": 6141100360,
    "latitude": 47.717959,
    "longitude": -122.35316,
    "building_number": 422,
    "street": "N. 122nd St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "422 N. 122nd St., Seattle, WA 98133",
    "purchase_date": "6/8/15",
    "purchase_year": 2015,
    "purchase_amount": 361000,
    "assessed_value": 305000,
    "purchase_amount_vs_assessment": 18.36065574,
    "sale_date": "5/12/16",
    "sale_amount": 550000
  },
  {
    "parcel_id": 4075300200,
    "latitude": 47.699007,
    "longitude": -122.27688,
    "building_number": 9551,
    "street": "48th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9551 48th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "6/17/15",
    "purchase_year": 2015,
    "purchase_amount": 450000,
    "assessed_value": 523000,
    "purchase_amount_vs_assessment": -13.95793499,
    "sale_date": "6/17/16",
    "sale_amount": 835000
  },
  {
    "parcel_id": 1596600090,
    "latitude": 47.572124,
    "longitude": -122.30427,
    "building_number": 2102,
    "street": "S. Spokane St.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2102 S. Spokane St., Seattle, WA 98144",
    "purchase_date": "6/17/15",
    "purchase_year": 2015,
    "purchase_amount": 327500,
    "assessed_value": 306000,
    "purchase_amount_vs_assessment": 7.026143791,
    "sale_date": "7/11/16",
    "sale_amount": 720000
  },
  {
    "parcel_id": 2547100065,
    "latitude": 47.670362,
    "longitude": -122.16422,
    "building_number": 13124,
    "street": "N.E. 73rd St.",
    "city": "Kirkland",
    "zip": 98033,
    "address": "13124 N.E. 73rd St., Kirkland, WA 98033",
    "purchase_date": "6/18/15",
    "purchase_year": 2015,
    "purchase_amount": 405900,
    "assessed_value": 259000,
    "purchase_amount_vs_assessment": 56.71814672,
    "sale_date": "11/11/16",
    "sale_amount": 675000
  },
  {
    "parcel_id": 6602500060,
    "latitude": 47.333884,
    "longitude": -122.29716,
    "building_number": 2801,
    "street": "S. 299th Place",
    "city": "Federal Way",
    "zip": 98003,
    "address": "2801 S. 299th Place, Federal Way, WA 98003",
    "purchase_date": "6/30/15",
    "purchase_year": 2015,
    "purchase_amount": 199500,
    "assessed_value": 204000,
    "purchase_amount_vs_assessment": -2.205882353,
    "sale_date": "8/18/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 9212900920,
    "latitude": 47.688811,
    "longitude": -122.29102,
    "building_number": 8232,
    "street": "34th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "8232 34th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "7/2/15",
    "purchase_year": 2015,
    "purchase_amount": 505000,
    "assessed_value": 486000,
    "purchase_amount_vs_assessment": 3.909465021,
    "sale_date": "4/21/16",
    "sale_amount": 870000
  },
  {
    "parcel_id": 2592400150,
    "latitude": 47.716482,
    "longitude": -122.1697,
    "building_number": 12915,
    "street": "129th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "12915 129th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "7/2/15",
    "purchase_year": 2015,
    "purchase_amount": 540000,
    "assessed_value": 330000,
    "purchase_amount_vs_assessment": 63.63636364,
    "sale_date": "10/26/15",
    "sale_amount": 389950
  },
  {
    "parcel_id": 2592400150,
    "latitude": 47.716482,
    "longitude": -122.1697,
    "building_number": 12915,
    "street": "129th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "12915 129th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "7/2/15",
    "purchase_year": 2015,
    "purchase_amount": 540000,
    "assessed_value": 330000,
    "purchase_amount_vs_assessment": 63.63636364,
    "sale_date": "10/26/15",
    "sale_amount": 389950
  },
  {
    "parcel_id": 3026059195,
    "latitude": 47.71425,
    "longitude": -122.21602,
    "building_number": 12615,
    "street": "94th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "12615 94th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "7/2/15",
    "purchase_year": 2015,
    "purchase_amount": 540000,
    "assessed_value": 254000,
    "purchase_amount_vs_assessment": 112.5984252,
    "sale_date": "9/23/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 3052701045,
    "latitude": 47.679366,
    "longitude": -122.37218,
    "building_number": 1203,
    "street": "N.W. 70th St.",
    "city": "Seattle",
    "zip": 98117,
    "address": "1203 N.W. 70th St., Seattle, WA 98117",
    "purchase_date": "7/8/15",
    "purchase_year": 2015,
    "purchase_amount": 501000,
    "assessed_value": 464000,
    "purchase_amount_vs_assessment": 7.974137931,
    "sale_date": "11/15/17",
    "sale_amount": 1035000
  },
  {
    "parcel_id": 6381502115,
    "latitude": 47.728207,
    "longitude": -122.30646,
    "building_number": 2017,
    "street": "N.E. 137th St.",
    "city": "Seattle",
    "zip": 98125,
    "address": "2017 N.E. 137th St., Seattle, WA 98125",
    "purchase_date": "7/10/15",
    "purchase_year": 2015,
    "purchase_amount": 268000,
    "assessed_value": 271000,
    "purchase_amount_vs_assessment": -1.10701107,
    "sale_date": "12/23/15",
    "sale_amount": 399950
  },
  {
    "parcel_id": 4027700633,
    "latitude": 47.770447,
    "longitude": -122.27322,
    "building_number": 19523,
    "street": "53rd Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "19523 53rd Ave. N.E., Seattle, WA 98155",
    "purchase_date": "7/14/15",
    "purchase_year": 2015,
    "purchase_amount": 250000,
    "assessed_value": 333000,
    "purchase_amount_vs_assessment": -24.92492492,
    "sale_date": "3/17/16",
    "sale_amount": 463000
  },
  {
    "parcel_id": 1928300700,
    "latitude": 47.670255,
    "longitude": -122.31896,
    "building_number": 824,
    "street": "N.E. 57th St.",
    "city": "Seattle",
    "zip": 98105,
    "address": "824 N.E. 57th St., Seattle, WA 98105",
    "purchase_date": "7/29/15",
    "purchase_year": 2015,
    "purchase_amount": 350000,
    "assessed_value": 379000,
    "purchase_amount_vs_assessment": -7.65171504
  },
  {
    "parcel_id": 424069060,
    "latitude": 47.588895,
    "longitude": -122.05304,
    "building_number": 21430,
    "street": "S.E. 24th St.",
    "city": "Sammamish",
    "zip": 98075,
    "address": "21430 S.E. 24th St., Sammamish, WA 98075",
    "purchase_date": "7/29/15",
    "purchase_year": 2015,
    "purchase_amount": 364500,
    "assessed_value": 457000,
    "purchase_amount_vs_assessment": -20.24070022,
    "sale_date": "3/24/16",
    "sale_amount": 795000
  },
  {
    "parcel_id": 5652601255,
    "latitude": 47.696255,
    "longitude": -122.29909,
    "building_number": 9217,
    "street": "27th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9217 27th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "7/30/15",
    "purchase_year": 2015,
    "purchase_amount": 407500,
    "assessed_value": 460000,
    "purchase_amount_vs_assessment": -11.41304348,
    "sale_date": "3/26/18",
    "sale_amount": 965000
  },
  {
    "parcel_id": 4036800650,
    "latitude": 47.599931,
    "longitude": -122.12956,
    "building_number": 15661,
    "street": "S.E. 11th St.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "15661 S.E. 11th St., Bellevue, WA 98008",
    "purchase_date": "7/30/15",
    "purchase_year": 2015,
    "purchase_amount": 290000,
    "assessed_value": 302000,
    "purchase_amount_vs_assessment": -3.973509934,
    "sale_date": "6/15/16",
    "sale_amount": 699950
  },
  {
    "parcel_id": 5153000070,
    "latitude": 47.721275,
    "longitude": -122.3593,
    "building_number": 12558,
    "street": "2nd Ave. N.W.",
    "city": "Seattle",
    "zip": 98177,
    "address": "12558 2nd Ave. N.W., Seattle, WA 98177",
    "purchase_date": "8/6/15",
    "purchase_year": 2015,
    "purchase_amount": 395000,
    "assessed_value": 350000,
    "purchase_amount_vs_assessment": 12.85714286,
    "sale_date": "8/20/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 5550300238,
    "latitude": 47.529265,
    "longitude": -122.36747,
    "building_number": 8127,
    "street": "27th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "8127 27th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "8/8/15",
    "purchase_year": 2015,
    "purchase_amount": 230000,
    "assessed_value": 253000,
    "purchase_amount_vs_assessment": -9.090909091,
    "sale_date": "3/8/16",
    "sale_amount": 455000
  },
  {
    "parcel_id": 9144100166,
    "latitude": 47.699612,
    "longitude": -122.37514,
    "building_number": 9610,
    "street": "Mary Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "9610 Mary Ave. N.W., Seattle, WA 98117",
    "purchase_date": "8/18/15",
    "purchase_year": 2015,
    "purchase_amount": 220000,
    "assessed_value": 328000,
    "purchase_amount_vs_assessment": -32.92682927,
    "sale_date": "5/19/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 9571800065,
    "latitude": 47.576851,
    "longitude": -122.3944,
    "building_number": 3021,
    "street": "49th Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "3021 49th Ave. S.W., Seattle, WA 98116",
    "purchase_date": "8/19/15",
    "purchase_year": 2015,
    "purchase_amount": 397000,
    "assessed_value": 352000,
    "purchase_amount_vs_assessment": 12.78409091,
    "sale_date": "3/2/16",
    "sale_amount": 635000
  },
  {
    "parcel_id": 5568200050,
    "latitude": 47.309397,
    "longitude": -122.22469,
    "building_number": 319,
    "street": "2nd St. N.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "319 2nd St. N.E., Auburn, WA 98002",
    "purchase_date": "8/20/15",
    "purchase_year": 2015,
    "purchase_amount": 151150,
    "assessed_value": 145000,
    "purchase_amount_vs_assessment": 4.24137931,
    "sale_date": "2/3/16",
    "sale_amount": 257500
  },
  {
    "parcel_id": 3131201900,
    "latitude": 47.6610487,
    "longitude": -122.325919,
    "building_number": 4428,
    "street": "4th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "4428 4th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "8/24/15",
    "purchase_year": 2015,
    "purchase_amount": 950000,
    "assessed_value": 725500,
    "purchase_amount_vs_assessment": 30.94417643
  },
  {
    "parcel_id": 8698600255,
    "latitude": 47.306148,
    "longitude": -122.22026,
    "building_number": 130,
    "street": "G St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "130 G St. S.E., Auburn, WA 98002",
    "purchase_date": "8/26/15",
    "purchase_year": 2015,
    "purchase_amount": 125000,
    "assessed_value": 141000,
    "purchase_amount_vs_assessment": -11.34751773,
    "sale_date": "10/27/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 8961800270,
    "latitude": 47.508095,
    "longitude": -122.30762,
    "building_number": 10611,
    "street": "20th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "10611 20th Ave. S., Seattle, WA 98168",
    "purchase_date": "8/31/15",
    "purchase_year": 2015,
    "purchase_amount": 203000,
    "assessed_value": 188000,
    "purchase_amount_vs_assessment": 7.978723404,
    "sale_date": "3/16/16",
    "sale_amount": 375000
  },
  {
    "parcel_id": 1261500130,
    "latitude": 47.507195,
    "longitude": -122.37499,
    "building_number": 10633,
    "street": "34th Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "10633 34th Ave. S.W., Seattle, WA 98146",
    "purchase_date": "9/1/15",
    "purchase_year": 2015,
    "purchase_amount": 362250,
    "assessed_value": 366000,
    "purchase_amount_vs_assessment": -1.024590164,
    "sale_date": "1/29/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 1447600365,
    "latitude": 47.495635,
    "longitude": -122.32944,
    "building_number": 12004,
    "street": "3rd Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "12004 3rd Ave. S., Seattle, WA 98168",
    "purchase_date": "9/2/15",
    "purchase_year": 2015,
    "purchase_amount": 126000,
    "assessed_value": 91000,
    "purchase_amount_vs_assessment": 38.46153846,
    "sale_date": "12/7/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 7374600720,
    "latitude": 47.591117,
    "longitude": -122.13968,
    "building_number": 2058,
    "street": "150th Ave. S.E.",
    "city": "Bellevue",
    "zip": 98007,
    "address": "2058 150th Ave. S.E., Bellevue, WA 98007",
    "purchase_date": "9/4/15",
    "purchase_year": 2015,
    "purchase_amount": 382500,
    "assessed_value": 428000,
    "purchase_amount_vs_assessment": -10.63084112,
    "sale_date": "6/3/16",
    "sale_amount": 693000
  },
  {
    "parcel_id": 3298700806,
    "latitude": 47.52086,
    "longitude": -122.35098,
    "building_number": 9203,
    "street": "12th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9203 12th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "9/11/15",
    "purchase_year": 2015,
    "purchase_amount": 231000,
    "assessed_value": 204000,
    "purchase_amount_vs_assessment": 13.23529412,
    "sale_date": "1/12/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 8165100060,
    "latitude": 47.777492,
    "longitude": -122.36267,
    "building_number": 333,
    "street": "N.W. 205th St.",
    "city": "Seattle",
    "zip": 98177,
    "address": "333 N.W. 205th St., Seattle, WA 98177",
    "purchase_date": "9/14/15",
    "purchase_year": 2015,
    "purchase_amount": 325000,
    "assessed_value": 324000,
    "purchase_amount_vs_assessment": 0.3086419753,
    "sale_date": "3/3/16",
    "sale_amount": 529000
  },
  {
    "parcel_id": 2887700031,
    "latitude": 47.689774,
    "longitude": -122.31189,
    "building_number": 8242,
    "street": "15th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "8242 15th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "9/24/15",
    "purchase_year": 2015,
    "purchase_amount": 310000,
    "assessed_value": 270000,
    "purchase_amount_vs_assessment": 14.81481481,
    "sale_date": "7/18/16",
    "sale_amount": 760000
  },
  {
    "parcel_id": 2568800044,
    "latitude": 47.703849,
    "longitude": -122.29439,
    "building_number": 10325,
    "street": "32nd Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "10325 32nd Ave. N.E., Seattle, WA 98125",
    "purchase_date": "9/24/15",
    "purchase_year": 2015,
    "purchase_amount": 255000,
    "assessed_value": 369000,
    "purchase_amount_vs_assessment": -30.89430894,
    "sale_date": "2/1/16",
    "sale_amount": 625000
  },
  {
    "parcel_id": 4058201280,
    "latitude": 47.503045,
    "longitude": -122.2367,
    "building_number": 11144,
    "street": "Woodward Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11144 Woodward Ave. S., Seattle, WA 98178",
    "purchase_date": "9/28/15",
    "purchase_year": 2015,
    "purchase_amount": 200000,
    "assessed_value": 216000,
    "purchase_amount_vs_assessment": -7.407407407,
    "sale_date": "11/19/15",
    "sale_amount": 274000
  },
  {
    "parcel_id": 5379800504,
    "latitude": 47.456539,
    "longitude": -122.27512,
    "building_number": 4632,
    "street": "S. 164th St.",
    "city": "Seattle",
    "zip": 98188,
    "address": "4632 S. 164th St., Seattle, WA 98188",
    "purchase_date": "9/29/15",
    "purchase_year": 2015,
    "purchase_amount": 145000,
    "assessed_value": 220000,
    "purchase_amount_vs_assessment": -34.09090909,
    "sale_date": "3/9/16",
    "sale_amount": 355000
  },
  {
    "parcel_id": 7345000210,
    "latitude": 47.277732,
    "longitude": -122.20681,
    "building_number": 1627,
    "street": "35th St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "1627 35th St. S.E., Auburn, WA 98002",
    "purchase_date": "9/30/15",
    "purchase_year": 2015,
    "purchase_amount": 158000,
    "assessed_value": 194000,
    "purchase_amount_vs_assessment": -18.55670103,
    "sale_date": "12/28/15",
    "sale_amount": 275000
  },
  {
    "parcel_id": 3901100110,
    "latitude": 47.669476,
    "longitude": -122.17424,
    "building_number": 12407,
    "street": "N.E. 72nd St.",
    "city": "Kirkland",
    "zip": 98033,
    "address": "12407 N.E. 72nd St., Kirkland, WA 98033",
    "purchase_date": "9/30/15",
    "purchase_year": 2015,
    "purchase_amount": 435000,
    "assessed_value": 367000,
    "purchase_amount_vs_assessment": 18.52861035,
    "sale_date": "1/12/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 6072500070,
    "latitude": 47.54507,
    "longitude": -122.17859,
    "building_number": 6327,
    "street": "121st Place S.E.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "6327 121st Place S.E., Bellevue, WA 98006",
    "purchase_date": "10/9/15",
    "purchase_year": 2015,
    "purchase_amount": 409000,
    "assessed_value": 349000,
    "purchase_amount_vs_assessment": 17.19197708,
    "sale_date": "4/27/16",
    "sale_amount": 620000
  },
  {
    "parcel_id": 9328500810,
    "latitude": 47.640915,
    "longitude": -122.11124,
    "building_number": 3419,
    "street": "172nd Ave. N.E.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "3419 172nd Ave. N.E., Bellevue, WA 98008",
    "purchase_date": "10/13/15",
    "purchase_year": 2015,
    "purchase_amount": 418782,
    "assessed_value": 442000,
    "purchase_amount_vs_assessment": -5.252941176,
    "sale_date": "3/23/16",
    "sale_amount": 684500
  },
  {
    "parcel_id": 7504010180,
    "latitude": 47.640763,
    "longitude": -122.06151,
    "building_number": 3332,
    "street": "Sahalee Drive W.",
    "city": "Sammamish",
    "zip": 98074,
    "address": "3332 Sahalee Drive W., Sammamish, WA 98074",
    "purchase_date": "10/14/15",
    "purchase_year": 2015,
    "purchase_amount": 518000,
    "assessed_value": 563000,
    "purchase_amount_vs_assessment": -7.992895204,
    "sale_date": "7/2/16",
    "sale_amount": 781100
  },
  {
    "parcel_id": 7642200201,
    "latitude": 47.496094,
    "longitude": -122.35802,
    "building_number": 1821,
    "street": "S.W. 119th St.",
    "city": "Seattle",
    "zip": 98146,
    "address": "1821 S.W. 119th St., Seattle, WA 98146",
    "purchase_date": "10/23/15",
    "purchase_year": 2015,
    "purchase_amount": 301000,
    "assessed_value": 231000,
    "purchase_amount_vs_assessment": 30.3030303,
    "sale_date": "11/5/15",
    "sale_amount": 14000
  },
  {
    "parcel_id": 1454100520,
    "latitude": 47.72488,
    "longitude": -122.28553,
    "building_number": 13064,
    "street": "39th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "13064 39th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "10/26/15",
    "purchase_year": 2015,
    "purchase_amount": 440000,
    "assessed_value": 587000,
    "purchase_amount_vs_assessment": -25.04258944,
    "sale_date": "5/12/16",
    "sale_amount": 815000
  },
  {
    "parcel_id": 8122100045,
    "latitude": 47.536604,
    "longitude": -122.3762,
    "building_number": 7326,
    "street": "35th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "7326 35th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "11/13/15",
    "purchase_year": 2015,
    "purchase_amount": 262500,
    "assessed_value": 221000,
    "purchase_amount_vs_assessment": 18.77828054,
    "sale_date": "6/28/16",
    "sale_amount": 656000
  },
  {
    "parcel_id": 9521100230,
    "latitude": 47.6625893,
    "longitude": -122.353866,
    "building_number": 4613,
    "street": "Evanston Ave. N.",
    "city": "Seattle",
    "zip": 98103,
    "address": "4613 Evanston Ave. N., Seattle, WA 98103",
    "purchase_date": "11/27/15",
    "purchase_year": 2015,
    "purchase_amount": 340000,
    "assessed_value": 429000,
    "purchase_amount_vs_assessment": -20.74592075,
    "sale_date": "12/3/15",
    "sale_amount": 0
  },
  {
    "parcel_id": 6381501325,
    "latitude": 47.729913,
    "longitude": -122.30214,
    "building_number": 2501,
    "street": "N.E. 140th St.",
    "city": "Seattle",
    "zip": 98125,
    "address": "2501 N.E. 140th St., Seattle, WA 98125",
    "purchase_date": "12/6/15",
    "purchase_year": 2015,
    "purchase_amount": 256000,
    "assessed_value": 276000,
    "purchase_amount_vs_assessment": -7.246376812,
    "sale_date": "9/15/16",
    "sale_amount": 450000
  },
  {
    "parcel_id": 6632300143,
    "latitude": 47.731324,
    "longitude": -122.30767,
    "building_number": 14037,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "14037 20th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "12/8/15",
    "purchase_year": 2015,
    "purchase_amount": 225000,
    "assessed_value": 364000,
    "purchase_amount_vs_assessment": -38.18681319,
    "sale_date": "7/11/16",
    "sale_amount": 628000
  },
  {
    "parcel_id": 7893801790,
    "latitude": 47.410604,
    "longitude": -122.32889,
    "building_number": 21312,
    "street": "4th Place S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "21312 4th Place S., Seattle, WA 98198",
    "purchase_date": "12/11/15",
    "purchase_year": 2015,
    "purchase_amount": 299000,
    "assessed_value": 294000,
    "purchase_amount_vs_assessment": 1.700680272,
    "sale_date": "6/28/16",
    "sale_amount": 579950
  },
  {
    "parcel_id": 4024101386,
    "latitude": 47.759065,
    "longitude": -122.30396,
    "building_number": 17823,
    "street": "25th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "17823 25th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "12/16/15",
    "purchase_year": 2015,
    "purchase_amount": 391000,
    "assessed_value": 299000,
    "purchase_amount_vs_assessment": 30.76923077,
    "sale_date": "7/19/16",
    "sale_amount": 615000
  },
  {
    "parcel_id": 9476200590,
    "latitude": 47.491036,
    "longitude": -122.18604,
    "building_number": 508,
    "street": "Windsor Place N.E.",
    "city": "Renton",
    "zip": 98056,
    "address": "508 Windsor Place N.E., Renton, WA 98056",
    "purchase_date": "12/17/15",
    "purchase_year": 2015,
    "purchase_amount": 260000,
    "assessed_value": 220000,
    "purchase_amount_vs_assessment": 18.18181818,
    "sale_date": "10/20/16",
    "sale_amount": 390000
  },
  {
    "parcel_id": 1761600170,
    "latitude": 47.730162,
    "longitude": -122.23148,
    "building_number": 14222,
    "street": "82nd Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "14222 82nd Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "12/17/15",
    "purchase_year": 2015,
    "purchase_amount": 346500,
    "assessed_value": 270000,
    "purchase_amount_vs_assessment": 28.33333333,
    "sale_date": "7/29/16",
    "sale_amount": 495000
  },
  {
    "parcel_id": 5101404605,
    "latitude": 47.697248,
    "longitude": -122.31514,
    "building_number": 9411,
    "street": "12th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9411 12th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "12/22/15",
    "purchase_year": 2015,
    "purchase_amount": 350000,
    "assessed_value": 299000,
    "purchase_amount_vs_assessment": 17.05685619,
    "sale_date": "11/14/16",
    "sale_amount": 710000
  },
  {
    "parcel_id": 5249802450,
    "latitude": 47.56107,
    "longitude": -122.27477,
    "building_number": 4627,
    "street": "47th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4627 47th Ave. S., Seattle, WA 98118",
    "purchase_date": "12/23/15",
    "purchase_year": 2015,
    "purchase_amount": 440000,
    "assessed_value": 334000,
    "purchase_amount_vs_assessment": 31.73652695,
    "sale_date": "12/2/16",
    "sale_amount": 695000
  },
  {
    "parcel_id": 7812801885,
    "latitude": 47.492317,
    "longitude": -122.24814,
    "building_number": 6819,
    "street": "S. 124th St.",
    "city": "Seattle",
    "zip": 98178,
    "address": "6819 S. 124th St., Seattle, WA 98178",
    "purchase_date": "12/28/15",
    "purchase_year": 2015,
    "purchase_amount": 155000,
    "assessed_value": 157000,
    "purchase_amount_vs_assessment": -1.27388535,
    "sale_date": "10/14/16",
    "sale_amount": 300000
  },
  {
    "parcel_id": 8731901620,
    "latitude": 47.31121,
    "longitude": -122.37594,
    "building_number": 3248,
    "street": "S.W. 325th St.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "3248 S.W. 325th St., Federal Way, WA 98023",
    "purchase_date": "1/7/16",
    "purchase_year": 2016,
    "purchase_amount": 275000,
    "assessed_value": 299000,
    "purchase_amount_vs_assessment": -8.026755853,
    "sale_date": "4/18/16",
    "sale_amount": 405000
  },
  {
    "parcel_id": 8656800210,
    "latitude": 47.671149,
    "longitude": -121.86563,
    "building_number": 7709,
    "street": "Tolt River Road N.E.",
    "city": "Carnation",
    "zip": 98014,
    "address": "7709 Tolt River Road N.E., Carnation, WA 98014",
    "purchase_date": "1/27/16",
    "purchase_year": 2016,
    "purchase_amount": 295000,
    "assessed_value": 369000,
    "purchase_amount_vs_assessment": -20.05420054,
    "sale_date": "10/12/16",
    "sale_amount": 560000
  },
  {
    "parcel_id": 3575303553,
    "latitude": 47.619923,
    "longitude": -122.06148,
    "building_number": 20819,
    "street": "N.E. Inglewood Hill Road",
    "city": "Sammamish",
    "zip": 98074,
    "address": "20819 N.E. Inglewood Hill Road, Sammamish, WA 98074",
    "purchase_date": "1/27/16",
    "purchase_year": 2016,
    "purchase_amount": 405000,
    "assessed_value": 359000,
    "purchase_amount_vs_assessment": 12.81337047,
    "sale_date": "3/23/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 193600040,
    "latitude": 47.683567,
    "longitude": -122.11764,
    "building_number": 16621,
    "street": "N.E. 92nd St.",
    "city": "Redmond",
    "zip": 98052,
    "address": "16621 N.E. 92nd St., Redmond, WA 98052",
    "purchase_date": "1/28/16",
    "purchase_year": 2016,
    "purchase_amount": 372000,
    "assessed_value": 411000,
    "purchase_amount_vs_assessment": -9.489051095,
    "sale_date": "5/27/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 6181700305,
    "latitude": 47.760002,
    "longitude": -122.25581,
    "building_number": 6433,
    "street": "N.E. 182nd St.",
    "city": "Kenmore",
    "zip": 98028,
    "address": "6433 N.E. 182nd St., Kenmore, WA 98028",
    "purchase_date": "2/4/16",
    "purchase_year": 2016,
    "purchase_amount": 290000,
    "assessed_value": 338000,
    "purchase_amount_vs_assessment": -14.20118343,
    "sale_date": "5/12/17",
    "sale_amount": 562000
  },
  {
    "parcel_id": 1223049087,
    "latitude": 47.497106,
    "longitude": -122.23114,
    "building_number": 8041,
    "street": "S. 118th St.",
    "city": "Seattle",
    "zip": 98178,
    "address": "8041 S. 118th St., Seattle, WA 98178",
    "purchase_date": "2/9/16",
    "purchase_year": 2016,
    "purchase_amount": 255000,
    "assessed_value": 233000,
    "purchase_amount_vs_assessment": 9.442060086,
    "sale_date": "9/27/16",
    "sale_amount": 524950
  },
  {
    "parcel_id": 9191201315,
    "latitude": 47.669839,
    "longitude": -122.29884,
    "building_number": 5545,
    "street": "27th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5545 27th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "2/19/16",
    "purchase_year": 2016,
    "purchase_amount": 550000,
    "assessed_value": 589000,
    "purchase_amount_vs_assessment": -6.62139219,
    "sale_date": "1/5/17",
    "sale_amount": 915000
  },
  {
    "parcel_id": 7230300350,
    "latitude": 47.468184,
    "longitude": -122.10882,
    "building_number": 14909,
    "street": "175th Ave. S.E.",
    "city": "Renton",
    "zip": 98059,
    "address": "14909 175th Ave. S.E., Renton, WA 98059",
    "purchase_date": "2/19/16",
    "purchase_year": 2016,
    "purchase_amount": 246000,
    "assessed_value": 297000,
    "purchase_amount_vs_assessment": -17.17171717,
    "sale_date": "3/22/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 4392200180,
    "latitude": 47.328587,
    "longitude": -122.04363,
    "building_number": 30432,
    "street": "224th Ave. S.E.",
    "city": "Black Diamond",
    "zip": 98010,
    "address": "30432 224th Ave. S.E., Black Diamond, WA 98010",
    "purchase_date": "2/25/16",
    "purchase_year": 2016,
    "purchase_amount": 203900,
    "assessed_value": 214000,
    "purchase_amount_vs_assessment": -4.719626168,
    "sale_date": "7/26/16",
    "sale_amount": 308500
  },
  {
    "parcel_id": 1545805210,
    "latitude": 47.363495,
    "longitude": -122.04458,
    "building_number": 26606,
    "street": "221st Place S.E.",
    "city": "Maple Valley",
    "zip": 98038,
    "address": "26606 221st Place S.E., Maple Valley, WA 98038",
    "purchase_date": "2/25/16",
    "purchase_year": 2016,
    "purchase_amount": 220794,
    "assessed_value": 271000,
    "purchase_amount_vs_assessment": -18.52619926,
    "sale_date": "6/20/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 1545805210,
    "latitude": 47.363495,
    "longitude": -122.04458,
    "building_number": 26606,
    "street": "221st Place S.E.",
    "city": "Maple Valley",
    "zip": 98038,
    "address": "26606 221st Place S.E., Maple Valley, WA 98038",
    "purchase_date": "2/25/16",
    "purchase_year": 2016,
    "purchase_amount": 220794,
    "assessed_value": 271000,
    "purchase_amount_vs_assessment": -18.52619926,
    "sale_date": "6/20/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 7806210060,
    "latitude": 47.293367,
    "longitude": -122.19425,
    "building_number": 2609,
    "street": "17th St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "2609 17th St. S.E., Auburn, WA 98002",
    "purchase_date": "2/25/16",
    "purchase_year": 2016,
    "purchase_amount": 195000,
    "assessed_value": 187000,
    "purchase_amount_vs_assessment": 4.278074866,
    "sale_date": "7/26/16",
    "sale_amount": 323000
  },
  {
    "parcel_id": 4027700915,
    "latitude": 47.774205,
    "longitude": -122.26924,
    "building_number": 5607,
    "street": "N.E. 200th Place",
    "city": "Kenmore",
    "zip": 98028,
    "address": "5607 N.E. 200th Place, Kenmore, WA 98028",
    "purchase_date": "2/29/16",
    "purchase_year": 2016,
    "purchase_amount": 339000,
    "assessed_value": 328000,
    "purchase_amount_vs_assessment": 3.353658537,
    "sale_date": "3/21/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 8861700050,
    "latitude": 47.688714,
    "longitude": -122.12568,
    "building_number": 16113,
    "street": "N.E. 99th St.",
    "city": "Redmond",
    "zip": 98052,
    "address": "16113 N.E. 99th St., Redmond, WA 98052",
    "purchase_date": "3/7/16",
    "purchase_year": 2016,
    "purchase_amount": 350000,
    "assessed_value": 400000,
    "purchase_amount_vs_assessment": -12.5,
    "sale_date": "9/27/16",
    "sale_amount": 599950
  },
  {
    "parcel_id": 6303400145,
    "latitude": 47.509857,
    "longitude": -122.35741,
    "building_number": 10402,
    "street": "18th Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "10402 18th Ave. S.W., Seattle, WA 98146",
    "purchase_date": "3/10/16",
    "purchase_year": 2016,
    "purchase_amount": 230000,
    "assessed_value": 238000,
    "purchase_amount_vs_assessment": -3.361344538,
    "sale_date": "3/17/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 4059400315,
    "latitude": 47.502664,
    "longitude": -122.24411,
    "building_number": 11216,
    "street": "Crestwood Drive S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11216 Crestwood Drive S., Seattle, WA 98178",
    "purchase_date": "3/16/16",
    "purchase_year": 2016,
    "purchase_amount": 225500,
    "assessed_value": 210000,
    "purchase_amount_vs_assessment": 7.380952381,
    "sale_date": "3/21/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 6791200090,
    "latitude": 47.590172,
    "longitude": -122.05056,
    "building_number": 21515,
    "street": "S.E. 22nd St.",
    "city": "Sammamish",
    "zip": 98075,
    "address": "21515 S.E. 22nd St., Sammamish, WA 98075",
    "purchase_date": "3/22/16",
    "purchase_year": 2016,
    "purchase_amount": 480000,
    "assessed_value": 440000,
    "purchase_amount_vs_assessment": 9.090909091,
    "sale_date": "11/11/16",
    "sale_amount": 790000
  },
  {
    "parcel_id": 6141100430,
    "latitude": 47.719307,
    "longitude": -122.35253,
    "building_number": 12252,
    "street": "Dayton Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "12252 Dayton Ave. N., Seattle, WA 98133",
    "purchase_date": "3/23/16",
    "purchase_year": 2016,
    "purchase_amount": 370000,
    "assessed_value": 394000,
    "purchase_amount_vs_assessment": -6.091370558,
    "sale_date": "5/19/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 6751300335,
    "latitude": 47.586044,
    "longitude": -122.13285,
    "building_number": 2553,
    "street": "156th Ave. S.E.",
    "city": "Bellevue",
    "zip": 98007,
    "address": "2553 156th Ave. S.E., Bellevue, WA 98007",
    "purchase_date": "3/24/16",
    "purchase_year": 2016,
    "purchase_amount": 300000,
    "assessed_value": 422000,
    "purchase_amount_vs_assessment": -28.90995261,
    "sale_date": "9/14/17",
    "sale_amount": 790000
  },
  {
    "parcel_id": 6790600900,
    "latitude": 47.396295,
    "longitude": -122.30694,
    "building_number": 23006,
    "street": "20th Ave. S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "23006 20th Ave. S., Seattle, WA 98198",
    "purchase_date": "3/29/16",
    "purchase_year": 2016,
    "purchase_amount": 285000,
    "assessed_value": 225000,
    "purchase_amount_vs_assessment": 26.66666667,
    "sale_date": "5/23/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 414100485,
    "latitude": 47.74559,
    "longitude": -122.34177,
    "building_number": 1319,
    "street": "N. 161st St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "1319 N. 161st St., Seattle, WA 98133",
    "purchase_date": "3/29/16",
    "purchase_year": 2016,
    "purchase_amount": 245000,
    "assessed_value": 249000,
    "purchase_amount_vs_assessment": -1.606425703,
    "sale_date": "5/19/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 3797001170,
    "latitude": 47.685215,
    "longitude": -122.34696,
    "building_number": 7712,
    "street": "Linden Ave. N.",
    "city": "Seattle",
    "zip": 98103,
    "address": "7712 Linden Ave. N., Seattle, WA 98103",
    "purchase_date": "3/30/16",
    "purchase_year": 2016,
    "purchase_amount": 525000,
    "assessed_value": 440000,
    "purchase_amount_vs_assessment": 19.31818182,
    "sale_date": "10/13/17",
    "sale_amount": 849950
  },
  {
    "parcel_id": 9828700375,
    "latitude": 47.621081,
    "longitude": -122.2926,
    "building_number": 229,
    "street": "31st Ave. E.",
    "city": "Seattle",
    "zip": 98112,
    "address": "229 31st Ave. E., Seattle, WA 98112",
    "purchase_date": "4/4/16",
    "purchase_year": 2016,
    "purchase_amount": 460000,
    "assessed_value": 341000,
    "purchase_amount_vs_assessment": 34.8973607,
    "sale_date": "1/17/17",
    "sale_amount": 657500
  },
  {
    "parcel_id": 2255500005,
    "latitude": 47.60902,
    "longitude": -122.31099,
    "building_number": 1609,
    "street": "E. Columbia St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "1609 E. Columbia St., Seattle, WA 98122",
    "purchase_date": "4/4/16",
    "purchase_year": 2016,
    "purchase_amount": 575000,
    "assessed_value": 565000,
    "purchase_amount_vs_assessment": 1.769911504,
    "sale_date": "1/12/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 2123700145,
    "latitude": 47.526665,
    "longitude": -122.27312,
    "building_number": 8440,
    "street": "47th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "8440 47th Ave. S., Seattle, WA 98118",
    "purchase_date": "4/19/16",
    "purchase_year": 2016,
    "purchase_amount": 20000,
    "assessed_value": 167000,
    "purchase_amount_vs_assessment": -88.0239521,
    "sale_date": "6/6/16",
    "sale_amount": 209000
  },
  {
    "parcel_id": 9122000795,
    "latitude": 47.581819,
    "longitude": -122.30526,
    "building_number": 2336,
    "street": "21st Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2336 21st Ave. S., Seattle, WA 98144",
    "purchase_date": "4/26/16",
    "purchase_year": 2016,
    "purchase_amount": 310000,
    "assessed_value": 254000,
    "purchase_amount_vs_assessment": 22.04724409,
    "sale_date": "11/10/16",
    "sale_amount": 495000
  },
  {
    "parcel_id": 6629300100,
    "latitude": 47.749012,
    "longitude": -122.35356,
    "building_number": 607,
    "street": "N. 165th Place",
    "city": "Seattle",
    "zip": 98133,
    "address": "607 N. 165th Place, Seattle, WA 98133",
    "purchase_date": "4/28/16",
    "purchase_year": 2016,
    "purchase_amount": 300000,
    "assessed_value": 332000,
    "purchase_amount_vs_assessment": -9.638554217,
    "sale_date": "5/19/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 1446800900,
    "latitude": 47.492794,
    "longitude": -122.33217,
    "building_number": 12256,
    "street": "Occidental Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "12256 Occidental Ave. S., Seattle, WA 98168",
    "purchase_date": "5/3/16",
    "purchase_year": 2016,
    "purchase_amount": 221000,
    "assessed_value": 197000,
    "purchase_amount_vs_assessment": 12.18274112,
    "sale_date": "7/28/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 3353400354,
    "latitude": 47.263661,
    "longitude": -122.25137,
    "building_number": 108,
    "street": "4th Ave. S.W.",
    "city": "Pacific",
    "zip": 98047,
    "address": "108 4th Ave. S.W., Pacific, WA 98047",
    "purchase_date": "5/4/16",
    "purchase_year": 2016,
    "purchase_amount": 161000,
    "assessed_value": 164000,
    "purchase_amount_vs_assessment": -1.829268293,
    "sale_date": "5/10/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 425069065,
    "latitude": 47.67536,
    "longitude": -122.04728,
    "building_number": 8004,
    "street": "219th Ave. N.E.",
    "city": "Redmond",
    "zip": 98053,
    "address": "8004 219th Ave. N.E., Redmond, WA 98053",
    "purchase_date": "5/10/16",
    "purchase_year": 2016,
    "purchase_amount": 520000,
    "assessed_value": 488000,
    "purchase_amount_vs_assessment": 6.557377049,
    "sale_date": "6/27/17",
    "sale_amount": 875000
  },
  {
    "parcel_id": 4058200220,
    "latitude": 47.503394,
    "longitude": -122.22913,
    "building_number": 11034,
    "street": "Lotus Place S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11034 Lotus Place S., Seattle, WA 98178",
    "purchase_date": "5/10/16",
    "purchase_year": 2016,
    "purchase_amount": 310414,
    "assessed_value": 371000,
    "purchase_amount_vs_assessment": -16.33045822,
    "sale_date": "3/15/17",
    "sale_amount": 639950
  },
  {
    "parcel_id": 5553300405,
    "latitude": 47.631852,
    "longitude": -122.39159,
    "building_number": 2619,
    "street": "W. Galer St.",
    "city": "Seattle",
    "zip": 98199,
    "address": "2619 W. Galer St., Seattle, WA 98199",
    "purchase_date": "5/12/16",
    "purchase_year": 2016,
    "purchase_amount": 1780000,
    "assessed_value": 2078000,
    "purchase_amount_vs_assessment": -14.34071222,
    "sale_date": "3/15/17",
    "sale_amount": 2590000
  },
  {
    "parcel_id": 6664000110,
    "latitude": 47.58994,
    "longitude": -122.19288,
    "building_number": 10935,
    "street": "S.E. 23rd St.",
    "city": "Bellevue",
    "zip": 98004,
    "address": "10935 S.E. 23rd St., Bellevue, WA 98004",
    "purchase_date": "5/18/16",
    "purchase_year": 2016,
    "purchase_amount": 796000,
    "assessed_value": 668000,
    "purchase_amount_vs_assessment": 19.16167665,
    "sale_date": "8/8/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 2705600006,
    "latitude": 47.701348,
    "longitude": -122.36555,
    "building_number": 9756,
    "street": "8th Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "9756 8th Ave. N.W., Seattle, WA 98117",
    "purchase_date": "5/19/16",
    "purchase_year": 2016,
    "purchase_amount": 575000,
    "assessed_value": 360000,
    "purchase_amount_vs_assessment": 59.72222222,
    "sale_date": "11/29/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 798000280,
    "latitude": 47.502104,
    "longitude": -122.32938,
    "building_number": 11236,
    "street": "3rd Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "11236 3rd Ave. S., Seattle, WA 98168",
    "purchase_date": "5/22/16",
    "purchase_year": 2016,
    "purchase_amount": 225000,
    "assessed_value": 169000,
    "purchase_amount_vs_assessment": 33.13609467,
    "sale_date": "6/23/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 8563000510,
    "latitude": 47.623413,
    "longitude": -122.10346,
    "building_number": 1502,
    "street": "177th Ave. N.E.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "1502 177th Ave. N.E., Bellevue, WA 98008",
    "purchase_date": "5/24/16",
    "purchase_year": 2016,
    "purchase_amount": 570000,
    "assessed_value": 493000,
    "purchase_amount_vs_assessment": 15.61866126,
    "sale_date": "3/7/17",
    "sale_amount": 830000
  },
  {
    "parcel_id": 3342103207,
    "latitude": 47.520604,
    "longitude": -122.19997,
    "building_number": 1408,
    "street": "N. 32nd St.",
    "city": "Renton",
    "zip": 98056,
    "address": "1408 N. 32nd St., Renton, WA 98056",
    "purchase_date": "5/24/16",
    "purchase_year": 2016,
    "purchase_amount": 302500,
    "assessed_value": 375000,
    "purchase_amount_vs_assessment": -19.33333333,
    "sale_date": "2/21/17",
    "sale_amount": 515000
  },
  {
    "parcel_id": 5381600065,
    "latitude": 47.447608,
    "longitude": -122.2747,
    "building_number": 4707,
    "street": "S. 173rd St.",
    "city": "Seattle",
    "zip": 98188,
    "address": "4707 S. 173rd St., Seattle, WA 98188",
    "purchase_date": "6/2/16",
    "purchase_year": 2016,
    "purchase_amount": 302500,
    "assessed_value": 290000,
    "purchase_amount_vs_assessment": 4.310344828,
    "sale_date": "8/11/16",
    "sale_amount": 420000
  },
  {
    "parcel_id": 3024079053,
    "latitude": 47.540431,
    "longitude": -121.9598,
    "building_number": 28603,
    "street": "S.E. 67th St.",
    "city": "Issaquah",
    "zip": 98027,
    "address": "28603 S.E. 67th St., Issaquah, WA 98027",
    "purchase_date": "6/10/16",
    "purchase_year": 2016,
    "purchase_amount": 470000,
    "assessed_value": 444000,
    "purchase_amount_vs_assessment": 5.855855856,
    "sale_date": "6/27/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 8122600215,
    "latitude": 47.538595,
    "longitude": -122.36886,
    "building_number": 7118,
    "street": "28th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "7118 28th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "6/13/16",
    "purchase_year": 2016,
    "purchase_amount": 325000,
    "assessed_value": 212000,
    "purchase_amount_vs_assessment": 53.30188679,
    "sale_date": "7/1/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 6082400171,
    "latitude": 47.483406,
    "longitude": -122.3003,
    "building_number": 2449,
    "street": "S. 133rd St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "2449 S. 133rd St., Seattle, WA 98168",
    "purchase_date": "6/20/16",
    "purchase_year": 2016,
    "purchase_amount": 190000,
    "assessed_value": 198000,
    "purchase_amount_vs_assessment": -4.04040404,
    "sale_date": "10/4/16",
    "sale_amount": 320000
  },
  {
    "parcel_id": 9414500580,
    "latitude": 47.520394,
    "longitude": -122.04758,
    "building_number": 970,
    "street": "Greenwood Blvd. S.W.",
    "city": "Issaquah",
    "zip": 98027,
    "address": "970 Greenwood Blvd. S.W., Issaquah, WA 98027",
    "purchase_date": "6/23/16",
    "purchase_year": 2016,
    "purchase_amount": 430000,
    "assessed_value": 513000,
    "purchase_amount_vs_assessment": -16.17933723,
    "sale_date": "10/17/16",
    "sale_amount": 595000
  },
  {
    "parcel_id": 3298700407,
    "latitude": 47.522493,
    "longitude": -122.35369,
    "building_number": 9008,
    "street": "15th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9008 15th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "6/29/16",
    "purchase_year": 2016,
    "purchase_amount": 254000,
    "assessed_value": 216000,
    "purchase_amount_vs_assessment": 17.59259259,
    "sale_date": "2/21/17",
    "sale_amount": 389950
  },
  {
    "parcel_id": 2436701040,
    "latitude": 47.667272,
    "longitude": -122.28763,
    "building_number": 5218,
    "street": "37th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5218 37th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "7/8/16",
    "purchase_year": 2016,
    "purchase_amount": 652500,
    "assessed_value": 529000,
    "purchase_amount_vs_assessment": 23.34593573,
    "sale_date": "8/7/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 3331500260,
    "latitude": 47.553196,
    "longitude": -122.27373,
    "building_number": 4707,
    "street": "S. Brandon St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4707 S. Brandon St., Seattle, WA 98118",
    "purchase_date": "7/8/16",
    "purchase_year": 2016,
    "purchase_amount": 390000,
    "assessed_value": 293000,
    "purchase_amount_vs_assessment": 33.10580205,
    "sale_date": "3/30/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 7017200030,
    "latitude": 47.712035,
    "longitude": -122.34989,
    "building_number": 11252,
    "street": "Fremont Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "11252 Fremont Ave. N., Seattle, WA 98133",
    "purchase_date": "7/14/16",
    "purchase_year": 2016,
    "purchase_amount": 312500,
    "assessed_value": 394000,
    "purchase_amount_vs_assessment": -20.68527919,
    "sale_date": "4/14/17",
    "sale_amount": 699950
  },
  {
    "parcel_id": 3432501390,
    "latitude": 47.748226,
    "longitude": -122.31744,
    "building_number": 16267,
    "street": "11th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "16267 11th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "7/18/16",
    "purchase_year": 2016,
    "purchase_amount": 330000,
    "assessed_value": 410000,
    "purchase_amount_vs_assessment": -19.51219512,
    "sale_date": "2/28/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 2767704695,
    "latitude": 47.672588,
    "longitude": -122.37531,
    "building_number": 1436,
    "street": "N.W. 60th St.",
    "city": "Seattle",
    "zip": 98107,
    "address": "1436 N.W. 60th St., Seattle, WA 98107",
    "purchase_date": "7/25/16",
    "purchase_year": 2016,
    "purchase_amount": 1050000,
    "assessed_value": 587000,
    "purchase_amount_vs_assessment": 78.87563884
  },
  {
    "parcel_id": 3438501572,
    "latitude": 47.54545,
    "longitude": -122.35998,
    "building_number": 6335,
    "street": "21st Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "6335 21st Ave. S.W., Seattle, WA 98106",
    "purchase_date": "7/26/16",
    "purchase_year": 2016,
    "purchase_amount": 316000,
    "assessed_value": 270000,
    "purchase_amount_vs_assessment": 17.03703704,
    "sale_date": "9/29/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 3438502733,
    "latitude": 47.541383,
    "longitude": -122.35536,
    "building_number": 6753,
    "street": "16th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "6753 16th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "7/28/16",
    "purchase_year": 2016,
    "purchase_amount": 310000,
    "assessed_value": 375000,
    "purchase_amount_vs_assessment": -17.33333333,
    "sale_date": "8/23/17",
    "sale_amount": 580000
  },
  {
    "parcel_id": 7905380460,
    "latitude": 47.72097,
    "longitude": -122.21723,
    "building_number": 13510,
    "street": "92nd Place N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13510 92nd Place N.E., Kirkland, WA 98034",
    "purchase_date": "7/28/16",
    "purchase_year": 2016,
    "purchase_amount": 430000,
    "assessed_value": 342000,
    "purchase_amount_vs_assessment": 25.73099415,
    "sale_date": "4/13/17",
    "sale_amount": 755000
  },
  {
    "parcel_id": 7812800305,
    "latitude": 47.497877,
    "longitude": -122.24105,
    "building_number": 7414,
    "street": "S. 118th Place",
    "city": "Seattle",
    "zip": 98178,
    "address": "7414 S. 118th Place, Seattle, WA 98178",
    "purchase_date": "8/10/16",
    "purchase_year": 2016,
    "purchase_amount": 215000,
    "assessed_value": 185000,
    "purchase_amount_vs_assessment": 16.21621622,
    "sale_date": "1/20/17",
    "sale_amount": 355000
  },
  {
    "parcel_id": 5706500245,
    "latitude": 47.211823,
    "longitude": -121.99368,
    "building_number": 1956,
    "street": "Lowell Ave.",
    "city": "Enumclaw",
    "zip": 98022,
    "address": "1956 Lowell Ave., Enumclaw, WA 98022",
    "purchase_date": "8/10/16",
    "purchase_year": 2016,
    "purchase_amount": 141000,
    "assessed_value": 146000,
    "purchase_amount_vs_assessment": -3.424657534,
    "sale_date": "12/21/16",
    "sale_amount": 245000
  },
  {
    "parcel_id": 7399300370,
    "latitude": 47.462009,
    "longitude": -122.19084,
    "building_number": 2024,
    "street": "Aberdeen Ave. S.E.",
    "city": "Renton",
    "zip": 98055,
    "address": "2024 Aberdeen Ave. S.E., Renton, WA 98055",
    "purchase_date": "8/18/16",
    "purchase_year": 2016,
    "purchase_amount": 225000,
    "assessed_value": 231000,
    "purchase_amount_vs_assessment": -2.597402597
  },
  {
    "parcel_id": 2660500455,
    "latitude": 47.5555976,
    "longitude": -122.2886421,
    "building_number": 5051,
    "street": "37th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5051 37th Ave. S., Seattle, WA 98118",
    "purchase_date": "8/25/16",
    "purchase_year": 2016,
    "purchase_amount": 270000,
    "assessed_value": 294000,
    "purchase_amount_vs_assessment": -8.163265306
  },
  {
    "parcel_id": 1158700190,
    "latitude": 47.758647,
    "longitude": -122.36629,
    "building_number": 17828,
    "street": "8th Ave. N.W.",
    "city": "Seattle",
    "zip": 98177,
    "address": "17828 8th Ave. N.W., Seattle, WA 98177",
    "purchase_date": "8/25/16",
    "purchase_year": 2016,
    "purchase_amount": 460000,
    "assessed_value": 461000,
    "purchase_amount_vs_assessment": -0.2169197397,
    "sale_date": "2/27/17",
    "sale_amount": 832000
  },
  {
    "parcel_id": 3920100010,
    "latitude": 47.630911,
    "longitude": -122.09473,
    "building_number": 2325,
    "street": "184th Ave. N.E.",
    "city": "Redmond",
    "zip": 98052,
    "address": "2325 184th Ave. N.E., Redmond, WA 98052",
    "purchase_date": "9/8/16",
    "purchase_year": 2016,
    "purchase_amount": 525000,
    "assessed_value": 497000,
    "purchase_amount_vs_assessment": 5.633802817,
    "sale_date": "9/26/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 6099400142,
    "latitude": 47.475645,
    "longitude": -122.29346,
    "building_number": 14217,
    "street": "31st Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "14217 31st Ave. S., Seattle, WA 98168",
    "purchase_date": "9/8/16",
    "purchase_year": 2016,
    "purchase_amount": 110000,
    "assessed_value": 163000,
    "purchase_amount_vs_assessment": -32.51533742,
    "sale_date": "1/2/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 2473000760,
    "latitude": 47.4518,
    "longitude": -122.14964,
    "building_number": 16909,
    "street": "144th Ave. S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "16909 144th Ave. S.E., Renton, WA 98058",
    "purchase_date": "9/14/16",
    "purchase_year": 2016,
    "purchase_amount": 340000,
    "assessed_value": 342000,
    "purchase_amount_vs_assessment": -0.5847953216,
    "sale_date": "3/13/17",
    "sale_amount": 600000
  },
  {
    "parcel_id": 4365200780,
    "latitude": 47.521881,
    "longitude": -122.37378,
    "building_number": 9032,
    "street": "32nd Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "9032 32nd Ave. S.W., Seattle, WA 98126",
    "purchase_date": "9/19/16",
    "purchase_year": 2016,
    "purchase_amount": 376000,
    "assessed_value": 323000,
    "purchase_amount_vs_assessment": 16.40866873,
    "sale_date": "1/24/17",
    "sale_amount": 600000
  },
  {
    "parcel_id": 5726500040,
    "latitude": 47.592996,
    "longitude": -122.05187,
    "building_number": 1900,
    "street": "215th Place S.E.",
    "city": "Sammamish",
    "zip": 98075,
    "address": "1900 215th Place S.E., Sammamish, WA 98075",
    "purchase_date": "9/21/16",
    "purchase_year": 2016,
    "purchase_amount": 520000,
    "assessed_value": 460000,
    "purchase_amount_vs_assessment": 13.04347826,
    "sale_date": "9/27/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 1306300045,
    "latitude": 47.708131,
    "longitude": -122.35044,
    "building_number": 10743,
    "street": "Fremont Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "10743 Fremont Ave. N., Seattle, WA 98133",
    "purchase_date": "9/22/16",
    "purchase_year": 2016,
    "purchase_amount": 297500,
    "assessed_value": 319000,
    "purchase_amount_vs_assessment": -6.739811912,
    "sale_date": "8/30/17",
    "sale_amount": 574950
  },
  {
    "parcel_id": 7750500315,
    "latitude": 47.521565,
    "longitude": -122.3472,
    "building_number": 9041,
    "street": "9th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9041 9th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "9/23/16",
    "purchase_year": 2016,
    "purchase_amount": 246000,
    "assessed_value": 231000,
    "purchase_amount_vs_assessment": 6.493506494,
    "sale_date": "10/24/16",
    "sale_amount": 0
  },
  {
    "parcel_id": 1624049256,
    "latitude": 47.566921,
    "longitude": -122.29492,
    "building_number": 4031,
    "street": "30th Ave. S.",
    "city": "Seattle",
    "zip": 98108,
    "address": "4031 30th Ave. S., Seattle, WA 98108",
    "purchase_date": "10/5/16",
    "purchase_year": 2016,
    "purchase_amount": 330000,
    "assessed_value": 298000,
    "purchase_amount_vs_assessment": 10.73825503,
    "sale_date": "6/22/17",
    "sale_amount": 600000
  },
  {
    "parcel_id": 321100220,
    "latitude": 47.530374,
    "longitude": -122.22122,
    "building_number": 8045,
    "street": "E. Mercer Way",
    "city": "Mercer Island",
    "zip": 98040,
    "address": "8045 E. Mercer Way, Mercer Island, WA 98040",
    "purchase_date": "10/8/16",
    "purchase_year": 2016,
    "purchase_amount": 1000000,
    "assessed_value": 937000,
    "purchase_amount_vs_assessment": 6.723585912,
    "sale_date": "2/23/17",
    "sale_amount": 1240000
  },
  {
    "parcel_id": 1088030060,
    "latitude": 47.665057,
    "longitude": -122.18509,
    "building_number": 6555,
    "street": "116th Place N.E.",
    "city": "Kirkland",
    "zip": 98033,
    "address": "6555 116th Place N.E., Kirkland, WA 98033",
    "purchase_date": "10/18/16",
    "purchase_year": 2016,
    "purchase_amount": 655000,
    "assessed_value": 711000,
    "purchase_amount_vs_assessment": -7.876230661,
    "sale_date": "5/23/17",
    "sale_amount": 1005000
  },
  {
    "parcel_id": 635000100,
    "latitude": 47.599528,
    "longitude": -122.28671,
    "building_number": 3521,
    "street": "S. Leschi Place",
    "city": "Seattle",
    "zip": 98144,
    "address": "3521 S. Leschi Place, Seattle, WA 98144",
    "purchase_date": "10/19/16",
    "purchase_year": 2016,
    "purchase_amount": 1325000,
    "assessed_value": 985000,
    "purchase_amount_vs_assessment": 34.5177665,
    "sale_date": "1/25/19",
    "sale_amount": 2349000
  },
  {
    "parcel_id": 306000215,
    "latitude": 47.700742,
    "longitude": -122.34888,
    "building_number": 726,
    "street": "N. 98th St.",
    "city": "Seattle",
    "zip": 98103,
    "address": "726 N. 98th St., Seattle, WA 98103",
    "purchase_date": "10/20/16",
    "purchase_year": 2016,
    "purchase_amount": 353000,
    "assessed_value": 408000,
    "purchase_amount_vs_assessment": -13.48039216,
    "sale_date": "11/16/17",
    "sale_amount": 830000
  },
  {
    "parcel_id": 7173700180,
    "latitude": 47.666029,
    "longitude": -122.30586,
    "building_number": 5037,
    "street": "21st Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5037 21st Ave. N.E., Seattle, WA 98105",
    "purchase_date": "10/25/16",
    "purchase_year": 2016,
    "purchase_amount": 575000,
    "assessed_value": 637000,
    "purchase_amount_vs_assessment": -9.733124019,
    "sale_date": "7/20/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 4012900030,
    "latitude": 47.317966,
    "longitude": -122.27651,
    "building_number": 31624,
    "street": "46th Ave. S.",
    "city": "Auburn",
    "zip": 98001,
    "address": "31624 46th Ave. S., Auburn, WA 98001",
    "purchase_date": "10/27/16",
    "purchase_year": 2016,
    "purchase_amount": 195000,
    "assessed_value": 228000,
    "purchase_amount_vs_assessment": -14.47368421,
    "sale_date": "3/24/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 2254501373,
    "latitude": 47.612683,
    "longitude": -122.313,
    "building_number": 1425,
    "street": "E. Union St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "1425 E. Union St., Seattle, WA 98122",
    "purchase_date": "10/28/16",
    "purchase_year": 2016,
    "purchase_amount": 525000,
    "assessed_value": 363000,
    "purchase_amount_vs_assessment": 44.62809917
  },
  {
    "parcel_id": 6190700540,
    "latitude": 47.757073,
    "longitude": -122.36876,
    "building_number": 17536,
    "street": "10th Ave. N.W.",
    "city": "Seattle",
    "zip": 98177,
    "address": "17536 10th Ave. N.W., Seattle, WA 98177",
    "purchase_date": "11/17/16",
    "purchase_year": 2016,
    "purchase_amount": 382000,
    "assessed_value": 478000,
    "purchase_amount_vs_assessment": -20.08368201,
    "sale_date": "12/8/16",
    "sale_amount": 400000
  },
  {
    "parcel_id": 4036800060,
    "latitude": 47.603024,
    "longitude": -122.12913,
    "building_number": 15634,
    "street": "S.E. 8th St.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "15634 S.E. 8th St., Bellevue, WA 98008",
    "purchase_date": "11/18/16",
    "purchase_year": 2016,
    "purchase_amount": 400000,
    "assessed_value": 401000,
    "purchase_amount_vs_assessment": -0.2493765586,
    "sale_date": "2/27/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 1437900030,
    "latitude": 47.71784,
    "longitude": -122.19268,
    "building_number": 13109,
    "street": "111th Place N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13109 111th Place N.E., Kirkland, WA 98034",
    "purchase_date": "12/20/16",
    "purchase_year": 2016,
    "purchase_amount": 415000,
    "assessed_value": 391000,
    "purchase_amount_vs_assessment": 6.138107417,
    "sale_date": "6/13/17",
    "sale_amount": 699950
  },
  {
    "parcel_id": 825049094,
    "latitude": 47.669743,
    "longitude": -122.31445,
    "building_number": 5611,
    "street": "Brooklyn Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5611 Brooklyn Ave. N.E., Seattle, WA 98105",
    "purchase_date": "12/28/16",
    "purchase_year": 2016,
    "purchase_amount": 625000,
    "assessed_value": 557000,
    "purchase_amount_vs_assessment": 12.20825853,
    "sale_date": "2/15/17",
    "sale_amount": 799000
  },
  {
    "parcel_id": 1400300145,
    "latitude": 47.596409,
    "longitude": -122.29614,
    "building_number": 708,
    "street": "28th Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "708 28th Ave. S., Seattle, WA 98144",
    "purchase_date": "1/4/17",
    "purchase_year": 2017,
    "purchase_amount": 285000,
    "assessed_value": 222000,
    "purchase_amount_vs_assessment": 28.37837838,
    "sale_date": "11/27/18",
    "sale_amount": 825000
  },
  {
    "parcel_id": 2724069171,
    "latitude": 47.533288,
    "longitude": -122.03262,
    "building_number": 320,
    "street": "2nd Ave. N.E.",
    "city": "Issaquah",
    "zip": 98027,
    "address": "320 2nd Ave. N.E., Issaquah, WA 98027",
    "purchase_date": "1/4/17",
    "purchase_year": 2017,
    "purchase_amount": 403000,
    "assessed_value": 360000,
    "purchase_amount_vs_assessment": 11.94444444,
    "sale_date": "9/21/17",
    "sale_amount": 710000
  },
  {
    "parcel_id": 2473002130,
    "latitude": 47.449,
    "longitude": -122.14781,
    "building_number": 14607,
    "street": "S.E. 173rd St.",
    "city": "Renton",
    "zip": 98058,
    "address": "14607 S.E. 173rd St., Renton, WA 98058",
    "purchase_date": "1/5/17",
    "purchase_year": 2017,
    "purchase_amount": 450000,
    "assessed_value": 442000,
    "purchase_amount_vs_assessment": 1.809954751,
    "sale_date": "2/28/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 3873900220,
    "latitude": 47.343925,
    "longitude": -122.28433,
    "building_number": 3723,
    "street": "S. 287th St.",
    "city": "Auburn",
    "zip": 98001,
    "address": "3723 S. 287th St., Auburn, WA 98001",
    "purchase_date": "1/6/17",
    "purchase_year": 2017,
    "purchase_amount": 170000,
    "assessed_value": 227000,
    "purchase_amount_vs_assessment": -25.11013216,
    "sale_date": "7/25/17",
    "sale_amount": 310000
  },
  {
    "parcel_id": 3678900055,
    "latitude": 47.573828,
    "longitude": -122.31269,
    "building_number": 3305,
    "street": "16th Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "3305 16th Ave. S., Seattle, WA 98144",
    "purchase_date": "1/6/17",
    "purchase_year": 2017,
    "purchase_amount": 275000,
    "assessed_value": 434000,
    "purchase_amount_vs_assessment": -36.6359447,
    "sale_date": "10/18/17",
    "sale_amount": 825000
  },
  {
    "parcel_id": 3432501000,
    "latitude": 47.742697,
    "longitude": -122.31674,
    "building_number": 15550,
    "street": "11th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "15550 11th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "1/10/17",
    "purchase_year": 2017,
    "purchase_amount": 374500,
    "assessed_value": 357000,
    "purchase_amount_vs_assessment": 4.901960784,
    "sale_date": "9/12/17",
    "sale_amount": 616000
  },
  {
    "parcel_id": 6617000070,
    "latitude": 47.555811,
    "longitude": -122.26447,
    "building_number": 5136,
    "street": "55th Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5136 55th Ave. S., Seattle, WA 98118",
    "purchase_date": "1/11/17",
    "purchase_year": 2017,
    "purchase_amount": 701000,
    "assessed_value": 755000,
    "purchase_amount_vs_assessment": -7.152317881,
    "sale_date": "3/26/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 8819900030,
    "latitude": 47.669201,
    "longitude": -122.28992,
    "building_number": 5522,
    "street": "35th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5522 35th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "1/13/17",
    "purchase_year": 2017,
    "purchase_amount": 610000,
    "assessed_value": 564000,
    "purchase_amount_vs_assessment": 8.156028369,
    "sale_date": "6/30/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 795001145,
    "latitude": 47.503649,
    "longitude": -122.3277,
    "building_number": 11050,
    "street": "4th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "11050 4th Ave. S., Seattle, WA 98168",
    "purchase_date": "1/20/17",
    "purchase_year": 2017,
    "purchase_amount": 193000,
    "assessed_value": 185000,
    "purchase_amount_vs_assessment": 4.324324324,
    "sale_date": "2/28/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 1498303990,
    "latitude": 47.585041,
    "longitude": -122.2943,
    "building_number": 2011,
    "street": "30th Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2011 30th Ave. S., Seattle, WA 98144",
    "purchase_date": "1/25/17",
    "purchase_year": 2017,
    "purchase_amount": 560000,
    "assessed_value": 574000,
    "purchase_amount_vs_assessment": -2.43902439,
    "sale_date": "1/10/18",
    "sale_amount": 1100000
  },
  {
    "parcel_id": 2225300145,
    "latitude": 47.76316,
    "longitude": -122.30856,
    "building_number": 2310,
    "street": "N.E. 185th St.",
    "city": "Seattle",
    "zip": 98155,
    "address": "2310 N.E. 185th St., Seattle, WA 98155",
    "purchase_date": "1/27/17",
    "purchase_year": 2017,
    "purchase_amount": 210000,
    "assessed_value": 288000,
    "purchase_amount_vs_assessment": -27.08333333,
    "sale_date": "9/21/17",
    "sale_amount": 525000
  },
  {
    "parcel_id": 3361400170,
    "latitude": 47.502809,
    "longitude": -122.31935,
    "building_number": 1025,
    "street": "S. 112th St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "1025 S. 112th St., Seattle, WA 98168",
    "purchase_date": "1/30/17",
    "purchase_year": 2017,
    "purchase_amount": 220000,
    "assessed_value": 214000,
    "purchase_amount_vs_assessment": 2.803738318,
    "sale_date": "12/21/17",
    "sale_amount": 579950
  },
  {
    "parcel_id": 8820903055,
    "latitude": 47.714876,
    "longitude": -122.28349,
    "building_number": 11738,
    "street": "Bartlett Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "11738 Bartlett Ave. N.E., Seattle, WA 98125",
    "purchase_date": "2/1/17",
    "purchase_year": 2017,
    "purchase_amount": 449950,
    "assessed_value": 436000,
    "purchase_amount_vs_assessment": 3.199541284,
    "sale_date": "3/23/18",
    "sale_amount": 905000
  },
  {
    "parcel_id": 1326049159,
    "latitude": 47.741791,
    "longitude": -122.24878,
    "building_number": 15544,
    "street": "Juanita Drive N.E.",
    "city": "Kenmore",
    "zip": 98028,
    "address": "15544 Juanita Drive N.E., Kenmore, WA 98028",
    "purchase_date": "2/2/17",
    "purchase_year": 2017,
    "purchase_amount": 328000,
    "assessed_value": 312000,
    "purchase_amount_vs_assessment": 5.128205128,
    "sale_date": "11/27/17",
    "sale_amount": 649950
  },
  {
    "parcel_id": 3438502663,
    "latitude": 47.54224,
    "longitude": -122.35637,
    "building_number": 6721,
    "street": "17th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "6721 17th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "2/10/17",
    "purchase_year": 2017,
    "purchase_amount": 285000,
    "assessed_value": 339000,
    "purchase_amount_vs_assessment": -15.92920354,
    "sale_date": "8/24/17",
    "sale_amount": 575000
  },
  {
    "parcel_id": 6072000620,
    "latitude": 47.546575,
    "longitude": -122.17802,
    "building_number": 6240,
    "street": "121st Ave. S.E.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "6240 121st Ave. S.E., Bellevue, WA 98006",
    "purchase_date": "2/16/17",
    "purchase_year": 2017,
    "purchase_amount": 570000,
    "assessed_value": 547000,
    "purchase_amount_vs_assessment": 4.204753199,
    "sale_date": "8/14/17",
    "sale_amount": 803000
  },
  {
    "parcel_id": 1923300245,
    "latitude": 47.68643,
    "longitude": -122.35048,
    "building_number": 544,
    "street": "N. 79th St.",
    "city": "Seattle",
    "zip": 98103,
    "address": "544 N. 79th St., Seattle, WA 98103",
    "purchase_date": "2/24/17",
    "purchase_year": 2017,
    "purchase_amount": 525000,
    "assessed_value": 512000,
    "purchase_amount_vs_assessment": 2.5390625,
    "sale_date": "8/3/18",
    "sale_amount": 1099999
  },
  {
    "parcel_id": 2123049205,
    "latitude": 47.471277,
    "longitude": -122.29901,
    "building_number": 2620,
    "street": "S. 148th St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "2620 S. 148th St., Seattle, WA 98168",
    "purchase_date": "2/27/17",
    "purchase_year": 2017,
    "purchase_amount": 225000,
    "assessed_value": 230000,
    "purchase_amount_vs_assessment": -2.173913043,
    "sale_date": "5/17/17",
    "sale_amount": 402000
  },
  {
    "parcel_id": 5127100320,
    "latitude": 47.474731,
    "longitude": -122.14458,
    "building_number": 14230,
    "street": "146th Place S.E.",
    "city": "Renton",
    "zip": 98059,
    "address": "14230 146th Place S.E., Renton, WA 98059",
    "purchase_date": "2/28/17",
    "purchase_year": 2017,
    "purchase_amount": 235000,
    "assessed_value": 231000,
    "purchase_amount_vs_assessment": 1.731601732,
    "sale_date": "4/12/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 603002095,
    "latitude": 47.523076,
    "longitude": -122.28105,
    "building_number": 9003,
    "street": "Carkeek Drive S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "9003 Carkeek Drive S., Seattle, WA 98118",
    "purchase_date": "3/10/17",
    "purchase_year": 2017,
    "purchase_amount": 235000,
    "assessed_value": 319000,
    "purchase_amount_vs_assessment": -26.3322884,
    "sale_date": "1/30/18",
    "sale_amount": 550000
  },
  {
    "parcel_id": 7625702085,
    "latitude": 47.549398,
    "longitude": -122.39085,
    "building_number": 5932,
    "street": "46th Ave. S.W.",
    "city": "Seattle",
    "zip": 98136,
    "address": "5932 46th Ave. S.W., Seattle, WA 98136",
    "purchase_date": "3/13/17",
    "purchase_year": 2017,
    "purchase_amount": 532500,
    "assessed_value": 569000,
    "purchase_amount_vs_assessment": -6.414762742,
    "sale_date": "2/20/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 2420069269,
    "latitude": 47.210611,
    "longitude": -121.99047,
    "building_number": 2921,
    "street": "Fredricksen St.",
    "city": "Enumclaw",
    "zip": 98022,
    "address": "2921 Fredricksen St., Enumclaw, WA 98022",
    "purchase_date": "3/13/17",
    "purchase_year": 2017,
    "purchase_amount": 130000,
    "assessed_value": 179000,
    "purchase_amount_vs_assessment": -27.37430168,
    "sale_date": "12/4/17",
    "sale_amount": 275000
  },
  {
    "parcel_id": 5561100110,
    "latitude": 47.455708,
    "longitude": -121.98902,
    "building_number": 16214,
    "street": "264th Place S.E.",
    "city": "Issaquah",
    "zip": 98027,
    "address": "16214 264th Place S.E., Issaquah, WA 98027",
    "purchase_date": "3/16/17",
    "purchase_year": 2017,
    "purchase_amount": 465000,
    "assessed_value": 502000,
    "purchase_amount_vs_assessment": -7.370517928,
    "sale_date": "8/22/17",
    "sale_amount": 682500
  },
  {
    "parcel_id": 9828700305,
    "latitude": 47.620549,
    "longitude": -122.29149,
    "building_number": 211,
    "street": "32nd Ave. E.",
    "city": "Seattle",
    "zip": 98112,
    "address": "211 32nd Ave. E., Seattle, WA 98112",
    "purchase_date": "3/17/17",
    "purchase_year": 2017,
    "purchase_amount": 430000,
    "assessed_value": 466000,
    "purchase_amount_vs_assessment": -7.725321888,
    "sale_date": "3/14/18",
    "sale_amount": 950000
  },
  {
    "parcel_id": 3946900020,
    "latitude": 47.6924288,
    "longitude": -122.3252499,
    "building_number": 8807,
    "street": "5th Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "8807 5th Ave. N.E., Seattle, WA 98115",
    "purchase_date": "3/23/17",
    "purchase_year": 2017,
    "purchase_amount": 1050000,
    "assessed_value": 244000,
    "purchase_amount_vs_assessment": 330.3278689,
    "sale_date": "12/27/18",
    "sale_amount": 1400000
  },
  {
    "parcel_id": 3946900025,
    "latitude": 47.692383,
    "longitude": -122.32337,
    "building_number": 422,
    "street": "N.E. 88th St.",
    "city": "Seattle",
    "zip": 98115,
    "address": "422 N.E. 88th St., Seattle, WA 98115",
    "purchase_date": "3/23/17",
    "purchase_year": 2017,
    "purchase_amount": 1050000,
    "assessed_value": 702000,
    "purchase_amount_vs_assessment": 49.57264957,
    "sale_date": "8/16/18",
    "sale_amount": 1345000
  },
  {
    "parcel_id": 5631500178,
    "latitude": 47.733629,
    "longitude": -122.23052,
    "building_number": 8226,
    "street": "N.E. 145th St.",
    "city": "Kenmore",
    "zip": 98028,
    "address": "8226 N.E. 145th St., Kenmore, WA 98028",
    "purchase_date": "3/29/17",
    "purchase_year": 2017,
    "purchase_amount": 425000,
    "assessed_value": 321000,
    "purchase_amount_vs_assessment": 32.39875389,
    "sale_date": "12/28/17",
    "sale_amount": 620000
  },
  {
    "parcel_id": 8156600106,
    "latitude": 47.677813,
    "longitude": -122.3004,
    "building_number": 2502,
    "street": "N.E. 68th St.",
    "city": "Seattle",
    "zip": 98115,
    "address": "2502 N.E. 68th St., Seattle, WA 98115",
    "purchase_date": "3/31/17",
    "purchase_year": 2017,
    "purchase_amount": 670000,
    "assessed_value": 494000,
    "purchase_amount_vs_assessment": 35.62753036,
    "sale_date": "11/13/17",
    "sale_amount": 915000
  },
  {
    "parcel_id": 889000040,
    "latitude": 47.6632692,
    "longitude": -122.3208665,
    "building_number": 4703,
    "street": "9th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "4703 9th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "4/5/17",
    "purchase_year": 2017,
    "purchase_amount": 750000,
    "assessed_value": 474000,
    "purchase_amount_vs_assessment": 58.2278481,
    "sale_date": "6/8/18",
    "sale_amount": 1250000
  },
  {
    "parcel_id": 2899200030,
    "latitude": 47.509223,
    "longitude": -122.34581,
    "building_number": 10436,
    "street": "9th Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "10436 9th Ave. S.W., Seattle, WA 98146",
    "purchase_date": "4/5/17",
    "purchase_year": 2017,
    "purchase_amount": 297000,
    "assessed_value": 238000,
    "purchase_amount_vs_assessment": 24.78991597,
    "sale_date": "11/7/17",
    "sale_amount": 510000
  },
  {
    "parcel_id": 7839800085,
    "latitude": 47.478438,
    "longitude": -122.2104,
    "building_number": 340,
    "street": "Morris Ave. S.",
    "city": "Renton",
    "zip": 98057,
    "address": "340 Morris Ave. S., Renton, WA 98057",
    "purchase_date": "4/13/17",
    "purchase_year": 2017,
    "purchase_amount": 110000,
    "assessed_value": 261000,
    "purchase_amount_vs_assessment": -57.85440613,
    "sale_date": "11/9/17",
    "sale_amount": 295000
  },
  {
    "parcel_id": 3205400160,
    "latitude": 47.721295,
    "longitude": -122.17853,
    "building_number": 13432,
    "street": "121st Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13432 121st Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "4/17/17",
    "purchase_year": 2017,
    "purchase_amount": 565000,
    "assessed_value": 401000,
    "purchase_amount_vs_assessment": 40.89775561,
    "sale_date": "11/13/18",
    "sale_amount": 785000
  },
  {
    "parcel_id": 7227501340,
    "latitude": 47.494594,
    "longitude": -122.18912,
    "building_number": 2213,
    "street": "N.E. 6th Place",
    "city": "Renton",
    "zip": 98056,
    "address": "2213 N.E. 6th Place, Renton, WA 98056",
    "purchase_date": "4/20/17",
    "purchase_year": 2017,
    "purchase_amount": 225000,
    "assessed_value": 215000,
    "purchase_amount_vs_assessment": 4.651162791,
    "sale_date": "8/18/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 6639900050,
    "latitude": 47.694222,
    "longitude": -122.17814,
    "building_number": 10435,
    "street": "Slater Ave. N.E.",
    "city": "Kirkland",
    "zip": 98033,
    "address": "10435 Slater Ave. N.E., Kirkland, WA 98033",
    "purchase_date": "4/25/17",
    "purchase_year": 2017,
    "purchase_amount": 1200000,
    "assessed_value": 448000,
    "purchase_amount_vs_assessment": 167.8571429,
    "sale_date": "9/13/17",
    "sale_amount": 1900000
  },
  {
    "parcel_id": 3336001800,
    "latitude": 47.526512,
    "longitude": -122.26462,
    "building_number": 8606,
    "street": "Seward Park Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "8606 Seward Park Ave. S., Seattle, WA 98118",
    "purchase_date": "5/1/17",
    "purchase_year": 2017,
    "purchase_amount": 467500,
    "assessed_value": 406000,
    "purchase_amount_vs_assessment": 15.14778325,
    "sale_date": "11/6/17",
    "sale_amount": 550000
  },
  {
    "parcel_id": 3579800400,
    "latitude": 47.734237,
    "longitude": -122.24198,
    "building_number": 7422,
    "street": "N.E. 145th Place",
    "city": "Kenmore",
    "zip": 98028,
    "address": "7422 N.E. 145th Place, Kenmore, WA 98028",
    "purchase_date": "5/3/17",
    "purchase_year": 2017,
    "purchase_amount": 540000,
    "assessed_value": 398000,
    "purchase_amount_vs_assessment": 35.67839196,
    "sale_date": "12/28/17",
    "sale_amount": 719950
  },
  {
    "parcel_id": 1926059041,
    "latitude": 47.732297,
    "longitude": -122.22715,
    "building_number": 14414,
    "street": "85th Place N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "14414 85th Place N.E., Kirkland, WA 98034",
    "purchase_date": "5/4/17",
    "purchase_year": 2017,
    "purchase_amount": 460000,
    "assessed_value": 438000,
    "purchase_amount_vs_assessment": 5.02283105,
    "sale_date": "11/14/17",
    "sale_amount": 775000
  },
  {
    "parcel_id": 1727001060,
    "latitude": 47.639148,
    "longitude": -122.16945,
    "building_number": 12813,
    "street": "N.E. 32nd Place",
    "city": "Bellevue",
    "zip": 98005,
    "address": "12813 N.E. 32nd Place, Bellevue, WA 98005",
    "purchase_date": "5/4/17",
    "purchase_year": 2017,
    "purchase_amount": 850000,
    "assessed_value": 658000,
    "purchase_amount_vs_assessment": 29.17933131,
    "sale_date": "9/5/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 179000198,
    "latitude": 47.493603,
    "longitude": -122.27932,
    "building_number": 12223,
    "street": "43rd Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "12223 43rd Ave. S., Seattle, WA 98178",
    "purchase_date": "5/4/17",
    "purchase_year": 2017,
    "purchase_amount": 205900,
    "assessed_value": 140000,
    "purchase_amount_vs_assessment": 47.07142857,
    "sale_date": "9/1/17",
    "sale_amount": 265000
  },
  {
    "parcel_id": 3876600060,
    "latitude": 47.336859,
    "longitude": -122.29094,
    "building_number": 3213,
    "street": "S. 295th Place",
    "city": "Auburn",
    "zip": 98001,
    "address": "3213 S. 295th Place, Auburn, WA 98001",
    "purchase_date": "5/5/17",
    "purchase_year": 2017,
    "purchase_amount": 145000,
    "assessed_value": 181000,
    "purchase_amount_vs_assessment": -19.88950276,
    "sale_date": "11/28/17",
    "sale_amount": 305000
  },
  {
    "parcel_id": 219000070,
    "latitude": 47.575273,
    "longitude": -122.40389,
    "building_number": 3215,
    "street": "56th Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "3215 56th Ave. S.W., Seattle, WA 98116",
    "purchase_date": "5/9/17",
    "purchase_year": 2017,
    "purchase_amount": 830000,
    "assessed_value": 594000,
    "purchase_amount_vs_assessment": 39.73063973,
    "sale_date": "9/14/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 1788700065,
    "latitude": 47.328688,
    "longitude": -122.34616,
    "building_number": 812,
    "street": "S.W. 305th St.",
    "city": "Federal Way",
    "zip": 98023,
    "address": "812 S.W. 305th St., Federal Way, WA 98023",
    "purchase_date": "5/15/17",
    "purchase_year": 2017,
    "purchase_amount": 160000,
    "assessed_value": 172000,
    "purchase_amount_vs_assessment": -6.976744186,
    "sale_date": "9/12/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 3874900150,
    "latitude": 47.544885,
    "longitude": -122.3781,
    "building_number": 6357,
    "street": "36th Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "6357 36th Ave. S.W., Seattle, WA 98126",
    "purchase_date": "5/24/17",
    "purchase_year": 2017,
    "purchase_amount": 430000,
    "assessed_value": 267000,
    "purchase_amount_vs_assessment": 61.04868914,
    "sale_date": "2/28/18",
    "sale_amount": 800000
  },
  {
    "parcel_id": 3816300045,
    "latitude": 47.7641,
    "longitude": -122.26121,
    "building_number": 6178,
    "street": "N.E. 187th Place",
    "city": "Kenmore",
    "zip": 98028,
    "address": "6178 N.E. 187th Place, Kenmore, WA 98028",
    "purchase_date": "5/25/17",
    "purchase_year": 2017,
    "purchase_amount": 572000,
    "assessed_value": 521000,
    "purchase_amount_vs_assessment": 9.788867562,
    "sale_date": "9/6/18",
    "sale_amount": 1020000
  },
  {
    "parcel_id": 7018000440,
    "latitude": 47.751088,
    "longitude": -122.22814,
    "building_number": 8411,
    "street": "N.E. 169th Place",
    "city": "Kenmore",
    "zip": 98028,
    "address": "8411 N.E. 169th Place, Kenmore, WA 98028",
    "purchase_date": "6/1/17",
    "purchase_year": 2017,
    "purchase_amount": 400000,
    "assessed_value": 389000,
    "purchase_amount_vs_assessment": 2.827763496,
    "sale_date": "1/2/18",
    "sale_amount": 599950
  },
  {
    "parcel_id": 4037500210,
    "latitude": 47.60899,
    "longitude": -122.12275,
    "building_number": 16241,
    "street": "Main St.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "16241 Main St., Bellevue, WA 98008",
    "purchase_date": "6/6/17",
    "purchase_year": 2017,
    "purchase_amount": 715000,
    "assessed_value": 465000,
    "purchase_amount_vs_assessment": 53.76344086,
    "sale_date": "2/26/18",
    "sale_amount": 1003000
  },
  {
    "parcel_id": 3739500079,
    "latitude": 47.736594,
    "longitude": -122.30707,
    "building_number": 14734,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "14734 20th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "6/6/17",
    "purchase_year": 2017,
    "purchase_amount": 525000,
    "assessed_value": 406000,
    "purchase_amount_vs_assessment": 29.31034483,
    "sale_date": "1/12/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 7899800095,
    "latitude": 47.523367,
    "longitude": -122.3554,
    "building_number": 8847,
    "street": "16th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "8847 16th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "6/8/17",
    "purchase_year": 2017,
    "purchase_amount": 290000,
    "assessed_value": 313000,
    "purchase_amount_vs_assessment": -7.348242812,
    "sale_date": "2/15/18",
    "sale_amount": 635000
  },
  {
    "parcel_id": 6844703870,
    "latitude": 47.696924,
    "longitude": -122.28567,
    "building_number": 3846,
    "street": "N.E. 94th St.",
    "city": "Seattle",
    "zip": 98115,
    "address": "3846 N.E. 94th St., Seattle, WA 98115",
    "purchase_date": "6/15/17",
    "purchase_year": 2017,
    "purchase_amount": 850000,
    "assessed_value": 805000,
    "purchase_amount_vs_assessment": 5.590062112,
    "sale_date": "1/10/18",
    "sale_amount": 1210000
  },
  {
    "parcel_id": 2898600010,
    "latitude": 47.512604,
    "longitude": -122.34607,
    "building_number": 10038,
    "street": "9th Ave. S.W.",
    "city": "Seattle",
    "zip": 98146,
    "address": "10038 9th Ave. S.W., Seattle, WA 98146",
    "purchase_date": "6/21/17",
    "purchase_year": 2017,
    "purchase_amount": 265000,
    "assessed_value": 198000,
    "purchase_amount_vs_assessment": 33.83838384,
    "sale_date": "7/11/18",
    "sale_amount": 528000
  },
  {
    "parcel_id": 7173700150,
    "latitude": 47.665895,
    "longitude": -122.30622,
    "building_number": 5032,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5032 20th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "6/28/17",
    "purchase_year": 2017,
    "purchase_amount": 1210000,
    "assessed_value": 711000,
    "purchase_amount_vs_assessment": 70.18284107,
    "sale_date": "5/21/18",
    "sale_amount": 1400000
  },
  {
    "parcel_id": 7950304215,
    "latitude": 47.562691,
    "longitude": -122.28145,
    "building_number": 4502,
    "street": "41st Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "4502 41st Ave. S., Seattle, WA 98118",
    "purchase_date": "6/28/17",
    "purchase_year": 2017,
    "purchase_amount": 350000,
    "assessed_value": 252000,
    "purchase_amount_vs_assessment": 38.88888889,
    "sale_date": "2/13/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 5379804478,
    "latitude": 47.449709,
    "longitude": -122.27626,
    "building_number": 4454,
    "street": "S. 172nd St.",
    "city": "Seattle",
    "zip": 98188,
    "address": "4454 S. 172nd St., Seattle, WA 98188",
    "purchase_date": "7/3/17",
    "purchase_year": 2017,
    "purchase_amount": 125000,
    "assessed_value": 105000,
    "purchase_amount_vs_assessment": 19.04761905,
    "sale_date": "3/21/18",
    "sale_amount": 350000
  },
  {
    "parcel_id": 3416600690,
    "latitude": 47.602773,
    "longitude": -122.29283,
    "building_number": 137,
    "street": "31st Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "137 31st Ave., Seattle, WA 98122",
    "purchase_date": "7/17/17",
    "purchase_year": 2017,
    "purchase_amount": 750000,
    "assessed_value": 646000,
    "purchase_amount_vs_assessment": 16.09907121,
    "sale_date": "8/7/18",
    "sale_amount": 1250000
  },
  {
    "parcel_id": 9178600755,
    "latitude": 47.654525,
    "longitude": -122.33197,
    "building_number": 2212,
    "street": "N. 39th St.",
    "city": "Seattle",
    "zip": 98103,
    "address": "2212 N. 39th St., Seattle, WA 98103",
    "purchase_date": "7/18/17",
    "purchase_year": 2017,
    "purchase_amount": 710000,
    "assessed_value": 623000,
    "purchase_amount_vs_assessment": 13.964687,
    "sale_date": "4/29/18",
    "sale_amount": 1270000
  },
  {
    "parcel_id": 8121101160,
    "latitude": 47.570162,
    "longitude": -122.28253,
    "building_number": 3716,
    "street": "Cascadia Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "3716 Cascadia Ave. S., Seattle, WA 98144",
    "purchase_date": "7/19/17",
    "purchase_year": 2017,
    "purchase_amount": 1050000,
    "assessed_value": 1321000,
    "purchase_amount_vs_assessment": -20.51476154,
    "sale_date": "3/19/19",
    "sale_amount": 2390000
  },
  {
    "parcel_id": 5606000220,
    "latitude": 47.665122,
    "longitude": -122.27012,
    "building_number": 5015,
    "street": "Ivanhoe Place N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5015 Ivanhoe Place N.E., Seattle, WA 98105",
    "purchase_date": "7/27/17",
    "purchase_year": 2017,
    "purchase_amount": 810000,
    "assessed_value": 634000,
    "purchase_amount_vs_assessment": 27.76025237,
    "sale_date": "9/13/17",
    "sale_amount": 1050000
  },
  {
    "parcel_id": 5016002745,
    "latitude": 47.62346,
    "longitude": -122.30147,
    "building_number": 425,
    "street": "24th Ave. E.",
    "city": "Seattle",
    "zip": 98112,
    "address": "425 24th Ave. E., Seattle, WA 98112",
    "purchase_date": "7/28/17",
    "purchase_year": 2017,
    "purchase_amount": 781000,
    "assessed_value": 526000,
    "purchase_amount_vs_assessment": 48.47908745,
    "sale_date": "9/21/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 3298400420,
    "latitude": 47.625351,
    "longitude": -122.12076,
    "building_number": 1612,
    "street": "164th Place N.E.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "1612 164th Place N.E., Bellevue, WA 98008",
    "purchase_date": "8/1/17",
    "purchase_year": 2017,
    "purchase_amount": 506000,
    "assessed_value": 407000,
    "purchase_amount_vs_assessment": 24.32432432,
    "sale_date": "8/18/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 2516000290,
    "latitude": 47.658346,
    "longitude": -122.36326,
    "building_number": 4217,
    "street": "5th Ave. N.W.",
    "city": "Seattle",
    "zip": 98107,
    "address": "4217 5th Ave. N.W., Seattle, WA 98107",
    "purchase_date": "8/3/17",
    "purchase_year": 2017,
    "purchase_amount": 650000,
    "assessed_value": 616000,
    "purchase_amount_vs_assessment": 5.519480519,
    "sale_date": "4/13/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 2926059165,
    "latitude": 47.704325,
    "longitude": -122.1927,
    "building_number": 11104,
    "street": "N.E. 116th St.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "11104 N.E. 116th St., Kirkland, WA 98034",
    "purchase_date": "8/8/17",
    "purchase_year": 2017,
    "purchase_amount": 475000,
    "assessed_value": 406000,
    "purchase_amount_vs_assessment": 16.99507389,
    "sale_date": "1/29/18",
    "sale_amount": 561950
  },
  {
    "parcel_id": 8947000005,
    "latitude": 47.51005,
    "longitude": -122.34104,
    "building_number": 509,
    "street": "S.W. 104th St.",
    "city": "Seattle",
    "zip": 98146,
    "address": "509 S.W. 104th St., Seattle, WA 98146",
    "purchase_date": "8/17/17",
    "purchase_year": 2017,
    "purchase_amount": 291000,
    "assessed_value": 201000,
    "purchase_amount_vs_assessment": 44.7761194,
    "sale_date": "9/12/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 3876000340,
    "latitude": 47.725225,
    "longitude": -122.18749,
    "building_number": 11514,
    "street": "N.E. 139th Place",
    "city": "Kirkland",
    "zip": 98034,
    "address": "11514 N.E. 139th Place, Kirkland, WA 98034",
    "purchase_date": "8/21/17",
    "purchase_year": 2017,
    "purchase_amount": 470000,
    "assessed_value": 455000,
    "purchase_amount_vs_assessment": 3.296703297,
    "sale_date": "6/27/18",
    "sale_amount": 800000
  },
  {
    "parcel_id": 1066100200,
    "latitude": 47.617248,
    "longitude": -122.10609,
    "building_number": 819,
    "street": "176th Ave. N.E.",
    "city": "Bellevue",
    "zip": 98008,
    "address": "819 176th Ave. N.E., Bellevue, WA 98008",
    "purchase_date": "8/23/17",
    "purchase_year": 2017,
    "purchase_amount": 780000,
    "assessed_value": 593000,
    "purchase_amount_vs_assessment": 31.53456998,
    "sale_date": "6/25/18",
    "sale_amount": 1175000
  },
  {
    "parcel_id": 9477000050,
    "latitude": 47.733557,
    "longitude": -122.19316,
    "building_number": 11109,
    "street": "N.E. 146th St.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "11109 N.E. 146th St., Kirkland, WA 98034",
    "purchase_date": "8/24/17",
    "purchase_year": 2017,
    "purchase_amount": 355000,
    "assessed_value": 386000,
    "purchase_amount_vs_assessment": -8.031088083,
    "sale_date": "1/2/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 421000065,
    "latitude": 47.494366,
    "longitude": -122.16903,
    "building_number": 683,
    "street": "Redmond Ave. N.E.",
    "city": "Renton",
    "zip": 98056,
    "address": "683 Redmond Ave. N.E., Renton, WA 98056",
    "purchase_date": "8/28/17",
    "purchase_year": 2017,
    "purchase_amount": 205000,
    "assessed_value": 203000,
    "purchase_amount_vs_assessment": 0.9852216749,
    "sale_date": "2/23/18",
    "sale_amount": 427460
  },
  {
    "parcel_id": 8864000360,
    "latitude": 47.481007,
    "longitude": -122.2904,
    "building_number": 3232,
    "street": "S. 137th St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "3232 S. 137th St., Seattle, WA 98168",
    "purchase_date": "8/29/17",
    "purchase_year": 2017,
    "purchase_amount": 213000,
    "assessed_value": 206000,
    "purchase_amount_vs_assessment": 3.398058252,
    "sale_date": "1/4/18",
    "sale_amount": 400000
  },
  {
    "parcel_id": 2130701030,
    "latitude": 47.742184,
    "longitude": -121.98427,
    "building_number": 15728,
    "street": "1st Ave. N.E.",
    "city": "Duvall",
    "zip": 98019,
    "address": "15728 1st Ave. N.E., Duvall, WA 98019",
    "purchase_date": "8/30/17",
    "purchase_year": 2017,
    "purchase_amount": 830000,
    "assessed_value": 589000,
    "purchase_amount_vs_assessment": 40.91680815
  },
  {
    "parcel_id": 621069124,
    "latitude": 47.340598,
    "longitude": -122.09163,
    "building_number": 29031,
    "street": "188th Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "29031 188th Ave. S.E., Kent, WA 98042",
    "purchase_date": "8/31/17",
    "purchase_year": 2017,
    "purchase_amount": 56000,
    "assessed_value": 169000,
    "purchase_amount_vs_assessment": -66.86390533,
    "sale_date": "11/7/18",
    "sale_amount": 357000
  },
  {
    "parcel_id": 7937600110,
    "latitude": 47.438004,
    "longitude": -122.08051,
    "building_number": 18315,
    "street": "196th Ave. S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "18315 196th Ave. S.E., Renton, WA 98058",
    "purchase_date": "9/8/17",
    "purchase_year": 2017,
    "purchase_amount": 108500,
    "assessed_value": 516000,
    "purchase_amount_vs_assessment": -78.97286822
  },
  {
    "parcel_id": 1438200080,
    "latitude": 47.545444,
    "longitude": -122.29,
    "building_number": 6320,
    "street": "33rd Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "6320 33rd Ave. S., Seattle, WA 98118",
    "purchase_date": "9/13/17",
    "purchase_year": 2017,
    "purchase_amount": 425000,
    "assessed_value": 388000,
    "purchase_amount_vs_assessment": 9.536082474,
    "sale_date": "5/22/18",
    "sale_amount": 750000
  },
  {
    "parcel_id": 1245000946,
    "latitude": 47.690381,
    "longitude": -122.20798,
    "building_number": 1826,
    "street": "1st St.",
    "city": "Kirkland",
    "zip": 98033,
    "address": "1826 1st St., Kirkland, WA 98033",
    "purchase_date": "9/15/17",
    "purchase_year": 2017,
    "purchase_amount": 575000,
    "assessed_value": 567000,
    "purchase_amount_vs_assessment": 1.410934744,
    "sale_date": "2/12/18",
    "sale_amount": 860000
  },
  {
    "parcel_id": 9274201930,
    "latitude": 47.589584,
    "longitude": -122.39,
    "building_number": 1534,
    "street": "46th Ave. S.W.",
    "city": "Seattle",
    "zip": 98116,
    "address": "1534 46th Ave. S.W., Seattle, WA 98116",
    "purchase_date": "9/19/17",
    "purchase_year": 2017,
    "purchase_amount": 699000,
    "assessed_value": 648000,
    "purchase_amount_vs_assessment": 7.87037037,
    "sale_date": "9/10/18",
    "sale_amount": 1350000
  },
  {
    "parcel_id": 390100040,
    "latitude": 47.756174,
    "longitude": -122.3395,
    "building_number": 1616,
    "street": "N. 175th St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "1616 N. 175th St., Seattle, WA 98133",
    "purchase_date": "9/26/17",
    "purchase_year": 2017,
    "purchase_amount": 260000,
    "assessed_value": 226000,
    "purchase_amount_vs_assessment": 15.04424779,
    "sale_date": "4/10/19",
    "sale_amount": 485000
  },
  {
    "parcel_id": 1951600010,
    "latitude": 47.372043,
    "longitude": -122.29627,
    "building_number": 25604,
    "street": "29th Ave. S.",
    "city": "Kent",
    "zip": 98032,
    "address": "25604 29th Ave. S., Kent, WA 98032",
    "purchase_date": "9/28/17",
    "purchase_year": 2017,
    "purchase_amount": 160000,
    "assessed_value": 176000,
    "purchase_amount_vs_assessment": -9.090909091,
    "sale_date": "4/10/18",
    "sale_amount": 330000
  },
  {
    "parcel_id": 1226059135,
    "latitude": 47.751119,
    "longitude": -122.10917,
    "building_number": 17006,
    "street": "172nd Place N.E.",
    "city": "Woodinville",
    "zip": 98072,
    "address": "17006 172nd Place N.E., Woodinville, WA 98072",
    "purchase_date": "10/3/17",
    "purchase_year": 2017,
    "purchase_amount": 515000,
    "assessed_value": 588000,
    "purchase_amount_vs_assessment": -12.41496599,
    "sale_date": "2/12/19",
    "sale_amount": 799950
  },
  {
    "parcel_id": 3626039217,
    "latitude": 47.703183,
    "longitude": -122.3664,
    "building_number": 10055,
    "street": "8th Ave. N.W.",
    "city": "Seattle",
    "zip": 98177,
    "address": "10055 8th Ave. N.W., Seattle, WA 98177",
    "purchase_date": "10/5/17",
    "purchase_year": 2017,
    "purchase_amount": 465000,
    "assessed_value": 356000,
    "purchase_amount_vs_assessment": 30.61797753
  },
  {
    "parcel_id": 1521049086,
    "latitude": 47.306309,
    "longitude": -122.27237,
    "building_number": 32859,
    "street": "46th Place S.",
    "city": "Auburn",
    "zip": 98001,
    "address": "32859 46th Place S., Auburn, WA 98001",
    "purchase_date": "10/9/17",
    "purchase_year": 2017,
    "purchase_amount": 185000,
    "assessed_value": 278000,
    "purchase_amount_vs_assessment": -33.45323741,
    "sale_date": "10/19/18",
    "sale_amount": 445000
  },
  {
    "parcel_id": 1270000120,
    "latitude": 47.708078,
    "longitude": -122.22511,
    "building_number": 12020,
    "street": "87th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "12020 87th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "10/11/17",
    "purchase_year": 2017,
    "purchase_amount": 805000,
    "assessed_value": 984000,
    "purchase_amount_vs_assessment": -18.19105691,
    "sale_date": "9/5/19",
    "sale_amount": 0
  },
  {
    "parcel_id": 1508210360,
    "latitude": 47.67708,
    "longitude": -122.10929,
    "building_number": 8231,
    "street": "172nd Ave. N.E.",
    "city": "Redmond",
    "zip": 98052,
    "address": "8231 172nd Ave. N.E., Redmond, WA 98052",
    "purchase_date": "10/14/17",
    "purchase_year": 2017,
    "purchase_amount": 375000,
    "assessed_value": 279000,
    "purchase_amount_vs_assessment": 34.40860215,
    "sale_date": "2/20/19",
    "sale_amount": 849950
  },
  {
    "parcel_id": 2807100165,
    "latitude": 47.763844,
    "longitude": -122.34005,
    "building_number": 18522,
    "street": "Ashworth Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "18522 Ashworth Ave. N., Seattle, WA 98133",
    "purchase_date": "10/16/17",
    "purchase_year": 2017,
    "purchase_amount": 528250,
    "assessed_value": 396000,
    "purchase_amount_vs_assessment": 33.39646465,
    "sale_date": "6/15/18",
    "sale_amount": 799950
  },
  {
    "parcel_id": 2201501170,
    "latitude": 47.576267,
    "longitude": -122.135,
    "building_number": 15418,
    "street": "S.E. 38th St.",
    "city": "Bellevue",
    "zip": 98006,
    "address": "15418 S.E. 38th St., Bellevue, WA 98006",
    "purchase_date": "10/20/17",
    "purchase_year": 2017,
    "purchase_amount": 600000,
    "assessed_value": 432000,
    "purchase_amount_vs_assessment": 38.88888889,
    "sale_date": "4/24/18",
    "sale_amount": 825000
  },
  {
    "parcel_id": 9464700050,
    "latitude": 47.644908,
    "longitude": -122.14956,
    "building_number": 3818,
    "street": "142nd Place N.E.",
    "city": "Bellevue",
    "zip": 98007,
    "address": "3818 142nd Place N.E., Bellevue, WA 98007",
    "purchase_date": "10/27/17",
    "purchase_year": 2017,
    "purchase_amount": 910000,
    "assessed_value": 822000,
    "purchase_amount_vs_assessment": 10.70559611,
    "sale_date": "8/3/18",
    "sale_amount": 1360000
  },
  {
    "parcel_id": 4213900020,
    "latitude": 47.766124,
    "longitude": -122.33014,
    "building_number": 2345,
    "street": "N. 189th St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "2345 N. 189th St., Seattle, WA 98133",
    "purchase_date": "11/2/17",
    "purchase_year": 2017,
    "purchase_amount": 415000,
    "assessed_value": 386000,
    "purchase_amount_vs_assessment": 7.512953368,
    "sale_date": "1/18/18",
    "sale_amount": 630000
  },
  {
    "parcel_id": 9144100119,
    "latitude": 47.701299,
    "longitude": -122.37436,
    "building_number": 1405,
    "street": "N.W. 100th St.",
    "city": "Seattle",
    "zip": 98177,
    "address": "1405 N.W. 100th St., Seattle, WA 98177",
    "purchase_date": "11/10/17",
    "purchase_year": 2017,
    "purchase_amount": 560000,
    "assessed_value": 419000,
    "purchase_amount_vs_assessment": 33.65155131,
    "sale_date": "1/9/18",
    "sale_amount": 678500
  },
  {
    "parcel_id": 6370400050,
    "latitude": 47.491282,
    "longitude": -122.25738,
    "building_number": 6112,
    "street": "S. 125th St.",
    "city": "Seattle",
    "zip": 98178,
    "address": "6112 S. 125th St., Seattle, WA 98178",
    "purchase_date": "11/15/17",
    "purchase_year": 2017,
    "purchase_amount": 395000,
    "assessed_value": 298000,
    "purchase_amount_vs_assessment": 32.55033557,
    "sale_date": "6/18/18",
    "sale_amount": 635000
  },
  {
    "parcel_id": 8819900205,
    "latitude": 47.669993,
    "longitude": -122.28876,
    "building_number": 5550,
    "street": "36th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5550 36th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "11/29/17",
    "purchase_year": 2017,
    "purchase_amount": 670000,
    "assessed_value": 518000,
    "purchase_amount_vs_assessment": 29.34362934,
    "sale_date": "8/29/18",
    "sale_amount": 949950
  },
  {
    "parcel_id": 8819900205,
    "latitude": 47.669993,
    "longitude": -122.28876,
    "building_number": 5550,
    "street": "36th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5550 36th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "11/29/17",
    "purchase_year": 2017,
    "purchase_amount": 670000,
    "assessed_value": 518000,
    "purchase_amount_vs_assessment": 29.34362934,
    "sale_date": "8/29/18",
    "sale_amount": 949950
  },
  {
    "parcel_id": 7234600485,
    "latitude": 47.616275,
    "longitude": -122.31049,
    "building_number": 1633,
    "street": "17th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "1633 17th Ave., Seattle, WA 98122",
    "purchase_date": "12/1/17",
    "purchase_year": 2017,
    "purchase_amount": 2572000,
    "assessed_value": 1595100,
    "purchase_amount_vs_assessment": 61.24380917
  },
  {
    "parcel_id": 4059400430,
    "latitude": 47.500267,
    "longitude": -122.24281,
    "building_number": 11423,
    "street": "Woodley Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11423 Woodley Ave. S., Seattle, WA 98178",
    "purchase_date": "12/5/17",
    "purchase_year": 2017,
    "purchase_amount": 300000,
    "assessed_value": 247000,
    "purchase_amount_vs_assessment": 21.45748988,
    "sale_date": "8/18/18",
    "sale_amount": 490000
  },
  {
    "parcel_id": 7812800095,
    "latitude": 47.49865,
    "longitude": -122.2393,
    "building_number": 7459,
    "street": "S. 116th St.",
    "city": "Seattle",
    "zip": 98178,
    "address": "7459 S. 116th St., Seattle, WA 98178",
    "purchase_date": "12/6/17",
    "purchase_year": 2017,
    "purchase_amount": 300000,
    "assessed_value": 218000,
    "purchase_amount_vs_assessment": 37.6146789,
    "sale_date": "12/15/17",
    "sale_amount": 0
  },
  {
    "parcel_id": 2770604225,
    "latitude": 47.642378,
    "longitude": -122.37401,
    "building_number": 2557,
    "street": "13th Ave. W.",
    "city": "Seattle",
    "zip": 98119,
    "address": "2557 13th Ave. W., Seattle, WA 98119",
    "purchase_date": "12/7/17",
    "purchase_year": 2017,
    "purchase_amount": 1050000,
    "assessed_value": 914000,
    "purchase_amount_vs_assessment": 14.87964989,
    "sale_date": "9/14/18",
    "sale_amount": 1570000
  },
  {
    "parcel_id": 1865800170,
    "latitude": 47.373465,
    "longitude": -122.11683,
    "building_number": 25410,
    "street": "168th Place S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "25410 168th Place S.E., Kent, WA 98042",
    "purchase_date": "12/9/17",
    "purchase_year": 2017,
    "purchase_amount": 215000,
    "assessed_value": 226000,
    "purchase_amount_vs_assessment": -4.867256637,
    "sale_date": "5/1/18",
    "sale_amount": 385000
  },
  {
    "parcel_id": 2212900090,
    "latitude": 47.32838,
    "longitude": -122.13806,
    "building_number": 30421,
    "street": "153rd Ave. S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "30421 153rd Ave. S.E., Kent, WA 98042",
    "purchase_date": "12/20/17",
    "purchase_year": 2017,
    "purchase_amount": 171000,
    "assessed_value": 204000,
    "purchase_amount_vs_assessment": -16.17647059,
    "sale_date": "1/5/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 1432400710,
    "latitude": 47.451069,
    "longitude": -122.18046,
    "building_number": 12012,
    "street": "S.E. 169th Place",
    "city": "Renton",
    "zip": 98058,
    "address": "12012 S.E. 169th Place, Renton, WA 98058",
    "purchase_date": "12/21/17",
    "purchase_year": 2017,
    "purchase_amount": 205000,
    "assessed_value": 214000,
    "purchase_amount_vs_assessment": -4.205607477,
    "sale_date": "7/11/18",
    "sale_amount": 399950
  },
  {
    "parcel_id": 16000540,
    "latitude": 47.309598,
    "longitude": -122.20934,
    "building_number": 118,
    "street": "Pike St. N.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "118 Pike St. N.E., Auburn, WA 98002",
    "purchase_date": "1/10/18",
    "purchase_year": 2018,
    "purchase_amount": 171000,
    "assessed_value": 187000,
    "purchase_amount_vs_assessment": -8.556149733,
    "sale_date": "7/22/19",
    "sale_amount": 305000
  },
  {
    "parcel_id": 2123049533,
    "latitude": 47.472774,
    "longitude": -122.29822,
    "building_number": 14527,
    "street": "27th Place S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "14527 27th Place S., Seattle, WA 98168",
    "purchase_date": "2/2/18",
    "purchase_year": 2018,
    "purchase_amount": 245000,
    "assessed_value": 201000,
    "purchase_amount_vs_assessment": 21.89054726,
    "sale_date": "2/20/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 8864000045,
    "latitude": 47.481181,
    "longitude": -122.28759,
    "building_number": 13544,
    "street": "35th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "13544 35th Ave. S., Seattle, WA 98168",
    "purchase_date": "2/2/18",
    "purchase_year": 2018,
    "purchase_amount": 230000,
    "assessed_value": 107000,
    "purchase_amount_vs_assessment": 114.953271,
    "sale_date": "2/21/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 1148000100,
    "latitude": 47.482327,
    "longitude": -122.34403,
    "building_number": 650,
    "street": "S.W. 135th St.",
    "city": "Seattle",
    "zip": 98146,
    "address": "650 S.W. 135th St., Seattle, WA 98146",
    "purchase_date": "2/5/18",
    "purchase_year": 2018,
    "purchase_amount": 275000,
    "assessed_value": 261000,
    "purchase_amount_vs_assessment": 5.363984674,
    "sale_date": "2/20/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 7883604915,
    "latitude": 47.524597,
    "longitude": -122.32147,
    "building_number": 833,
    "street": "S. Trenton St.",
    "city": "Seattle",
    "zip": 98108,
    "address": "833 S. Trenton St., Seattle, WA 98108",
    "purchase_date": "2/12/18",
    "purchase_year": 2018,
    "purchase_amount": 265000,
    "assessed_value": 199000,
    "purchase_amount_vs_assessment": 33.16582915,
    "sale_date": "5/22/18",
    "sale_amount": 399950
  },
  {
    "parcel_id": 6818400010,
    "latitude": 47.456333,
    "longitude": -122.26958,
    "building_number": 5118,
    "street": "S. 164th St.",
    "city": "Seattle",
    "zip": 98188,
    "address": "5118 S. 164th St., Seattle, WA 98188",
    "purchase_date": "2/16/18",
    "purchase_year": 2018,
    "purchase_amount": 275000,
    "assessed_value": 320000,
    "purchase_amount_vs_assessment": -14.0625,
    "sale_date": "6/14/19",
    "sale_amount": 540000
  },
  {
    "parcel_id": 423059302,
    "latitude": 47.505459,
    "longitude": -122.17105,
    "building_number": 1433,
    "street": "Queen Ave. N.E.",
    "city": "Renton",
    "zip": 98056,
    "address": "1433 Queen Ave. N.E., Renton, WA 98056",
    "purchase_date": "2/22/18",
    "purchase_year": 2018,
    "purchase_amount": 337500,
    "assessed_value": 365000,
    "purchase_amount_vs_assessment": -7.534246575,
    "sale_date": "5/30/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 7813200105,
    "latitude": 47.493569,
    "longitude": -122.24447,
    "building_number": 12017,
    "street": "71st Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "12017 71st Ave. S., Seattle, WA 98178",
    "purchase_date": "2/22/18",
    "purchase_year": 2018,
    "purchase_amount": 260000,
    "assessed_value": 228000,
    "purchase_amount_vs_assessment": 14.03508772,
    "sale_date": "3/16/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 6197200220,
    "latitude": 47.439014,
    "longitude": -122.18401,
    "building_number": 18225,
    "street": "118th Ave. S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "18225 118th Ave. S.E., Renton, WA 98058",
    "purchase_date": "2/27/18",
    "purchase_year": 2018,
    "purchase_amount": 214500,
    "assessed_value": 181000,
    "purchase_amount_vs_assessment": 18.50828729,
    "sale_date": "3/16/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 5466300380,
    "latitude": 47.379125,
    "longitude": -122.1469,
    "building_number": 24809,
    "street": "145th Lane S.E.",
    "city": "Kent",
    "zip": 98042,
    "address": "24809 145th Lane S.E., Kent, WA 98042",
    "purchase_date": "3/9/18",
    "purchase_year": 2018,
    "purchase_amount": 180000,
    "assessed_value": 206000,
    "purchase_amount_vs_assessment": -12.62135922,
    "sale_date": "6/27/18",
    "sale_amount": 300000
  },
  {
    "parcel_id": 4365200875,
    "latitude": 47.521884,
    "longitude": -122.37431,
    "building_number": 9031,
    "street": "32nd Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "9031 32nd Ave. S.W., Seattle, WA 98126",
    "purchase_date": "3/12/18",
    "purchase_year": 2018,
    "purchase_amount": 464000,
    "assessed_value": 387000,
    "purchase_amount_vs_assessment": 19.89664083,
    "sale_date": "5/1/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 4157500030,
    "latitude": 47.592386,
    "longitude": -122.13561,
    "building_number": 15305,
    "street": "S.E. 20th St.",
    "city": "Bellevue",
    "zip": 98007,
    "address": "15305 S.E. 20th St., Bellevue, WA 98007",
    "purchase_date": "3/14/18",
    "purchase_year": 2018,
    "purchase_amount": 715000,
    "assessed_value": 554000,
    "purchase_amount_vs_assessment": 29.06137184,
    "sale_date": "4/12/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 1721801680,
    "latitude": 47.508907,
    "longitude": -122.33404,
    "building_number": 10449,
    "street": "1st Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "10449 1st Ave. S., Seattle, WA 98168",
    "purchase_date": "3/21/18",
    "purchase_year": 2018,
    "purchase_amount": 240000,
    "assessed_value": 250000,
    "purchase_amount_vs_assessment": -4,
    "sale_date": "12/3/18",
    "sale_amount": 475000
  },
  {
    "parcel_id": 1123049086,
    "latitude": 47.499194,
    "longitude": -122.24988,
    "building_number": 11605,
    "street": "Renton Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11605 Renton Ave. S., Seattle, WA 98178",
    "purchase_date": "3/23/18",
    "purchase_year": 2018,
    "purchase_amount": 359975,
    "assessed_value": 284000,
    "purchase_amount_vs_assessment": 26.75176056,
    "sale_date": "4/27/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 2473520580,
    "latitude": 47.453705,
    "longitude": -122.12846,
    "building_number": 16626,
    "street": "158th Place S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "16626 158th Place S.E., Renton, WA 98058",
    "purchase_date": "3/27/18",
    "purchase_year": 2018,
    "purchase_amount": 380000,
    "assessed_value": 382000,
    "purchase_amount_vs_assessment": -0.5235602094,
    "sale_date": "6/15/18",
    "sale_amount": 475000
  },
  {
    "parcel_id": 8864000720,
    "latitude": 47.480637,
    "longitude": -122.28684,
    "building_number": 3519,
    "street": "S. 137th St.",
    "city": "Seattle",
    "zip": 98168,
    "address": "3519 S. 137th St., Seattle, WA 98168",
    "purchase_date": "3/30/18",
    "purchase_year": 2018,
    "purchase_amount": 250000,
    "assessed_value": 241000,
    "purchase_amount_vs_assessment": 3.734439834,
    "sale_date": "4/12/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 9477000830,
    "latitude": 47.736085,
    "longitude": -122.19226,
    "building_number": 11203,
    "street": "N.E. 149th St.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "11203 N.E. 149th St., Kirkland, WA 98034",
    "purchase_date": "4/2/18",
    "purchase_year": 2018,
    "purchase_amount": 525000,
    "assessed_value": 413000,
    "purchase_amount_vs_assessment": 27.11864407,
    "sale_date": "11/5/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 8645511390,
    "latitude": 47.467124,
    "longitude": -122.17663,
    "building_number": 1652,
    "street": "Index Ave. S.E.",
    "city": "Renton",
    "zip": 98058,
    "address": "1652 Index Ave. S.E., Renton, WA 98058",
    "purchase_date": "4/3/18",
    "purchase_year": 2018,
    "purchase_amount": 360000,
    "assessed_value": 322000,
    "purchase_amount_vs_assessment": 11.80124224,
    "sale_date": "4/24/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 826069077,
    "latitude": 47.75008,
    "longitude": -122.06552,
    "building_number": 16716,
    "street": "203rd Place N.E.",
    "city": "Woodinville",
    "zip": 98077,
    "address": "16716 203rd Place N.E., Woodinville, WA 98077",
    "purchase_date": "4/6/18",
    "purchase_year": 2018,
    "purchase_amount": 499015,
    "assessed_value": 588000,
    "purchase_amount_vs_assessment": -15.1335034,
    "sale_date": "5/7/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 9352900895,
    "latitude": 47.518472,
    "longitude": -122.35897,
    "building_number": 9424,
    "street": "20th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "9424 20th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "4/11/18",
    "purchase_year": 2018,
    "purchase_amount": 310000,
    "assessed_value": 306000,
    "purchase_amount_vs_assessment": 1.307189542,
    "sale_date": "5/9/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 5561400120,
    "latitude": 47.462523,
    "longitude": -122.00895,
    "building_number": 24957,
    "street": "S.E. 155th Place",
    "city": "Issaquah",
    "zip": 98027,
    "address": "24957 S.E. 155th Place, Issaquah, WA 98027",
    "purchase_date": "4/17/18",
    "purchase_year": 2018,
    "purchase_amount": 565000,
    "assessed_value": 535000,
    "purchase_amount_vs_assessment": 5.607476636,
    "sale_date": "5/8/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 3336001535,
    "latitude": 47.526372,
    "longitude": -122.26612,
    "building_number": 8615,
    "street": "Wabash Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "8615 Wabash Ave. S., Seattle, WA 98118",
    "purchase_date": "4/20/18",
    "purchase_year": 2018,
    "purchase_amount": 310000,
    "assessed_value": 386000,
    "purchase_amount_vs_assessment": -19.68911917,
    "sale_date": "12/20/18",
    "sale_amount": 599950
  },
  {
    "parcel_id": 5700002525,
    "latitude": 47.581318,
    "longitude": -122.28767,
    "building_number": 2500,
    "street": "Lake Park Drive S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2500 Lake Park Drive S., Seattle, WA 98144",
    "purchase_date": "4/24/18",
    "purchase_year": 2018,
    "purchase_amount": 725000,
    "assessed_value": 863000,
    "purchase_amount_vs_assessment": -15.99073001,
    "sale_date": "6/14/19",
    "sale_amount": 1546500
  },
  {
    "parcel_id": 2729200040,
    "latitude": 47.573238,
    "longitude": -122.3046,
    "building_number": 3328,
    "street": "21st Ave. S.",
    "city": "Seattle",
    "zip": 98144,
    "address": "3328 21st Ave. S., Seattle, WA 98144",
    "purchase_date": "4/30/18",
    "purchase_year": 2018,
    "purchase_amount": 500000,
    "assessed_value": 372000,
    "purchase_amount_vs_assessment": 34.40860215,
    "sale_date": "8/14/19",
    "sale_amount": 850000
  },
  {
    "parcel_id": 4302200620,
    "latitude": 47.527854,
    "longitude": -122.35541,
    "building_number": 8415,
    "street": "16th Ave. S.W.",
    "city": "Seattle",
    "zip": 98106,
    "address": "8415 16th Ave. S.W., Seattle, WA 98106",
    "purchase_date": "5/7/18",
    "purchase_year": 2018,
    "purchase_amount": 410500,
    "assessed_value": 328000,
    "purchase_amount_vs_assessment": 25.15243902,
    "sale_date": "6/19/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 7152200405,
    "latitude": 47.613109,
    "longitude": -122.29111,
    "building_number": 3200,
    "street": "E. Union St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "3200 E. Union St., Seattle, WA 98122",
    "purchase_date": "5/8/18",
    "purchase_year": 2018,
    "purchase_amount": 3210200,
    "assessed_value": 2555000,
    "purchase_amount_vs_assessment": 25.64383562
  },
  {
    "parcel_id": 922059092,
    "latitude": 47.410986,
    "longitude": -122.18649,
    "building_number": 21244,
    "street": "116th Ave. S.E.",
    "city": "Kent",
    "zip": 98031,
    "address": "21244 116th Ave. S.E., Kent, WA 98031",
    "purchase_date": "5/8/18",
    "purchase_year": 2018,
    "purchase_amount": 370000,
    "assessed_value": 367000,
    "purchase_amount_vs_assessment": 0.8174386921,
    "sale_date": "6/8/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 1982200270,
    "latitude": 47.664197,
    "longitude": -122.36136,
    "building_number": 309,
    "street": "N.W. 49th St.",
    "city": "Seattle",
    "zip": 98107,
    "address": "309 N.W. 49th St., Seattle, WA 98107",
    "purchase_date": "5/9/18",
    "purchase_year": 2018,
    "purchase_amount": 825000,
    "assessed_value": 910000,
    "purchase_amount_vs_assessment": -9.340659341,
    "sale_date": "7/9/19",
    "sale_amount": 1475000
  },
  {
    "parcel_id": 4022902550,
    "latitude": 47.773156,
    "longitude": -122.28211,
    "building_number": 19631,
    "street": "44th Place N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "19631 44th Place N.E., Seattle, WA 98155",
    "purchase_date": "5/11/18",
    "purchase_year": 2018,
    "purchase_amount": 570000,
    "assessed_value": 526000,
    "purchase_amount_vs_assessment": 8.365019011,
    "sale_date": "8/20/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 6456200040,
    "latitude": 47.452598,
    "longitude": -122.35556,
    "building_number": 1604,
    "street": "S.W. 168th St.",
    "city": "Seattle",
    "zip": 98166,
    "address": "1604 S.W. 168th St., Seattle, WA 98166",
    "purchase_date": "5/21/18",
    "purchase_year": 2018,
    "purchase_amount": 465000,
    "assessed_value": 408000,
    "purchase_amount_vs_assessment": 13.97058824,
    "sale_date": "6/28/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 6843500030,
    "latitude": 47.740552,
    "longitude": -122.33412,
    "building_number": 2104,
    "street": "N. 154th St.",
    "city": "Seattle",
    "zip": 98133,
    "address": "2104 N. 154th St., Seattle, WA 98133",
    "purchase_date": "5/29/18",
    "purchase_year": 2018,
    "purchase_amount": 550000,
    "assessed_value": 425000,
    "purchase_amount_vs_assessment": 29.41176471,
    "sale_date": "12/5/18",
    "sale_amount": 755000
  },
  {
    "parcel_id": 7893207655,
    "latitude": 47.422526,
    "longitude": -122.32884,
    "building_number": 20021,
    "street": "5th Ave. S.",
    "city": "Seattle",
    "zip": 98198,
    "address": "20021 5th Ave. S., Seattle, WA 98198",
    "purchase_date": "6/1/18",
    "purchase_year": 2018,
    "purchase_amount": 385000,
    "assessed_value": 369000,
    "purchase_amount_vs_assessment": 4.33604336,
    "sale_date": "12/20/18",
    "sale_amount": 455000
  },
  {
    "parcel_id": 4235401110,
    "latitude": 47.658739,
    "longitude": -122.40266,
    "building_number": 3500,
    "street": "W. Government Way",
    "city": "Seattle",
    "zip": 98199,
    "address": "3500 W. Government Way, Seattle, WA 98199",
    "purchase_date": "6/20/18",
    "purchase_year": 2018,
    "purchase_amount": 1850000,
    "assessed_value": 1821000,
    "purchase_amount_vs_assessment": 1.592531576
  },
  {
    "parcel_id": 3763300065,
    "latitude": 47.715437,
    "longitude": -122.23317,
    "building_number": 12804,
    "street": "81st Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "12804 81st Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "6/20/18",
    "purchase_year": 2018,
    "purchase_amount": 600000,
    "assessed_value": 457000,
    "purchase_amount_vs_assessment": 31.29102845
  },
  {
    "parcel_id": 1624049172,
    "latitude": 47.572149,
    "longitude": -122.30319,
    "building_number": 2302,
    "street": "S. Spokane St.",
    "city": "Seattle",
    "zip": 98144,
    "address": "2302 S. Spokane St., Seattle, WA 98144",
    "purchase_date": "6/21/18",
    "purchase_year": 2018,
    "purchase_amount": 470000,
    "assessed_value": 433000,
    "purchase_amount_vs_assessment": 8.545034642,
    "sale_date": "2/27/20",
    "sale_amount": 780000
  },
  {
    "parcel_id": 88000192,
    "latitude": 47.457021,
    "longitude": -122.18852,
    "building_number": 16240,
    "street": "114th Ave. S.E.",
    "city": "Renton",
    "zip": 98055,
    "address": "16240 114th Ave. S.E., Renton, WA 98055",
    "purchase_date": "6/28/18",
    "purchase_year": 2018,
    "purchase_amount": 220000,
    "assessed_value": 264000,
    "purchase_amount_vs_assessment": -16.66666667,
    "sale_date": "8/22/18",
    "sale_amount": 306000
  },
  {
    "parcel_id": 3374300050,
    "latitude": 47.719288,
    "longitude": -122.17347,
    "building_number": 13220,
    "street": "125th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13220 125th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "7/9/18",
    "purchase_year": 2018,
    "purchase_amount": 490000,
    "assessed_value": 354000,
    "purchase_amount_vs_assessment": 38.4180791,
    "sale_date": "8/2/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 9324800285,
    "latitude": 47.730922,
    "longitude": -122.28873,
    "building_number": 14023,
    "street": "37th Ave. N.E.",
    "city": "Seattle",
    "zip": 98125,
    "address": "14023 37th Ave. N.E., Seattle, WA 98125",
    "purchase_date": "7/27/18",
    "purchase_year": 2018,
    "purchase_amount": 420000,
    "assessed_value": 380000,
    "purchase_amount_vs_assessment": 10.52631579,
    "sale_date": "12/27/19",
    "sale_amount": 599900
  },
  {
    "parcel_id": 9829200665,
    "latitude": 47.602924,
    "longitude": -122.28666,
    "building_number": 3708,
    "street": "E. Superior St.",
    "city": "Seattle",
    "zip": 98122,
    "address": "3708 E. Superior St., Seattle, WA 98122",
    "purchase_date": "8/2/18",
    "purchase_year": 2018,
    "purchase_amount": 590000,
    "assessed_value": 575000,
    "purchase_amount_vs_assessment": 2.608695652
  },
  {
    "parcel_id": 724069070,
    "latitude": 47.584722,
    "longitude": -122.08136,
    "building_number": 2805,
    "street": "194th Ave. S.E.",
    "city": "Sammamish",
    "zip": 98075,
    "address": "2805 194th Ave. S.E., Sammamish, WA 98075",
    "purchase_date": "8/3/18",
    "purchase_year": 2018,
    "purchase_amount": 1000000,
    "assessed_value": 1185000,
    "purchase_amount_vs_assessment": -15.61181435,
    "sale_date": "1/8/20",
    "sale_amount": 2000000
  },
  {
    "parcel_id": 724069070,
    "latitude": 47.584722,
    "longitude": -122.08136,
    "building_number": 2805,
    "street": "194th Ave. S.E.",
    "city": "Sammamish",
    "zip": 98075,
    "address": "2805 194th Ave. S.E., Sammamish, WA 98075",
    "purchase_date": "8/3/18",
    "purchase_year": 2018,
    "purchase_amount": 1000000,
    "assessed_value": 1185000,
    "purchase_amount_vs_assessment": -15.61181435,
    "sale_date": "1/8/20",
    "sale_amount": 2000000
  },
  {
    "parcel_id": 3756500350,
    "latitude": 47.716877,
    "longitude": -122.19458,
    "building_number": 13014,
    "street": "110th Ave. N.E.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "13014 110th Ave. N.E., Kirkland, WA 98034",
    "purchase_date": "8/10/18",
    "purchase_year": 2018,
    "purchase_amount": 495000,
    "assessed_value": 374000,
    "purchase_amount_vs_assessment": 32.35294118,
    "sale_date": "5/21/19",
    "sale_amount": 690000
  },
  {
    "parcel_id": 5141000170,
    "latitude": 47.558384,
    "longitude": -122.31633,
    "building_number": 4907,
    "street": "13th Ave. S.",
    "city": "Seattle",
    "zip": 98108,
    "address": "4907 13th Ave. S., Seattle, WA 98108",
    "purchase_date": "8/16/18",
    "purchase_year": 2018,
    "purchase_amount": 352000,
    "assessed_value": 350000,
    "purchase_amount_vs_assessment": 0.5714285714
  },
  {
    "parcel_id": 958000135,
    "latitude": 47.622202,
    "longitude": -122.30329,
    "building_number": 326,
    "street": "22nd Ave. E.",
    "city": "Seattle",
    "zip": 98112,
    "address": "326 22nd Ave. E., Seattle, WA 98112",
    "purchase_date": "9/4/18",
    "purchase_year": 2018,
    "purchase_amount": 750000,
    "assessed_value": 898000,
    "purchase_amount_vs_assessment": -16.48106904,
    "sale_date": "9/17/18",
    "sale_amount": 0
  },
  {
    "parcel_id": 2769601185,
    "latitude": 47.672922,
    "longitude": -122.36539,
    "building_number": 6017,
    "street": "7th Ave. N.W.",
    "city": "Seattle",
    "zip": 98107,
    "address": "6017 7th Ave. N.W., Seattle, WA 98107",
    "purchase_date": "9/28/18",
    "purchase_year": 2018,
    "purchase_amount": 625000,
    "assessed_value": 570000,
    "purchase_amount_vs_assessment": 9.649122807,
    "sale_date": "6/11/19",
    "sale_amount": 1206000
  },
  {
    "parcel_id": 923059183,
    "latitude": 47.5025,
    "longitude": -122.17425,
    "building_number": 3223,
    "street": "N.E. 12th St.",
    "city": "Renton",
    "zip": 98056,
    "address": "3223 N.E. 12th St., Renton, WA 98056",
    "purchase_date": "10/5/18",
    "purchase_year": 2018,
    "purchase_amount": 2273600,
    "assessed_value": 1342000,
    "purchase_amount_vs_assessment": 69.41877794
  },
  {
    "parcel_id": 7107100020,
    "latitude": 47.554991,
    "longitude": -122.29083,
    "building_number": 5209,
    "street": "33rd Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5209 33rd Ave. S., Seattle, WA 98118",
    "purchase_date": "10/26/18",
    "purchase_year": 2018,
    "purchase_amount": 350000,
    "assessed_value": 306000,
    "purchase_amount_vs_assessment": 14.37908497,
    "sale_date": "5/14/19",
    "sale_amount": 585000
  },
  {
    "parcel_id": 7300200460,
    "latitude": 47.576051,
    "longitude": -122.0471,
    "building_number": 21920,
    "street": "S.E. 37th St.",
    "city": "Sammamish",
    "zip": 98075,
    "address": "21920 S.E. 37th St., Sammamish, WA 98075",
    "purchase_date": "11/5/18",
    "purchase_year": 2018,
    "purchase_amount": 675000,
    "assessed_value": 570000,
    "purchase_amount_vs_assessment": 18.42105263,
    "sale_date": "4/14/19",
    "sale_amount": 985000
  },
  {
    "parcel_id": 5114400070,
    "latitude": 47.407902,
    "longitude": -122.00298,
    "building_number": 25325,
    "street": "S.E. 216th St.",
    "city": "Maple Valley",
    "zip": 98038,
    "address": "25325 S.E. 216th St., Maple Valley, WA 98038",
    "purchase_date": "11/28/18",
    "purchase_year": 2018,
    "purchase_amount": 315000,
    "assessed_value": 372000,
    "purchase_amount_vs_assessment": -15.32258065,
    "sale_date": "6/6/19",
    "sale_amount": 615000
  },
  {
    "parcel_id": 3819800470,
    "latitude": 47.726919,
    "longitude": -122.24014,
    "building_number": 7611,
    "street": "N.E. 140th Place",
    "city": "Kirkland",
    "zip": 98034,
    "address": "7611 N.E. 140th Place, Kirkland, WA 98034",
    "purchase_date": "12/7/18",
    "purchase_year": 2018,
    "purchase_amount": 515500,
    "assessed_value": 436000,
    "purchase_amount_vs_assessment": 18.23394495,
    "sale_date": "4/19/19",
    "sale_amount": 729950
  },
  {
    "parcel_id": 6163901233,
    "latitude": 47.757662,
    "longitude": -122.31894,
    "building_number": "",
    "street": "10th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": " 10th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "1/25/19",
    "purchase_year": 2019,
    "purchase_amount": 450000,
    "assessed_value": 552000,
    "purchase_amount_vs_assessment": -18.47826087,
    "sale_date": "4/27/19",
    "sale_amount": 685000
  },
  {
    "parcel_id": 1704900215,
    "latitude": 47.555371,
    "longitude": -122.28047,
    "building_number": 5164,
    "street": "42nd Ave. S.",
    "city": "Seattle",
    "zip": 98118,
    "address": "5164 42nd Ave. S., Seattle, WA 98118",
    "purchase_date": "2/19/19",
    "purchase_year": 2019,
    "purchase_amount": 445000,
    "assessed_value": 519000,
    "purchase_amount_vs_assessment": -14.25818882,
    "sale_date": "7/18/19",
    "sale_amount": 0
  },
  {
    "parcel_id": 8641500261,
    "latitude": 47.695266,
    "longitude": -122.30437,
    "building_number": 9123,
    "street": "23rd Ave. N.E.",
    "city": "Seattle",
    "zip": 98115,
    "address": "9123 23rd Ave. N.E., Seattle, WA 98115",
    "purchase_date": "3/14/19",
    "purchase_year": 2019,
    "purchase_amount": 380000,
    "assessed_value": 400000,
    "purchase_amount_vs_assessment": -5,
    "sale_date": "11/12/19",
    "sale_amount": 440000
  },
  {
    "parcel_id": 4058800945,
    "latitude": 47.504294,
    "longitude": -122.24011,
    "building_number": 11014,
    "street": "Auburn Ave. S.",
    "city": "Seattle",
    "zip": 98178,
    "address": "11014 Auburn Ave. S., Seattle, WA 98178",
    "purchase_date": "3/28/19",
    "purchase_year": 2019,
    "purchase_amount": 470000,
    "assessed_value": 515000,
    "purchase_amount_vs_assessment": -8.737864078,
    "sale_date": "12/19/19",
    "sale_amount": 799000
  },
  {
    "parcel_id": 795000905,
    "latitude": 47.505298,
    "longitude": -122.32908,
    "building_number": 10857,
    "street": "4th Ave. S.",
    "city": "Seattle",
    "zip": 98168,
    "address": "10857 4th Ave. S., Seattle, WA 98168",
    "purchase_date": "4/16/19",
    "purchase_year": 2019,
    "purchase_amount": 300000,
    "assessed_value": 321000,
    "purchase_amount_vs_assessment": -6.542056075,
    "sale_date": "3/3/20",
    "sale_amount": 407000
  },
  {
    "parcel_id": 2787700230,
    "latitude": 47.507056,
    "longitude": -122.16079,
    "building_number": 1700,
    "street": "Anacortes Ave. N.E.",
    "city": "Renton",
    "zip": 98059,
    "address": "1700 Anacortes Ave. N.E., Renton, WA 98059",
    "purchase_date": "4/24/19",
    "purchase_year": 2019,
    "purchase_amount": 440000,
    "assessed_value": 424000,
    "purchase_amount_vs_assessment": 3.773584906,
    "sale_date": "2/19/20",
    "sale_amount": 575000
  },
  {
    "parcel_id": 3749500230,
    "latitude": 47.416253,
    "longitude": -122.19861,
    "building_number": 20712,
    "street": "106th Place S.E.",
    "city": "Kent",
    "zip": 98031,
    "address": "20712 106th Place S.E., Kent, WA 98031",
    "purchase_date": "5/13/19",
    "purchase_year": 2019,
    "purchase_amount": 310000,
    "assessed_value": 350000,
    "purchase_amount_vs_assessment": -11.42857143,
    "sale_date": "11/13/19",
    "sale_amount": 494950
  },
  {
    "parcel_id": 8699100570,
    "latitude": 47.304163,
    "longitude": -122.21913,
    "building_number": 802,
    "street": "4th St. S.E.",
    "city": "Auburn",
    "zip": 98002,
    "address": "802 4th St. S.E., Auburn, WA 98002",
    "purchase_date": "5/18/19",
    "purchase_year": 2019,
    "purchase_amount": 135000,
    "assessed_value": 230000,
    "purchase_amount_vs_assessment": -41.30434783,
    "sale_date": "8/29/19",
    "sale_amount": 304800
  },
  {
    "parcel_id": 7173700050,
    "latitude": 47.667716,
    "longitude": -122.3062,
    "building_number": 5240,
    "street": "20th Ave. N.E.",
    "city": "Seattle",
    "zip": 98105,
    "address": "5240 20th Ave. N.E., Seattle, WA 98105",
    "purchase_date": "5/25/19",
    "purchase_year": 2019,
    "purchase_amount": 900000,
    "assessed_value": 731000,
    "purchase_amount_vs_assessment": 23.11901505
  },
  {
    "parcel_id": 7518506645,
    "latitude": 47.68117,
    "longitude": -122.38463,
    "building_number": 7057,
    "street": "22nd Ave. N.W.",
    "city": "Seattle",
    "zip": 98117,
    "address": "7057 22nd Ave. N.W., Seattle, WA 98117",
    "purchase_date": "6/5/19",
    "purchase_year": 2019,
    "purchase_amount": 732500,
    "assessed_value": 876000,
    "purchase_amount_vs_assessment": -16.38127854,
    "sale_date": "1/29/20",
    "sale_amount": 0
  },
  {
    "parcel_id": 8150600265,
    "latitude": 47.549224,
    "longitude": -122.3741,
    "building_number": 5929,
    "street": "32nd Ave. S.W.",
    "city": "Seattle",
    "zip": 98126,
    "address": "5929 32nd Ave. S.W., Seattle, WA 98126",
    "purchase_date": "6/8/19",
    "purchase_year": 2019,
    "purchase_amount": 300000,
    "assessed_value": 425000,
    "purchase_amount_vs_assessment": -29.41176471,
    "sale_date": "12/5/19",
    "sale_amount": 615000
  },
  {
    "parcel_id": 3807700040,
    "latitude": 47.772557,
    "longitude": -122.37808,
    "building_number": 1603,
    "street": "N.W. 198th St.",
    "city": "Seattle",
    "zip": 98177,
    "address": "1603 N.W. 198th St., Seattle, WA 98177",
    "purchase_date": "6/14/19",
    "purchase_year": 2019,
    "purchase_amount": 500000,
    "assessed_value": 604000,
    "purchase_amount_vs_assessment": -17.21854305,
    "sale_date": "12/11/19",
    "sale_amount": 799950
  },
  {
    "parcel_id": 3322049200,
    "latitude": 47.34504,
    "longitude": -122.29495,
    "building_number": 28605,
    "street": "30th Ave. S.",
    "city": "Federal Way",
    "zip": 98003,
    "address": "28605 30th Ave. S., Federal Way, WA 98003",
    "purchase_date": "7/11/19",
    "purchase_year": 2019,
    "purchase_amount": 190000,
    "assessed_value": 313000,
    "purchase_amount_vs_assessment": -39.2971246,
    "sale_date": "8/20/19",
    "sale_amount": 0
  },
  {
    "parcel_id": 7875400190,
    "latitude": 47.320749,
    "longitude": -122.31968,
    "building_number": 31323,
    "street": "11th Place S.",
    "city": "Federal Way",
    "zip": 98003,
    "address": "31323 11th Place S., Federal Way, WA 98003",
    "purchase_date": "8/13/19",
    "purchase_year": 2019,
    "purchase_amount": 255000,
    "assessed_value": 273000,
    "purchase_amount_vs_assessment": -6.593406593,
    "sale_date": "9/6/19",
    "sale_amount": 0
  },
  {
    "parcel_id": 5244801440,
    "latitude": 47.644468,
    "longitude": -122.35305,
    "building_number": 2641,
    "street": "Mayfair Ave. N.",
    "city": "Seattle",
    "zip": 98109,
    "address": "2641 Mayfair Ave. N., Seattle, WA 98109",
    "purchase_date": "8/29/19",
    "purchase_year": 2019,
    "purchase_amount": 575000,
    "assessed_value": 581900,
    "purchase_amount_vs_assessment": -1.185770751
  },
  {
    "parcel_id": 6824100020,
    "latitude": 47.699837,
    "longitude": -122.36703,
    "building_number": 819,
    "street": "N.W. 97th St.",
    "city": "Seattle",
    "zip": 98117,
    "address": "819 N.W. 97th St., Seattle, WA 98117",
    "purchase_date": "8/30/19",
    "purchase_year": 2019,
    "purchase_amount": 497500,
    "assessed_value": 548000,
    "purchase_amount_vs_assessment": -9.215328467
  },
  {
    "parcel_id": 7283900143,
    "latitude": 47.769689,
    "longitude": -122.35031,
    "building_number": 19338,
    "street": "Fremont Ave. N.",
    "city": "Seattle",
    "zip": 98133,
    "address": "19338 Fremont Ave. N., Seattle, WA 98133",
    "purchase_date": "11/2/19",
    "purchase_year": 2019,
    "purchase_amount": 419000,
    "assessed_value": 541000,
    "purchase_amount_vs_assessment": -22.55083179
  },
  {
    "parcel_id": 2464400126,
    "latitude": 47.686553,
    "longitude": -122.32093,
    "building_number": 545,
    "street": "N.E. 80th St.",
    "city": "Seattle",
    "zip": 98115,
    "address": "545 N.E. 80th St., Seattle, WA 98115",
    "purchase_date": "11/11/19",
    "purchase_year": 2019,
    "purchase_amount": 440000,
    "assessed_value": 596000,
    "purchase_amount_vs_assessment": -26.17449664,
    "sale_date": "12/19/19",
    "sale_amount": 622500
  },
  {
    "parcel_id": 3996300080,
    "latitude": 47.743856,
    "longitude": -122.2983,
    "building_number": 15835,
    "street": "28th Ave. N.E.",
    "city": "Seattle",
    "zip": 98155,
    "address": "15835 28th Ave. N.E., Seattle, WA 98155",
    "purchase_date": "11/26/19",
    "purchase_year": 2019,
    "purchase_amount": 415000,
    "assessed_value": 388000,
    "purchase_amount_vs_assessment": 6.958762887
  },
  {
    "parcel_id": 9412200440,
    "latitude": 47.522936,
    "longitude": -122.04337,
    "building_number": 400,
    "street": "S.W. Forest Place",
    "city": "Issaquah",
    "zip": 98027,
    "address": "400 S.W. Forest Place, Issaquah, WA 98027",
    "purchase_date": "1/15/20",
    "purchase_year": 2020,
    "purchase_amount": 397500,
    "assessed_value": 372000,
    "purchase_amount_vs_assessment": 6.85483871
  },
  {
    "parcel_id": 7234600786,
    "latitude": 47.610574,
    "longitude": -122.31045,
    "building_number": 905,
    "street": "17th Ave.",
    "city": "Seattle",
    "zip": 98122,
    "address": "905 17th Ave., Seattle, WA 98122",
    "purchase_date": "1/30/20",
    "purchase_year": 2020,
    "purchase_amount": 1750000,
    "assessed_value": 1363000,
    "purchase_amount_vs_assessment": 28.39325018
  },
  {
    "parcel_id": 3031200190,
    "latitude": 47.535351,
    "longitude": -122.28951,
    "building_number": 3304,
    "street": "S. Webster St.",
    "city": "Seattle",
    "zip": 98118,
    "address": "3304 S. Webster St., Seattle, WA 98118",
    "purchase_date": "2/14/20",
    "purchase_year": 2020,
    "purchase_amount": 330000,
    "assessed_value": 378000,
    "purchase_amount_vs_assessment": -12.6984127
  },
  {
    "parcel_id": 2297400280,
    "latitude": 47.717671,
    "longitude": -122.22476,
    "building_number": 8720,
    "street": "N.E. 131st St.",
    "city": "Kirkland",
    "zip": 98034,
    "address": "8720 N.E. 131st St., Kirkland, WA 98034",
    "purchase_date": "2/25/20",
    "purchase_year": 2020,
    "purchase_amount": 526000,
    "assessed_value": 657000,
    "purchase_amount_vs_assessment": -19.9391172
  }
]